webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _typeof2 = __webpack_require__(56);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var initState = function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var stateKey, persistLog, persist;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        stateKey = _state2.default.settings.startupOptions.state_key;
	                        persistLog = _Logger2.default.namespace('StatePersistence');
	                        persist = new _StatePersistence2.default(stateKey || '', _state2.default, Storage, persistLog);
	
	                        persist.includeBuffers = !!_state2.default.settings.startupOptions.remember_buffers;
	
	                        if (!stateKey) {
	                            _context.next = 7;
	                            break;
	                        }
	
	                        _context.next = 7;
	                        return persist.loadStateIfExists();
	
	                    case 7:
	
	                        api.setState(_state2.default);
	
	                    case 8:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function initState() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vue = __webpack_require__(28);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _i18next = __webpack_require__(384);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextXhrBackend = __webpack_require__(373);
	
	var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);
	
	var _vueI18next = __webpack_require__(156);
	
	var _vueI18next2 = _interopRequireDefault(_vueI18next);
	
	var _available = __webpack_require__(387);
	
	var _available2 = _interopRequireDefault(_available);
	
	var _enUs = __webpack_require__(388);
	
	var _enUs2 = _interopRequireDefault(_enUs);
	
	var _App = __webpack_require__(440);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _StartupError = __webpack_require__(457);
	
	var _StartupError2 = _interopRequireDefault(_StartupError);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _ConfigLoader = __webpack_require__(162);
	
	var _ConfigLoader2 = _interopRequireDefault(_ConfigLoader);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _ThemeManager = __webpack_require__(55);
	
	var _ThemeManager2 = _interopRequireDefault(_ThemeManager);
	
	var _StatePersistence = __webpack_require__(170);
	
	var _StatePersistence2 = _interopRequireDefault(_StatePersistence);
	
	var _Local = __webpack_require__(173);
	
	var Storage = _interopRequireWildcard(_Local);
	
	var _GlobalApi = __webpack_require__(36);
	
	var _GlobalApi2 = _interopRequireDefault(_GlobalApi);
	
	__webpack_require__(471);
	
	__webpack_require__(469);
	
	__webpack_require__(470);
	
	__webpack_require__(468);
	
	__webpack_require__(175);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logLevelMatch = window.location.href.match(/kiwi-loglevel=(\d)/);
	if (logLevelMatch && logLevelMatch[1]) {
	    _Logger2.default.setLevel(parseInt(logLevelMatch[1], 10));
	}
	
	var log = _Logger2.default.namespace('main');
	
	var api = window.kiwi = _GlobalApi2.default.singleton();
	
	function getQueryVariable(variable) {
	    var query = window.location.search.substring(1);
	    var vars = query.split('&');
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split('=');
	        if (pair[0] === variable) {
	            return pair[1];
	        }
	    }
	
	    return false;
	}
	
	_vue2.default.mixin({
	    methods: {
	        listen: function listen(source, event, fn) {
	            this.listeningEvents = this.listeningEvents || [];
	            this.listeningEvents.push(function () {
	                (source.$off || source.off).call(source, event, fn);
	            });
	            (source.$on || source.on).call(source, event, fn);
	        },
	        listenOnce: function listenOnce(source, event, fn) {
	            this.listeningEvents = this.listeningEvents || [];
	            this.listeningEvents.push(function () {
	                (source.$off || source.off).call(source, event, fn);
	            });
	            (source.$once || source.once).call(source, event, fn);
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        (this.listeningEvents || []).forEach(function (fn) {
	            return fn();
	        });
	    }
	});
	
	_vue2.default.directive('rawElement', {
	    bind: function bind(el, binding) {
	        el.appendChild(binding.value);
	    }
	});
	
	loadApp();
	
	function loadApp() {
	    var configFile = 'static/config.json';
	    var configObj = null;
	
	    if (getQueryVariable('config')) {
	        configFile = 'static/config_' + getQueryVariable('config') + '.json';
	    } else if (typeof window.kiwiConfig === 'function') {
	        try {
	            configObj = window.kiwiConfig();
	        } catch (err) {
	            log.error('Config file: ' + err.stack);
	            showError();
	        }
	    } else if (document.querySelector('meta[name="kiwiconfig"]')) {
	        configFile = document.querySelector('meta[name="kiwiconfig"]').content;
	    } else if (document.querySelector('script[name="kiwiconfig"]')) {
	        var configContents = document.querySelector('script[name="kiwiconfig"]').innerHTML;
	
	        try {
	            configObj = JSON.parse(configContents);
	        } catch (parseErr) {
	            log.error('Config file: ' + parseErr.stack);
	            showError();
	        }
	    }
	
	    var configLoader = new _ConfigLoader2.default();
	    (configObj ? configLoader.loadFromObj(configObj) : configLoader.loadFromUrl(configFile)).then(applyConfig).then(initState).then(initLocales).then(startApp).catch(showError);
	}
	
	function applyConfig(config) {
	    applyConfigObj(config, _state2.default.settings);
	
	    if (_state2.default.settings.windowTitle) {
	        window.document.title = _state2.default.settings.windowTitle;
	    }
	    _state2.default.$watch('settings.windowTitle', function (newVal) {
	        window.document.title = newVal;
	    });
	}
	
	function applyConfigObj(obj, target) {
	    _lodash2.default.each(obj, function (val, key) {
	        if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
	            if ((0, _typeof3.default)(target[key]) !== 'object') {
	                var newVal = _lodash2.default.isArray(val) ? [] : {};
	
	                _vue2.default.set(target, key, newVal);
	            }
	            applyConfigObj(val, target[key]);
	        } else {
	            _vue2.default.set(target, key, val);
	        }
	    });
	}
	
	function initLocales() {
	    _vue2.default.use(_vueI18next2.default);
	
	    api.i18n = _i18next2.default;
	
	    _i18next2.default.use(_i18nextXhrBackend2.default);
	    _i18next2.default.init({
	        whitelist: _available2.default.locales,
	        fallbackLng: 'en-us',
	        lowerCaseLng: true,
	        backend: {
	            loadPath: 'static/locales/{{lng}}.json',
	
	            crossDomain: false,
	
	            withCredentials: false
	        }
	    });
	
	    _i18next2.default.addResourceBundle('en-us', 'translation', _enUs2.default);
	
	    _vue2.default.mixin({
	        computed: {
	            $t: function $t() {
	                var _this = this;
	
	                return function (key, options) {
	                    var val = _this.$i18n.i18next.t(key, options, _this.$i18n.i18nLoadedAt);
	                    if (!val) {
	                        var opts = options || {};
	                        opts.lng = 'en-us';
	                        val = _this.$i18n.i18next.t(key, opts, _this.$i18n.i18nLoadedAt);
	                    }
	                    return val;
	                };
	            }
	        }
	    });
	
	    var defaultLang = _state2.default.setting('language');
	    var preferredLangs = window.navigator && window.navigator.languages || [];
	    var preferredLang = preferredLangs[0];
	
	    if (preferredLang) {
	        _i18next2.default.changeLanguage(preferredLang, function (err, t) {
	            if (err && defaultLang) {
	                _i18next2.default.changeLanguage(defaultLang);
	            }
	        });
	    } else if (defaultLang) {
	        _i18next2.default.changeLanguage(defaultLang);
	    }
	}
	
	function startApp() {
	    var themeMgr = _ThemeManager2.default.instance(_state2.default);
	    api.setThemeManager(themeMgr);
	
	    var argTheme = getQueryVariable('theme');
	    if (argTheme) {
	        themeMgr.setTheme(argTheme);
	    }
	
	    api.emit('init');
	
	    new _vue2.default({
	        el: '#app',
	        render: function render(h) {
	            return h(_App2.default);
	        },
	        i18n: new _vueI18next2.default(_i18next2.default)
	    });
	
	    api.emit('ready');
	}
	
	function showError(err) {
	    if (err) {
	        log.error('Error starting Kiwi IRC:', err);
	    } else {
	        log.error('Unknown error starting Kiwi IRC');
	    }
	
	    new _vue2.default({
	        el: '#app',
	        render: function render(h) {
	            return h(_StartupError2.default);
	        }
	    });
	}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(106);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _vue = __webpack_require__(28);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _strftime = __webpack_require__(71);
	
	var _strftime2 = _interopRequireDefault(_strftime);
	
	var _IrcClient = __webpack_require__(164);
	
	var IrcClient = _interopRequireWildcard(_IrcClient);
	
	var _Message = __webpack_require__(165);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _batchedAdd = __webpack_require__(171);
	
	var _batchedAdd2 = _interopRequireDefault(_batchedAdd);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateObj = {
	    persistence: null,
	
	    settings: {
	        windowTitle: 'Kiwi IRC - The web IRC client',
	        useMonospace: false,
	        messageLayout: 'compact',
	        theme: 'Default',
	        themes: [{ name: 'Default', url: 'static/themes/default' }],
	
	        restricted: true,
	
	        startupScreen: 'customServer',
	
	        kiwiServer: '/webirc/kiwiirc/',
	
	        bnc: {
	            active: false,
	            server: '',
	            port: 6667,
	            tls: false,
	            username: '',
	            password: ''
	        },
	
	        buffers: {
	            alert_on: 'highlight',
	            timestamp_format: '%H:%M:%S',
	            show_timestamps: true,
	            scrollback_size: 250,
	            show_joinparts: true,
	            show_topics: true,
	            show_nick_changes: true,
	            show_mode_changes: true,
	            traffic_as_activity: false,
	            coloured_nicklist: true,
	            colour_nicknames_in_messages: true,
	            block_pms: false,
	            show_emoticons: true,
	            extra_formatting: true,
	            mute_sound: false,
	            default_ban_mask: '*!%i@%h',
	            default_kick_reason: 'Your behavior is not conducive to the desired environment.'
	        },
	
	        startupOptions: {
	            server: '',
	            port: 6667,
	            tls: false,
	            channel: '',
	            nick: 'kiwi_?',
	            direct: false,
	            state_key: 'kiwi-state'
	        },
	        showAutocomplete: true,
	        aliases: '\n# General aliases\n/p /part $1+\n/me /action $destination $1+\n/j /join $1+\n/q /query $1+\n/w /whois $1+\n/raw /quote $1+\n/connect /server $1+\n/cycle $channel? /lines /part $channel | /join $channel\n\n# Op related aliases\n/op /quote mode $channel +o $1+\n/deop /quote mode $channel -o $1+\n/hop /quote mode $channel +h $1+\n/dehop /quote mode $channel -h $1+\n/voice /quote mode $channel +v $1+\n/devoice /quote mode $channel -v $1+\n/k /kick $channel $1+\n/ban /quote mode $channel +b $1+\n/unban /quote mode $channel -b $1+\n\n# Misc aliases\n/slap /me slaps $1 around a bit with a large trout\n/tick /msg $channel \u2714',
	        embedly: {
	            Key: ''
	        },
	
	        emojis: {
	            '-___-': '1f611',
	            ':\'-)': '1f602',
	            '\':-)': '1f605',
	            '\':-D': '1f605',
	            '>:-)': '1f606',
	            '\':-(': '1f613',
	            '>:-(': '1f620',
	            ':\'-(': '1f622',
	            'O:-)': '1f607',
	            '0:-3': '1f607',
	            '0:-)': '1f607',
	            '0;^)': '1f607',
	            'O;-)': '1f607',
	            '0;-)': '1f607',
	            'O:-3': '1f607',
	            '-__-': '1f611',
	            ':-Þ': '1f61b',
	            '<3': '2764',
	            '</3': '1f494',
	            ':\')': '1f602',
	            ':-D': '1f603',
	            '\':)': '1f605',
	            '\'=)': '1f605',
	            '\':D': '1f605',
	            '\'=D': '1f605',
	            '>:)': '1f606',
	            '>;)': '1f606',
	            '>=)': '1f606',
	            'XD': '1f606',
	            ';-)': '1f609',
	            '*-)': '1f609',
	            ';-]': '1f609',
	            ';^)': '1f609',
	            '\':(': '1f613',
	            '\'=(': '1f613',
	            ':-*': '1f618',
	            ':^*': '1f618',
	            '>:P': '1f61c',
	            'X-P': '1f61c',
	            '>:[': '1f61e',
	            ':-(': '1f61e',
	            ':-[': '1f61e',
	            '>:(': '1f620',
	            ':\'(': '1f622',
	            ';-(': '1f622',
	            '>.<': '1f623',
	            '#-)': '1f635',
	            '%-)': '1f635',
	            'X-)': '1f635',
	            '\\0/': '1f646',
	            '\\O/': '1f646',
	            '0:3': '1f607',
	            '0:)': '1f607',
	            'O:)': '1f607',
	            'O=)': '1f607',
	            'O:3': '1f607',
	            'B-)': '1f60e',
	            '8-)': '1f60e',
	            'B-D': '1f60e',
	            '8-D': '1f60e',
	            '-_-': '1f611',
	            '>:\\': '1f615',
	            '>:/': '1f615',
	            ':-/': '1f615',
	            ':-.': '1f615',
	            ':-P': '1f61b',
	            ':Þ': '1f61b',
	            ':-b': '1f61b',
	            ':-O': '1f62e',
	            'O_O': '1f62e',
	            '>:O': '1f62e',
	            ':-X': '1f636',
	            ':-#': '1f636',
	            ':-)': '1f642',
	            '(y)': '1f44d',
	            ':D': '1f603',
	            '=D': '1f603',
	            ';)': '1f609',
	            '*)': '1f609',
	            ';]': '1f609',
	            ';D': '1f609',
	            ':*': '1f618',
	            '=*': '1f618',
	            ':(': '1f61e',
	            ':[': '1f61e',
	            '=(': '1f61e',
	            ':@': '1f620',
	            ';(': '1f622',
	            'D:': '1f628',
	            ':$': '1f633',
	            '=$': '1f633',
	            '#)': '1f635',
	            '%)': '1f635',
	            'X)': '1f635',
	            'B)': '1f60e',
	            '8)': '1f60e',
	            ':/': '1f615',
	            ':\\': '1f615',
	            '=/': '1f615',
	            '=\\': '1f615',
	            ':L': '1f615',
	            '=L': '1f615',
	            ':P': '1f61b',
	            ':p': '1f61b',
	            '=P': '1f61b',
	            ':b': '1f61b',
	            ':O': '1f62e',
	            ':X': '1f636',
	            ':#': '1f636',
	            '=X': '1f636',
	            '=#': '1f636',
	            ':)': '1f642',
	            '=]': '1f642',
	            '=)': '1f642',
	            ':]': '1f642'
	        },
	        emojiLocation: 'https://kiwiirc.com/shared/emoji/'
	    },
	    user_settings: {},
	    connection: {
	        status: 'connected',
	        sessionId: ''
	    },
	    ui: {
	        active_network: 0,
	        active_buffer: '',
	        app_has_focus: true,
	        is_touch: false
	    },
	    networks: []
	};
	
	var messages = [];
	
	var availableStartups = (0, _create2.default)(null);
	
	var state = new _vue2.default({
	    data: stateObj,
	    methods: {
	        exportState: function exportState(includeBuffers) {
	            var toExport = {};
	
	            if (includeBuffers) {
	                toExport.networks = state.networks.map(function (network) {
	                    var networkObj = {
	                        id: network.id,
	                        name: network.name,
	                        connection: {
	                            server: network.connection.server,
	                            port: network.connection.port,
	                            tls: network.connection.tls,
	                            path: network.connection.path,
	                            password: network.connection.password,
	                            direct: network.connection.direct,
	                            encoding: network.connection.encoding
	                        },
	                        auto_commands: network.auto_commands,
	                        settings: _lodash2.default.cloneDeep(network.settings),
	                        nick: network.nick,
	                        username: network.username,
	                        gecos: network.gecos,
	                        password: network.password,
	                        buffers: []
	                    };
	
	                    networkObj.buffers = network.buffers.map(function (buffer) {
	                        var bufferObj = {
	                            name: buffer.name,
	                            key: buffer.key,
	                            enabled: !!buffer.enabled,
	                            settings: _lodash2.default.cloneDeep(buffer.settings)
	                        };
	
	                        return bufferObj;
	                    });
	
	                    return networkObj;
	                });
	            }
	
	            toExport.user_settings = state.user_settings;
	
	            return (0, _stringify2.default)(toExport);
	        },
	
	        importState: function importState(stateStr) {
	            var _this = this;
	
	            var importObj = JSON.parse(stateStr);
	            if (importObj && importObj.networks) {
	                this.resetState();
	                importObj.networks.forEach(function (importNetwork) {
	                    var network = createEmptyNetworkObject();
	                    network.id = importNetwork.id;
	                    network.name = importNetwork.name;
	                    network.connection = importNetwork.connection;
	                    network.auto_commands = importNetwork.auto_commands || '';
	                    network.settings = importNetwork.settings;
	                    network.nick = importNetwork.nick;
	                    network.username = importNetwork.username;
	                    network.gecos = importNetwork.gecos;
	                    network.password = importNetwork.password;
	
	                    _this.networks.push(network);
	                    initialiseNetworkState(network);
	
	                    importNetwork.buffers.forEach(function (importBuffer) {
	                        var buffer = createEmptyBufferObject();
	                        buffer.name = importBuffer.name;
	                        buffer.key = importBuffer.key;
	                        buffer.networkid = network.id;
	                        buffer.enabled = !!importBuffer.enabled;
	                        buffer.settings = importBuffer.settings;
	
	                        network.buffers.push(buffer);
	                        initialiseBufferState(buffer);
	                    });
	                });
	            }
	
	            if (importObj && importObj.user_settings) {
	                this.user_settings = importObj.user_settings;
	            }
	        },
	
	        resetState: function resetState() {
	            this.$set(this.$data, 'networks', []);
	            messages.splice(0);
	        },
	
	        setting: function setting(name, val) {
	            if (typeof val !== 'undefined') {
	                return this.setSetting('user_settings.' + name, val);
	            }
	
	            var userSetting = this.getSetting('user_settings.' + name);
	            var result = typeof userSetting !== 'undefined' ? userSetting : this.getSetting('settings.' + name);
	
	            return result;
	        },
	
	        getSetting: function getSetting(name) {
	            var parts = name.split('.');
	            var val = this.$data;
	
	            for (var i = 0; i < parts.length; i++) {
	                val = val[parts[i]];
	                if (typeof val === 'undefined') {
	                    break;
	                }
	            }
	
	            return val;
	        },
	
	        setSetting: function setSetting(name, newVal) {
	            var parts = name.split('.');
	            var val = this.$data;
	
	            for (var i = 0; i < parts.length; i++) {
	                var propName = parts[i];
	                var nextVal = val[propName];
	
	                if (i < parts.length - 1 && typeof nextVal === 'undefined') {
	                    nextVal = this.$set(val, propName, {});
	                } else if (i === parts.length - 1) {
	                    this.$set(val, propName, newVal);
	                }
	
	                val = nextVal;
	            }
	
	            return val;
	        },
	
	        getActiveNetwork: function getActiveNetwork() {
	            return this.getNetwork(this.ui.active_network);
	        },
	
	        getNetwork: function getNetwork(networkid) {
	            var network = _lodash2.default.find(this.networks, {
	                id: networkid
	            });
	
	            return network;
	        },
	
	        addNetwork: function addNetwork(name, nick, serverInfo) {
	            function networkidReduce(currentMax, network) {
	                return network.id > currentMax ? network.id : currentMax;
	            }
	            var networkid = serverInfo.channelId ? parseInt(serverInfo.channelId, 10) : _lodash2.default.reduce(this.networks, networkidReduce, 0) + 1;
	
	            var network = createEmptyNetworkObject();
	            network.id = networkid;
	            network.name = name;
	            network.nick = nick;
	            network.username = serverInfo.username;
	            network.gecos = serverInfo.gecos;
	            network.password = serverInfo.password;
	            network.connection.server = serverInfo.server || '';
	            network.connection.port = serverInfo.port || 6667;
	            network.connection.tls = serverInfo.tls || false;
	            network.connection.path = serverInfo.path || '';
	            network.connection.password = serverInfo.password || '';
	            network.connection.direct = !!serverInfo.direct;
	            network.connection.encoding = serverInfo.encoding || 'utf8';
	            network.connection.bncname = serverInfo.bncname || '';
	
	            if (serverInfo.services) {
	                network.services = serverInfo.services;
	            }
	
	            this.networks.push(network);
	            initialiseNetworkState(network);
	
	            this.addBuffer(network.id, '*').joined = true;
	
	            var eventObj = { network: network };
	            state.$emit('network.new', eventObj);
	
	            return network;
	        },
	
	        removeNetwork: function removeNetwork(networkid) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return;
	            }
	
	            if (network.state === 'connected') {
	                network.ircClient.quit();
	            }
	
	            if (network === this.getActiveNetwork()) {
	                this.setActiveBuffer(null);
	            }
	
	            var idx = this.networks.indexOf(network);
	            this.networks.splice(idx, 1);
	
	            var eventObj = { network: network };
	            state.$emit('network.removed', eventObj);
	        },
	
	        getActiveBuffer: function getActiveBuffer() {
	            return this.getBufferByName(this.ui.active_network, this.ui.active_buffer);
	        },
	
	        setActiveBuffer: function setActiveBuffer(networkid, bufferName) {
	            if (!networkid) {
	                this.ui.active_network = 0;
	                this.ui.active_buffer = '';
	            } else {
	                this.ui.active_network = networkid;
	                this.ui.active_buffer = bufferName;
	
	                var buffer = this.getBufferByName(networkid, bufferName);
	                if (buffer && buffer.flags.unread) {
	                    buffer.flags.unread = 0;
	                }
	
	                buffer.markAsRead(true);
	            }
	        },
	
	        updateBufferLastRead: function updateBufferLastRead(networkid, bufferName) {
	            var buffer = this.getBufferByName(networkid, bufferName);
	            if (buffer) {
	                buffer.last_read = Date.now();
	                buffer.active_timeout = null;
	            }
	        },
	
	        getOrAddBufferByName: function getOrAddBufferByName(networkid, bufferName) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return null;
	            }
	
	            var toMatch = bufferName.toLowerCase();
	            var buffer = _lodash2.default.find(network.buffers, function (b) {
	                return b.name.toLowerCase() === toMatch;
	            });
	
	            if (!buffer) {
	                buffer = this.addBuffer(networkid, bufferName);
	            }
	
	            return buffer;
	        },
	
	        getBufferByName: function getBufferByName(networkid, bufferName) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return null;
	            }
	
	            var toMatch = bufferName.toLowerCase();
	            var buffer = _lodash2.default.find(network.buffers, function (b) {
	                return b.name.toLowerCase() === toMatch;
	            });
	
	            return buffer;
	        },
	
	        addBuffer: function addBuffer(networkid, bufferName) {
	            var buffer = this.getBufferByName(networkid, bufferName);
	            if (buffer) {
	                return buffer;
	            }
	
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return false;
	            }
	
	            buffer = createEmptyBufferObject();
	            buffer.networkid = network.id;
	            buffer.name = bufferName;
	            network.buffers.push(buffer);
	
	            initialiseBufferState(buffer);
	
	            var eventObj = { buffer: buffer };
	            state.$emit('buffer.new', eventObj);
	
	            return buffer;
	        },
	
	        removeBuffer: function removeBuffer(buffer) {
	            var isActiveBuffer = this.getActiveBuffer() === buffer;
	
	            var network = this.getNetwork(buffer.networkid);
	            if (!network) {
	                return;
	            }
	
	            var eventObj = { buffer: buffer };
	            state.$emit('buffer.close', eventObj);
	
	            var bufferIdx = network.buffers.indexOf(buffer);
	            if (bufferIdx > -1) {
	                network.buffers.splice(bufferIdx, 1);
	            }
	
	            var messageIdx = _lodash2.default.findIndex(messages, {
	                networkid: network.id,
	                buffer: buffer.name
	            });
	            if (messageIdx > -1) {
	                messages.splice(messageIdx, 1);
	            }
	
	            if (buffer.isChannel() && buffer.joined) {
	                network.ircClient.part(buffer.name);
	            }
	
	            if (isActiveBuffer) {
	                this.setActiveBuffer(network.id, network.serverBuffer().name);
	            }
	
	            for (var nick in buffer.users) {
	                var user = buffer.users[nick];
	                delete user.buffers[buffer.id];
	            }
	        },
	
	        addMessage: function addMessage(buffer, message) {
	            var user = this.getUser(buffer.networkid, message.nick);
	            var bufferMessage = new _Message2.default(message, user);
	            if (user && user.ignore) {
	                bufferMessage.ignore = true;
	            }
	
	            buffer.addMessage(bufferMessage);
	
	            var includeAsActivity = false;
	            var typesForActivty = ['privmsg', 'action', 'notice'];
	            if (buffer.setting('traffic_as_activity') && message.type === 'traffic') {
	                typesForActivty.push('traffic');
	            }
	
	            if (typesForActivty.indexOf(message.type) > -1) {
	                includeAsActivity = true;
	            }
	
	            var isActiveBuffer = buffer.networkid === this.ui.active_network && buffer.name === this.ui.active_buffer;
	
	            var network = buffer.getNetwork();
	            var isNewMessage = message.time >= buffer.last_read;
	            var isHighlight = Misc.mentionsNick(bufferMessage.message, network.ircClient.user.nick);
	
	            if (isNewMessage && isActiveBuffer && state.ui.app_has_focus) {
	                buffer.last_read = message.time;
	            }
	
	            if (isNewMessage && includeAsActivity && !isActiveBuffer) {
	                buffer.incrementFlag('unread');
	                if (isHighlight) {
	                    buffer.flag('highlight', true);
	                }
	            }
	
	            var settingAlertOn = buffer.setting('alert_on');
	            var isOurJoin = message.type === 'traffic' && message.nick === network.nick;
	            if (isNewMessage && settingAlertOn !== 'never' && !isOurJoin) {
	                var notifyTitle = '';
	                var notifyMessage = message.nick ? message.nick + ': ' : '';
	                notifyMessage += message.message;
	
	                if (isHighlight) {
	                    notifyTitle = 'You were mentioned in ' + buffer.name;
	                } else if (settingAlertOn === 'message' && !isHighlight) {
	                    notifyTitle = buffer.name;
	                }
	
	                if (notifyTitle) {
	                    this.$emit('notification.show', notifyMessage, {
	                        title: notifyTitle,
	                        onclick: function onclick() {
	                            state.setActiveBuffer(buffer.networkid, buffer.name);
	
	                            if (parent && parent.focus) {
	                                parent.focus();
	                            }
	                            if (window.focus) {
	                                window.focus();
	                            }
	                        }
	                    });
	                }
	            }
	
	            this.$emit('message.new', bufferMessage, buffer);
	        },
	
	        getMessages: function getMessages(buffer) {
	            var bufMessages = _lodash2.default.find(messages, {
	                networkid: buffer.networkid,
	                buffer: buffer.name
	            });
	
	            return bufMessages ? bufMessages.messages : [];
	        },
	
	        getUser: function getUser(networkid, nick, usersArr_) {
	            var user = null;
	            var users = usersArr_;
	
	            if (!users) {
	                var network = this.getNetwork(networkid);
	                if (network) {
	                    users = network.users;
	                }
	            }
	
	            if (users) {
	                user = users[nick.toLowerCase()];
	            }
	
	            return user;
	        },
	
	        usersTransaction: function usersTransaction(networkid, fn) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return;
	            }
	
	            var users = _lodash2.default.clone(network.users);
	            fn(users);
	            this.$set(network, 'users', users);
	        },
	
	        addUser: function addUser(networkid, user, usersArr_) {
	            var network = null;
	
	            if (typeof networkid === 'number') {
	                network = this.getNetwork(networkid);
	            } else {
	                network = networkid;
	            }
	
	            if (!network) {
	                return null;
	            }
	
	            var usersArr = usersArr_ || network.users;
	            var userObj = null;
	
	            if (!usersArr[user.nick.toLowerCase()]) {
	                userObj = usersArr[user.nick.toLowerCase()] = {
	                    nick: user.nick,
	                    host: user.host || '',
	                    username: user.username || '',
	                    realname: user.realname || '',
	                    modes: user.modes || '',
	                    away: user.away || '',
	                    buffers: (0, _create2.default)(null)
	                };
	            } else {
	                userObj = state.getUser(network.id, user.nick, usersArr);
	                _lodash2.default.each(user, function (val, prop) {
	                    if (typeof val !== 'undefined') {
	                        userObj[prop] = val;
	                    }
	                });
	            }
	
	            return userObj;
	        },
	
	        removeUser: function removeUser(networkid, user) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return;
	            }
	
	            var buffers = state.getBuffersWithUser(networkid, user.nick);
	            buffers.forEach(function (buffer) {
	                state.removeUserFromBuffer(buffer, user.nick);
	            });
	
	            this.$delete(network.users, user.nick.toLowerCase());
	        },
	
	        addMultipleUsersToBuffer: function addMultipleUsersToBuffer(buffer, newUsers) {
	            var _this2 = this;
	
	            var network = this.getNetwork(buffer.networkid);
	            var bufUsers = _lodash2.default.clone(buffer.users);
	
	            state.usersTransaction(network.id, function (users) {
	                newUsers.forEach(function (newUser) {
	                    var user = newUser.user;
	                    var modes = newUser.modes;
	                    var userObj = state.getUser(network.id, user.nick, users);
	
	                    if (!userObj) {
	                        userObj = _this2.addUser(network, user, users);
	                    }
	                    bufUsers[userObj.nick.toLowerCase()] = userObj;
	
	                    if (!userObj.buffers[buffer.id]) {
	                        userObj.buffers[buffer.id] = {
	                            modes: modes || [],
	                            buffer: buffer
	                        };
	                    } else {
	                        userObj.buffers[buffer.id].modes = modes || [];
	                    }
	                });
	            });
	
	            buffer.users = bufUsers;
	        },
	
	        addUserToBuffer: function addUserToBuffer(buffer, user, modes) {
	            var network = this.getNetwork(buffer.networkid);
	            var userObj = state.getUser(network.id, user.nick);
	
	            if (!userObj) {
	                userObj = this.addUser(network, user);
	            }
	
	            buffer.addUser(userObj);
	
	            if (!userObj.buffers[buffer.id]) {
	                state.$set(userObj.buffers, buffer.id, {
	                    modes: modes || [],
	                    buffer: buffer
	                });
	            } else {
	                state.$set(userObj.buffers[buffer.id], 'modes', modes || []);
	            }
	        },
	
	        removeUserFromBuffer: function removeUserFromBuffer(buffer, nick) {
	            buffer.removeUser(nick);
	        },
	
	        getBuffersWithUser: function getBuffersWithUser(networkid, nick) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return [];
	            }
	
	            var normalisedNick = nick.toLowerCase();
	            var buffers = [];
	            network.buffers.forEach(function (buffer) {
	                if (buffer.users[normalisedNick]) {
	                    buffers.push(buffer);
	                }
	            });
	
	            return buffers;
	        },
	
	        changeUserNick: function changeUserNick(networkid, oldNick, newNick) {
	            var network = this.getNetwork(networkid);
	            if (!network) {
	                return;
	            }
	
	            var user = state.getUser(network.id, oldNick);
	            if (!user) {
	                return;
	            }
	
	            var normalisedNew = newNick.toLowerCase();
	            var normalisedOld = oldNick.toLowerCase();
	
	            user.nick = newNick;
	            state.$set(network.users, normalisedNew, network.users[normalisedOld]);
	            state.$delete(network.users, normalisedOld);
	
	            for (var bufferId in user.buffers) {
	                var buffer = user.buffers[bufferId].buffer;
	                state.$set(buffer.users, normalisedNew, buffer.users[normalisedOld]);
	                state.$delete(buffer.users, normalisedOld);
	            }
	        },
	
	        getStartups: function getStartups() {
	            return availableStartups;
	        }
	    }
	});
	
	exports.default = state;
	
	
	function createEmptyNetworkObject() {
	    return {
	        id: 0,
	        name: '',
	        state: 'disconnected',
	        state_error: '',
	        auto_commands: '',
	        is_znc: false,
	        channel_list: [],
	        channel_list_state: '',
	        connection: {
	            server: '',
	            port: 6667,
	            tls: false,
	            path: '',
	            password: '',
	            direct: false,
	            encoding: 'utf8',
	            bncname: ''
	        },
	        settings: {},
	        nick: '',
	        username: '',
	        gecos: '',
	        password: '',
	        buffers: [],
	        users: (0, _create2.default)(null)
	    };
	}
	
	var nextBufferId = 0;
	function createEmptyBufferObject() {
	    return {
	        id: nextBufferId++,
	        networkid: 0,
	        name: '',
	        topic: '',
	        key: '',
	        joined: false,
	        enabled: true,
	        users: (0, _create2.default)(null),
	        modes: (0, _create2.default)(null),
	        flags: {
	            unread: 0,
	            alert_on: 'default',
	            has_opened: false,
	            chathistory_available: true
	        },
	        settings: {},
	        last_read: Date.now(),
	        active_timeout: null,
	        message_count: 0
	    };
	}
	
	function initialiseNetworkState(network) {
	    Object.defineProperty(network, 'ircClient', {
	        value: IrcClient.create(state, network.id)
	    });
	    Object.defineProperty(network, 'bufferByName', {
	        value: _lodash2.default.partial(state.getBufferByName, network.id)
	    });
	    Object.defineProperty(network, 'serverBuffer', {
	        value: _lodash2.default.partial(state.getBufferByName, network.id, '*')
	    });
	    Object.defineProperty(network, 'setting', {
	        value: function setting(name, val) {
	            if (typeof val !== 'undefined') {
	                state.$set(network.settings, name, val);
	                return val;
	            }
	
	            return network.settings[name];
	        }
	    });
	    Object.defineProperty(network, 'isChannelName', {
	        value: function isChannelName(input) {
	            if (typeof input !== 'string' || !input) {
	                return false;
	            }
	
	            var chanPrefixes = this.ircClient.network.supports('CHANTYPES') || '#&';
	            return chanPrefixes.indexOf(input[0]) > -1;
	        }
	    });
	
	    network.state = 'disconnected';
	}
	
	function initialiseBufferState(buffer) {
	    Object.defineProperty(buffer, 'getNetwork', {
	        value: function getNetwork() {
	            return state.getNetwork(buffer.networkid);
	        }
	    });
	    Object.defineProperty(buffer, 'getMessages', {
	        value: function getNetwork() {
	            return state.getMessages(buffer);
	        }
	    });
	    Object.defineProperty(buffer, 'isServer', {
	        value: function isServer() {
	            return buffer.name === '*';
	        }
	    });
	    Object.defineProperty(buffer, 'isChannel', {
	        value: function isChannel() {
	            var chanPrefixes = ['#', '&'];
	            var ircNetwork = buffer.getNetwork().ircClient.network;
	            if (ircNetwork && ircNetwork.options.CHANTYPES) {
	                chanPrefixes = ircNetwork.options.CHANTYPES;
	            }
	
	            return chanPrefixes.indexOf(buffer.name[0]) > -1;
	        }
	    });
	    Object.defineProperty(buffer, 'isQuery', {
	        value: function isQuery() {
	            var chanPrefixes = ['#', '&'];
	            var ircNetwork = buffer.getNetwork().ircClient.network;
	            if (ircNetwork && ircNetwork.options.CHANTYPES) {
	                chanPrefixes = ircNetwork.options.CHANTYPES;
	            }
	
	            return chanPrefixes.indexOf(buffer.name[0]) === -1 && !this.isSpecial();
	        }
	    });
	    Object.defineProperty(buffer, 'isSpecial', {
	        value: function isSpecial() {
	            var name = buffer.name;
	            return name[0] === '*' && name.length > 1;
	        }
	    });
	    Object.defineProperty(buffer, 'isUserAnOp', {
	        value: function isUserAnOp(nick) {
	            var user = state.getUser(buffer.networkid, buffer.getNetwork().nick);
	            if (!user) {
	                return false;
	            }
	
	            var userBufferInfo = user.buffers[buffer.id];
	            if (!userBufferInfo) {
	                return false;
	            }
	
	            var modes = userBufferInfo.modes;
	            var opModes = ['Y', 'y', 'q', 'a', 'o', 'h'];
	            var hasOp = _lodash2.default.find(modes, function (mode) {
	                return opModes.indexOf(mode.toLowerCase()) > -1;
	            });
	
	            return !!hasOp;
	        }
	    });
	
	    Object.defineProperty(buffer, 'setting', {
	        value: function setting(name, val) {
	            if (typeof val !== 'undefined') {
	                state.$set(buffer.settings, name, val);
	                return val;
	            }
	
	            var result = typeof buffer.settings[name] !== 'undefined' ? buffer.settings[name] : state.setting('buffers.' + name);
	
	            return result;
	        }
	    });
	    Object.defineProperty(buffer, 'flag', {
	        value: function flag(name, val) {
	            if (typeof val !== 'undefined') {
	                state.$set(buffer.flags, name, val);
	                return val;
	            }
	
	            return buffer.flags[name];
	        }
	    });
	    Object.defineProperty(buffer, 'requestScrollback', {
	        value: function requestScrollback(_direction) {
	            var _this3 = this;
	
	            var direction = _direction || 'backward';
	            var time = '';
	
	            var numMessages = -50;
	
	            if (direction === 'backward') {
	                var lastMessage = this.getMessages().reduce(function (earliest, current) {
	                    var validType = earliest.type !== 'traffic';
	                    if (validType && earliest.time && earliest.time < current.time) {
	                        return earliest;
	                    }
	                    return current;
	                }, this.getMessages()[0]);
	
	                numMessages = -50;
	                time = lastMessage ? new Date(lastMessage.time) : new Date();
	            } else if (direction === 'forward') {
	                var firstMessage = this.getMessages().reduce(function (latest, current) {
	                    var validType = latest.type !== 'traffic';
	                    if (validType && latest.time && latest.time > current.time) {
	                        return latest;
	                    }
	                    return current;
	                }, this.getMessages()[0]);
	
	                numMessages = 50;
	                time = firstMessage ? new Date(firstMessage.time) : new Date();
	            } else {
	                throw new Error('Invalid direction for requestScrollback(): ' + _direction);
	            }
	
	            var irc = this.getNetwork().ircClient;
	            var timeStr = (0, _strftime2.default)('%FT%T.%L%:z', time);
	            irc.raw('CHATHISTORY ' + this.name + ' timestamp=' + timeStr + ' message_count=' + numMessages);
	            irc.once('batch end chathistory', function (event) {
	                if (event.commands.length === 0) {
	                    _this3.flags.chathistory_available = false;
	                } else {
	                    _this3.flags.chathistory_available = true;
	                }
	            });
	        }
	    });
	    Object.defineProperty(buffer, 'markAsRead', {
	        value: function markAsRead(delayed) {
	            if (buffer.active_timeout) {
	                clearTimeout(buffer.active_timeout);
	                buffer.active_timeout = null;
	            }
	            if (delayed) {
	                buffer.active_timeout = setTimeout(buffer.markAsRead, 10000, false);
	            } else {
	                buffer.last_read = Date.now();
	                buffer.flag('highlight', false);
	
	                var network = buffer.getNetwork();
	                var allowedUpdate = buffer.isChannel() || buffer.isQuery();
	                if (allowedUpdate && network.connection.bncname) {
	                    var lastMessage = buffer.getMessages().reduce(function (latest, current) {
	                        if (latest.time && latest.time > current.time) {
	                            return latest;
	                        }
	                        return current;
	                    }, buffer.getMessages()[0]);
	
	                    if (!lastMessage) {
	                        return;
	                    }
	
	                    network.ircClient.bnc.bufferSeen(network.connection.bncname, buffer.name, new Date(lastMessage.time));
	                }
	            }
	        }
	    });
	
	    Object.defineProperty(buffer, 'incrementFlag', {
	        value: function incrementFlagFn() {
	            var batches = (0, _create2.default)(null);
	            var processBatches = _lodash2.default.debounce(function () {
	                _lodash2.default.each(batches, function (incrBy, flagName) {
	                    buffer.flags[flagName] = (buffer.flags[flagName] || 0) + incrBy;
	                    batches[flagName] = 0;
	                });
	            }, 500);
	            return function incrementFlag(flagName) {
	                batches[flagName] = batches[flagName] || 0;
	                batches[flagName]++;
	                processBatches();
	            };
	        }()
	    });
	
	    function addSingleUser(user) {
	        state.$set(buffer.users, user.nick.toLowerCase(), user);
	    }
	    function addMultipleUsers(users) {
	        var o = _lodash2.default.clone(buffer.users);
	        users.forEach(function (user) {
	            o[user.nick.toLowerCase()] = user;
	        });
	        buffer.users = o;
	    }
	    Object.defineProperty(buffer, 'addUser', {
	        value: (0, _batchedAdd2.default)(addSingleUser, addMultipleUsers)
	    });
	    Object.defineProperty(buffer, 'removeUser', {
	        value: function removeUser(nick) {
	            var userObj = state.getUser(buffer.networkid, nick);
	
	            _lodash2.default.pull(buffer.addUser.queue(), userObj);
	
	            state.$delete(buffer.users, nick.toLowerCase());
	
	            if (userObj) {
	                delete userObj.buffers[buffer.id];
	            }
	        }
	    });
	    Object.defineProperty(buffer, 'clearUsers', {
	        value: function clearUsers() {
	            buffer.addUser.queue().splice(0);
	
	            _lodash2.default.each(buffer.users, function (userObj, nick) {
	                delete userObj.buffers[buffer.id];
	            });
	
	            state.$set(buffer, 'users', {});
	        }
	    });
	
	    function addSingleMessage(newMessage) {
	        messageObj.messages.push(newMessage);
	        trimMessages();
	        buffer.message_count++;
	    }
	    function addMultipleMessages(newMessages) {
	        messageObj.messages = messageObj.messages.concat(newMessages);
	        trimMessages();
	        buffer.message_count++;
	    }
	    Object.defineProperty(buffer, 'addMessage', {
	        value: (0, _batchedAdd2.default)(addSingleMessage, addMultipleMessages)
	    });
	
	    function trimMessages() {
	        var scrollbackSize = buffer.setting('scrollback_size');
	        var length = messageObj.messages.length;
	
	        if (messageObj.messages.length > scrollbackSize) {
	            messageObj.messages.splice(0, length - scrollbackSize);
	        }
	    }
	
	    var messageObj = {
	        networkid: buffer.networkid,
	        buffer: buffer.name,
	        messages: []
	    };
	    messages.push(messageObj);
	}

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.extractBuffers = extractBuffers;
	exports.mentionsNick = mentionsNick;
	exports.queryStringVal = queryStringVal;
	exports.networkErrorMessage = networkErrorMessage;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extractBuffers(str) {
	    var spaceIdx = str.indexOf(' ');
	    if (spaceIdx === -1) spaceIdx = str.length;
	
	    var bufferNames = str.substr(0, spaceIdx).split(',');
	    var keys = str.substr(spaceIdx + 1).split(',');
	
	    var buffers = [];
	    bufferNames.forEach(function (bufferName, idx) {
	        buffers.push({
	            name: bufferName,
	            key: keys[idx] || ''
	        });
	    });
	
	    return buffers;
	}
	
	function mentionsNick(input, nick) {
	    var punc = ',.!:;-+)]?¿\\/<>@';
	
	    var idx = input.toLowerCase().indexOf(nick.toLowerCase());
	    if (idx === -1) {
	        return false;
	    }
	
	    var startIdx = input.lastIndexOf(' ', idx);
	    if (startIdx === -1) {
	        startIdx = 0;
	    } else {
	        startIdx++;
	    }
	
	    var endIdx = input.indexOf(' ', idx);
	    if (endIdx === -1) {
	        endIdx = input.length;
	    }
	
	    var segment = input.substring(startIdx, endIdx);
	    var potentialNick = _lodash2.default.trim(segment, punc);
	
	    return potentialNick.toLowerCase() === nick.toLowerCase();
	}
	
	function queryStringVal(_name, _url) {
	    var url = _url || window.location.href;
	    var name = _lodash2.default.escapeRegExp(_name);
	    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	    var results = regex.exec(url);
	
	    if (!results) {
	        return null;
	    }
	    if (!results[2]) {
	        return '';
	    }
	
	    return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
	
	function networkErrorMessage(err) {
	    var errs = {
	        err_unknown_host: 'Unknown domain name or host',
	        err_forbidden: 'Forbidden to connect',
	        err_timeout: 'Took too long to connect',
	        err_refused: 'The server refused the connection',
	        err_tls: 'Could not connect securely',
	        err_proxy: 'The Kiwi IRC server had an error'
	    };
	
	    return errs[err] || 'Unknown error';
	}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = logger;
	var LOG_INFO = false;
	var LOG_ERROR = true;
	
	function logger() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    logger.info.apply(logger, args);
	}
	
	logger.info = function logInfo() {
	    if (LOG_INFO) {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        window.console.log.apply(window.console, args);
	    }
	};
	
	logger.error = function logError() {
	    if (LOG_ERROR) {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        window.console.error.apply(window.console, args);
	    }
	};
	
	logger.setLevel = function setLevel(newLevel) {
	    if (newLevel === 0) {
	        LOG_ERROR = false;
	        LOG_INFO = false;
	    } else if (newLevel === 1) {
	        LOG_ERROR = true;
	        LOG_INFO = false;
	    } else if (newLevel === 2) {
	        LOG_ERROR = true;
	        LOG_INFO = true;
	    }
	};
	
	logger.namespace = function namespace(label) {
	    function namespacedLogger() {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	        }
	
	        namespacedLogger.info.apply(namespacedLogger, args);
	    }
	
	    namespacedLogger.info = function logInfo() {
	        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	            args[_key5] = arguments[_key5];
	        }
	
	        var newArgs = args;
	        newArgs[0] = "[" + label + "] " + newArgs[0];
	        logger.info.apply(logger, newArgs);
	    };
	
	    namespacedLogger.error = function logError() {
	        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	            args[_key6] = arguments[_key6];
	        }
	
	        var newArgs = args;
	        newArgs[0] = "[" + label + "] " + newArgs[0];
	        logger.error.apply(logger, newArgs);
	    };
	
	    return namespacedLogger;
	};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(56);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.linkifyUrls = linkifyUrls;
	exports.addEmojis = addEmojis;
	exports.linkifyChannels = linkifyChannels;
	exports.linkifyUsers = linkifyUsers;
	exports.createNickColour = createNickColour;
	exports.hexVal = hexVal;
	exports.mapRange = mapRange;
	exports.formatText = formatText;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Colours = __webpack_require__(157);
	
	var Colours = _interopRequireWildcard(_Colours);
	
	var _Md = __webpack_require__(158);
	
	var _ThemeManager = __webpack_require__(55);
	
	var _ThemeManager2 = _interopRequireDefault(_ThemeManager);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var urlRegex = new RegExp(/(([A-Za-z][A-Za-z0-9-]*:\/\/)|(www\.))/.source + /([\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF.-]+)/.source + /([a-zA-Z]{2,6})/.source + /(:[0-9]+)?/.source + /(\/[\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF!:.?$'()[\]*,;~+=&%@!\-/]*)?/.source + /(#.*)?/.source, 'i');
	
	function linkifyUrls(input, _opts) {
	    var opts = _opts || {};
	    var foundUrls = [];
	    var urls = (0, _create2.default)(null);
	    var result = input.replace(urlRegex, function (_url) {
	        var url = _url;
	        var nice = '';
	        var suffix = '';
	
	        if (url.match(/^javascript:/i)) {
	            return url;
	        }
	
	        if (url.match(/^www\./i)) {
	            url = 'http://' + url;
	        }
	
	        if (url.indexOf('(') === -1 && url[url.length - 1] === ')') {
	            suffix += ')';
	            url = url.substr(0, url.length - 1);
	        }
	
	        nice = url;
	
	        if (nice.length > 100) {
	            nice = nice.substr(0, 100) + '...';
	        }
	
	        var out = '<a target="_blank" href="' + url.replace(/"/g, '%22') + '">' + _lodash2.default.escape(nice) + '</a>';
	
	        if (opts.addHandle) {
	            var cssClass = opts.handleClass || '';
	            var content = opts.handleContent || '';
	            out += '<a data-url="' + url + '" class="' + cssClass + '">' + content + '</a>';
	        }
	
	        var urlId = '---url' + Math.random() * 1e+17 + '---';
	        urls[urlId] = out;
	        out = urlId;
	
	        foundUrls.push(url);
	        return out + suffix;
	    });
	
	    result = _lodash2.default.escape(result);
	    (0, _keys2.default)(urls).forEach(function (urlId) {
	        result = result.replace(urlId, urls[urlId]);
	    });
	
	    return {
	        urls: foundUrls,
	        html: result
	    };
	}
	
	function addEmojis(wordCtx, emojiList, emojiLocation) {
	    var word = '';
	    var words = [word];
	
	    if ((typeof wordCtx === 'undefined' ? 'undefined' : (0, _typeof3.default)(wordCtx)) === 'object') {
	        word = wordCtx.word;
	        words = wordCtx.words;
	    } else {
	        word = wordCtx;
	    }
	
	    if (emojiList.hasOwnProperty && !emojiList.hasOwnProperty(word)) {
	        return word;
	    }
	
	    var emoji = emojiList[word];
	    if (emoji) {
	        var classes = 'kiwi-messagelist-emoji';
	        if (_lodash2.default.compact(words).length === 1) {
	            classes += ' kiwi-messagelist-emoji--single';
	        }
	
	        var src = '' + emojiLocation + emoji + '.png';
	        return '<img class="' + classes + '" src="' + src + '" alt="' + word + '" />';
	    }
	
	    return word;
	}
	
	var channelMatch = /(^|\s|[@+~&%}]+)([#&][^ .,\007<>\n\r]+)([.,<>\n\r]+)?$/i;
	function linkifyChannels(word) {
	    return word.replace(channelMatch, function (match, mPrefix, mChannel, mSuffix) {
	        var chan = _lodash2.default.escape(mChannel.trim());
	        var prefix = _lodash2.default.escape(mPrefix);
	        var suffix = _lodash2.default.escape(mSuffix);
	
	        var link = '<a class="u-link kiwi-channel" data-channel-name="' + chan + '">' + chan + '</a>';
	        return '' + prefix + link + suffix;
	    });
	}
	
	function linkifyUsers(word, userlist) {
	    var ret = '';
	    var nick = '';
	    var prepend = '';
	    var append = '';
	    var punc = ',.!:;-+)]?¿\\/<>@';
	    var validLastChar = punc.indexOf(word[word.length - 1]) > -1;
	    var normWord = word.toLowerCase();
	    var hasProp = Object.prototype.hasOwnProperty;
	
	    if (hasProp.call(userlist, normWord)) {
	        nick = word;
	    } else if (hasProp.call(userlist, normWord.substr(0, normWord.length - 1)) && validLastChar) {
	        nick = word.substr(0, word.length - 1);
	        append = word[word.length - 1];
	    } else if (hasProp.call(userlist, _lodash2.default.trim(normWord, punc))) {
	        nick = _lodash2.default.trim(word, punc);
	        var nickIdx = word.indexOf(nick);
	        append = word.substr(nickIdx + nick.length);
	        prepend = word.substr(0, nickIdx);
	    } else {
	        return word;
	    }
	
	    var escaped = _lodash2.default.escape(nick);
	    var colour = createNickColour(nick);
	    ret = '<a class="kiwi-nick" data-nick="' + escaped + '" style="color:' + colour + '">' + escaped + '</a>';
	
	    if (prepend) {
	        ret = _lodash2.default.escape(prepend) + ret;
	    }
	    if (append) {
	        ret += _lodash2.default.escape(append);
	    }
	
	    return ret;
	}
	
	var nickColourCache = (0, _create2.default)(null);
	function createNickColour(nick) {
	    var nickLower = nick.toLowerCase();
	
	    if (nickColourCache[nickLower]) {
	        return nickColourCache[nickLower];
	    }
	
	    var startingColour = '#36809B';
	
	    var hash = (0, _Md.md5)(nickLower);
	    var hueOffset = mapRange(hexVal(hash, 14, 3), 0, 4095, 0, 359);
	    var satOffset = hexVal(hash, 17);
	    var baseColour = Colours.rgb2hsl(Colours.hex2rgb(startingColour));
	    baseColour.h = (baseColour.h * 360 - hueOffset + 360) % 360 / 360;
	
	    if (satOffset % 2 === 0) {
	        baseColour.s = Math.min(1, (baseColour.s * 100 + satOffset) / 100);
	    } else {
	        baseColour.s = Math.max(0, (baseColour.s * 100 - satOffset) / 100);
	    }
	
	    var themeMngr = _ThemeManager2.default.instance();
	    var brightness = themeMngr.themeVar('nick-brightness');
	    if (brightness) {
	        baseColour.l = parseInt(brightness, 10) / 100;
	    }
	
	    var rgb = Colours.hsl2rgb(baseColour);
	    var nickColour = Colours.rgb2hex(rgb);
	
	    nickColourCache[nickLower] = nickColour;
	
	    return nickColour;
	}
	
	function hexVal(hash, index, len) {
	    return parseInt(hash.substr(index, len || 1), 16);
	}
	
	function mapRange(value, vMin, vMax, dMin, dMax) {
	    var vValue = parseFloat(value);
	    var vRange = vMax - vMin;
	    var dRange = dMax - dMin;
	
	    return (vValue - vMin) * dRange / vRange + dMin;
	}
	
	var textFormats = {
	    channel_join: '→ %nick (%username@%host) %text',
	    channel_part: '← %nick (%username@%host) %text',
	    channel_quit: '← %nick (%username@%host) %text',
	    channel_kicked: '← %text',
	    channel_selfkick: '× %text',
	    channel_badpassword: '× %text',
	    channel_topic: 'ⓘ %text',
	    channel_banned: '× %text',
	    channel_badkey: '⚠ %text',
	    channel_inviteonly: '⚠ %channel %text',
	    channel_alreadyin: '⚠ %nick %text',
	    channel_limitreached: '⚠ %channel %text',
	    channel_invalid_name: '⚠ %channel %text',
	    channel_topic_setby: 'ⓘ %text',
	    channel_has_been_invited: 'ⓘ %nick %text',
	    server_connecting: '%text',
	    server_connecting_error: '%text',
	    mode: 'ⓘ %nick %text',
	    selfmode: 'ⓘ %nick %text',
	    nickname_alreadyinuse: '⚠ %text',
	    network_disconnected: '⚠ %text',
	    network_connected: '⚠ %text',
	    whois_channels: '%text',
	    whois_idle_and_signon: '%text',
	    whois_away: '%text',
	    whois_server: '%text',
	    whois_idle: '%text',
	    whois_notfound: 'ⓘ %text',
	    nick_changed: 'ⓘ %text',
	    applet_notfound: '⚠ %text',
	    encoding_changed: 'ⓘ %text',
	    encoding_invalid: '⚠ %text',
	    settings_saved: 'ⓘ %text',
	    ignore_title: '%text:',
	    ignore_none: '%text',
	    ignore_nick: '%text',
	    ignore_stop_notice: '%text',
	    ignore_stopped: '%text',
	    chanop_privs_needed: '⚠ %text',
	    no_such_nick: 'ⓘ %nick: %text',
	    unknown_command: 'ⓘ %text',
	    motd: '%text',
	    ctcp_response: '[CTCP %nick reply] %message',
	    ctcp_request: '[CTCP %nick] %message',
	    privmsg: '%text',
	    notice: '%text',
	    action: '* %nick %text',
	    whois_ident: '%nick [%nick!%ident@%host] * %text',
	    whois: '%text',
	    who: '%nick [%nick!%ident@%host] * %realname',
	    quit: '%text',
	    rejoin: '%text',
	    set_setting: 'ⓘ %text',
	    list_aliases: 'ⓘ %text',
	    ignored_pattern: 'ⓘ %text',
	    wallops: '[WALLOPS] %text',
	    message_nick: '%prefix%nick',
	    general_error: '%text'
	};
	
	function formatText(formatId, params) {
	    var format = textFormats[formatId];
	
	    if (params.user) {
	        params.nick = params.user.nick || '';
	        params.username = params.user.username || '';
	        params.host = params.user.hostname || '';
	        params.prefix = params.user.prefix || '';
	    }
	
	    var result = format.replace(/%([A-Z]{2,})/ig, function (match, key) {
	        var ret = '';
	        if (typeof params[key] !== 'undefined') {
	            ret = params[key];
	        }
	
	        return ret;
	    });
	
	    return result;
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _eventEmitter = __webpack_require__(93);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _vue = __webpack_require__(28);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var singletonInstance = null;
	var callbacksOnReady = [];
	
	var GlobalApi = function () {
	    function GlobalApi() {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, GlobalApi);
	
	        (0, _eventEmitter2.default)(this);
	        this.Vue = _vue2.default;
	        this.state = null;
	        this.themes = null;
	        this.controlInputPlugins = [];
	        this.stateBrowserPlugins = [];
	        this.channelHeaderPlugins = [];
	        this.queryHeaderPlugins = [];
	        this.tabs = (0, _create2.default)(null);
	        this.isReady = false;
	
	        this.on('init', function () {
	            _this.isReady = true;
	            _this.initPlugins();
	        });
	    }
	
	    (0, _createClass3.default)(GlobalApi, [{
	        key: 'plugin',
	        value: function plugin(pluginName, fn) {
	            if (this.isReady) {
	                fn(this);
	            } else {
	                callbacksOnReady.push(fn);
	            }
	        }
	    }, {
	        key: 'initPlugins',
	        value: function initPlugins() {
	            var _this2 = this;
	
	            callbacksOnReady.forEach(function (fn) {
	                try {
	                    fn(_this2);
	                } catch (err) {
	                    window.error(err);
	                }
	            });
	
	            callbacksOnReady = [];
	        }
	    }, {
	        key: 'setState',
	        value: function setState(state) {
	            this.state = state;
	        }
	    }, {
	        key: 'setThemeManager',
	        value: function setThemeManager(themeManager) {
	            this.themes = themeManager;
	        }
	    }, {
	        key: 'logLevel',
	        value: function logLevel(newLevel) {
	            _Logger2.default.setLevel(newLevel);
	        }
	    }, {
	        key: 'addUi',
	        value: function addUi(type, element) {
	            switch (type) {
	                case 'input':
	                    this.controlInputPlugins.push(element);
	                    break;
	                case 'browser':
	                    this.stateBrowserPlugins.push(element);
	                    break;
	                case 'header_channel':
	                    this.channelHeaderPlugins.push(element);
	                    break;
	                case 'header_query':
	                    this.queryHeaderPlugins.push(element);
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'addTab',
	        value: function addTab(name, component, props) {
	            this.tabs[name] = {
	                component: _vue2.default.extend(component),
	                props: props || {}
	            };
	        }
	    }, {
	        key: 'showTab',
	        value: function showTab(name) {
	            var tab = this.tabs[name];
	            if (tab) {
	                this.state.$emit('active.component', tab.component, tab.props);
	            } else {
	                this.state.$emit('active.component', null);
	            }
	        }
	    }, {
	        key: 'addStartup',
	        value: function addStartup(name, ctor) {
	            var startups = this.state.getStartups();
	            startups[name] = ctor;
	        }
	    }], [{
	        key: 'singleton',
	        value: function singleton() {
	            singletonInstance = singletonInstance || new GlobalApi();
	            return singletonInstance;
	        }
	    }]);
	    return GlobalApi;
	}();
	
	exports.default = GlobalApi;

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createdInstance = null;
	
	var ThemeManager = function () {
	    function ThemeManager(state) {
	        (0, _classCallCheck3.default)(this, ThemeManager);
	
	        this.state = state;
	        this.listenForIrcEvents();
	        this.varsEl = null;
	    }
	
	    (0, _createClass3.default)(ThemeManager, [{
	        key: 'themeVar',
	        value: function themeVar(varName) {
	            if (!this.varsEl) {
	                this.varsEl = document.querySelector('.kiwi-wrap');
	            }
	
	            var styles = window.getComputedStyle(this.varsEl);
	            var v = styles.getPropertyValue('--kiwi-' + varName);
	            return (v || '').trim();
	        }
	    }, {
	        key: 'availableThemes',
	        value: function availableThemes() {
	            return this.state.settings.themes;
	        }
	    }, {
	        key: 'currentTheme',
	        value: function currentTheme() {
	            var state = this.state;
	            var currentThemeName = state.setting('theme');
	            currentThemeName = currentThemeName.toLowerCase();
	
	            var theme = _lodash2.default.find(state.settings.themes, function (t) {
	                var isMatch = t.name.toLowerCase() === currentThemeName;
	                return isMatch;
	            });
	
	            if (!theme) {
	                theme = state.settings.themes[0];
	            }
	
	            return theme;
	        }
	    }, {
	        key: 'setTheme',
	        value: function setTheme(theme) {
	            var theTheme = null;
	
	            if (typeof theme === 'string') {
	                theTheme = _lodash2.default.find(this.availableThemes(), function (t) {
	                    var isMatch = t.name.toLowerCase() === theme.toLowerCase();
	                    return isMatch;
	                });
	
	                if (!theTheme) {
	                    return;
	                }
	            } else {
	                theTheme = theme;
	            }
	
	            this.state.setting('theme', theTheme.name);
	            this.state.$emit('theme.change');
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var theme = this.currentTheme();
	            if (!theme) {
	                return;
	            }
	
	            var url = theme.url;
	            if (url.indexOf('cb=') > -1) {
	                url = url.replace(/cb=[0-9]+/, function () {
	                    return 'cb=' + Date.now();
	                });
	            } else if (url.indexOf('?') > -1) {
	                url += '&cb=' + Date.now();
	            } else {
	                url += '?cb=' + Date.now();
	            }
	
	            theme.url = url;
	            this.state.$emit('theme.change');
	        }
	    }, {
	        key: 'themeUrl',
	        value: function themeUrl(theme) {
	            var parts = theme.url.split('?');
	            var url = parts[0];
	            var qs = parts[1] || '';
	
	            if (url[url.length - 1] !== '/') {
	                url += '/';
	            }
	            return url + 'theme.css' + (qs ? '?' + qs : '');
	        }
	    }, {
	        key: 'setCustomThemeUrl',
	        value: function setCustomThemeUrl(url) {
	            var theme = _lodash2.default.find(ThemeManager.instance().availableThemes(), {
	                name: 'custom'
	            });
	
	            if (theme) {
	                theme.url = url;
	            }
	
	            if (theme.name === 'custom') {
	                this.state.$emit('theme.change');
	            }
	        }
	    }, {
	        key: 'listenForIrcEvents',
	        value: function listenForIrcEvents() {
	            var _this = this;
	
	            this.state.$on('irc:ctcp request', function (event, network) {
	                var ctcpType = (event.type || '').toLowerCase();
	                if (ctcpType === 'kiwi' && event.message.indexOf('theme reload') > -1) {
	                    _this.reload();
	                }
	            });
	        }
	    }]);
	    return ThemeManager;
	}();
	
	exports.default = ThemeManager;
	
	
	ThemeManager.instance = function instance(state) {
	    if (!createdInstance) {
	        createdInstance = new ThemeManager(state);
	    }
	
	    return createdInstance;
	};

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(345)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(196),
	  /* template */
	  __webpack_require__(500),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(349)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(197),
	  /* template */
	  __webpack_require__(504),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(334)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(198),
	  /* template */
	  __webpack_require__(489),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(338)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(204),
	  /* template */
	  __webpack_require__(493),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(348)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(205),
	  /* template */
	  __webpack_require__(503),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hex2rgb = hex2rgb;
	exports.rgb2hex = rgb2hex;
	exports.rgb2hsl = rgb2hsl;
	exports.hsl2rgb = hsl2rgb;
	exports.rgb2rgbString = rgb2rgbString;
	function hex2rgb(_hex) {
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    var hex = _hex.replace(shorthandRegex, function (m, r, g, b) {
	        return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	        r: parseInt(result[1], 16),
	        g: parseInt(result[2], 16),
	        b: parseInt(result[3], 16)
	    } : null;
	}
	
	function rgb2hex(rgb) {
	    return '#' + ['r', 'g', 'b'].map(function (key) {
	        return ('0' + rgb[key].toString(16)).slice(-2);
	    }).join('');
	}
	
	function rgb2hsl(rgb) {
	    var r = rgb.r;
	    var g = rgb.g;
	    var b = rgb.b;
	
	    r /= 255;
	    g /= 255;
	    b /= 255;
	
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var h = 0;
	    var s = 0;
	    var l = (max + min) / 2;
	
	    if (max === min) {
	        h = s = 0;
	    } else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        if (max === r) {
	            h = (g - b) / d + (g < b ? 6 : 0);
	        } else if (max === g) {
	            h = (b - r) / d + 2;
	        } else if (max === b) {
	            h = (r - g) / d + 4;
	        }
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	function hsl2rgb(hsl) {
	    function hue2rgb(_p, _q, _t) {
	        var p = _p;
	        var q = _q;
	        var t = _t;
	        if (t < 0) t += 1;
	        if (t > 1) t -= 1;
	        if (t < 1 / 6) return p + (q - p) * 6 * t;
	        if (t < 1 / 2) return q;
	        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	        return p;
	    }
	
	    var h = hsl.h;
	    var s = hsl.s;
	    var l = hsl.l;
	    var r = 0;
	    var g = 0;
	    var b = 0;
	
	    if (s === 0) {
	        r = g = b = l;
	    } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1 / 3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1 / 3);
	    }
	
	    return {
	        r: Math.round(r * 255),
	        g: Math.round(g * 255),
	        b: Math.round(b * 255)
	    };
	}
	
	function rgb2rgbString(rgb) {
	    return 'rgb(' + [rgb.r, rgb.g, rgb.b].join(',') + ')';
	}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	function md5cycle(x, k) {
	    var a = x[0],
	        b = x[1],
	        c = x[2],
	        d = x[3];
	
	    a = ff(a, b, c, d, k[0], 7, -680876936);
	    d = ff(d, a, b, c, k[1], 12, -389564586);
	    c = ff(c, d, a, b, k[2], 17, 606105819);
	    b = ff(b, c, d, a, k[3], 22, -1044525330);
	    a = ff(a, b, c, d, k[4], 7, -176418897);
	    d = ff(d, a, b, c, k[5], 12, 1200080426);
	    c = ff(c, d, a, b, k[6], 17, -1473231341);
	    b = ff(b, c, d, a, k[7], 22, -45705983);
	    a = ff(a, b, c, d, k[8], 7, 1770035416);
	    d = ff(d, a, b, c, k[9], 12, -1958414417);
	    c = ff(c, d, a, b, k[10], 17, -42063);
	    b = ff(b, c, d, a, k[11], 22, -1990404162);
	    a = ff(a, b, c, d, k[12], 7, 1804603682);
	    d = ff(d, a, b, c, k[13], 12, -40341101);
	    c = ff(c, d, a, b, k[14], 17, -1502002290);
	    b = ff(b, c, d, a, k[15], 22, 1236535329);
	
	    a = gg(a, b, c, d, k[1], 5, -165796510);
	    d = gg(d, a, b, c, k[6], 9, -1069501632);
	    c = gg(c, d, a, b, k[11], 14, 643717713);
	    b = gg(b, c, d, a, k[0], 20, -373897302);
	    a = gg(a, b, c, d, k[5], 5, -701558691);
	    d = gg(d, a, b, c, k[10], 9, 38016083);
	    c = gg(c, d, a, b, k[15], 14, -660478335);
	    b = gg(b, c, d, a, k[4], 20, -405537848);
	    a = gg(a, b, c, d, k[9], 5, 568446438);
	    d = gg(d, a, b, c, k[14], 9, -1019803690);
	    c = gg(c, d, a, b, k[3], 14, -187363961);
	    b = gg(b, c, d, a, k[8], 20, 1163531501);
	    a = gg(a, b, c, d, k[13], 5, -1444681467);
	    d = gg(d, a, b, c, k[2], 9, -51403784);
	    c = gg(c, d, a, b, k[7], 14, 1735328473);
	    b = gg(b, c, d, a, k[12], 20, -1926607734);
	
	    a = hh(a, b, c, d, k[5], 4, -378558);
	    d = hh(d, a, b, c, k[8], 11, -2022574463);
	    c = hh(c, d, a, b, k[11], 16, 1839030562);
	    b = hh(b, c, d, a, k[14], 23, -35309556);
	    a = hh(a, b, c, d, k[1], 4, -1530992060);
	    d = hh(d, a, b, c, k[4], 11, 1272893353);
	    c = hh(c, d, a, b, k[7], 16, -155497632);
	    b = hh(b, c, d, a, k[10], 23, -1094730640);
	    a = hh(a, b, c, d, k[13], 4, 681279174);
	    d = hh(d, a, b, c, k[0], 11, -358537222);
	    c = hh(c, d, a, b, k[3], 16, -722521979);
	    b = hh(b, c, d, a, k[6], 23, 76029189);
	    a = hh(a, b, c, d, k[9], 4, -640364487);
	    d = hh(d, a, b, c, k[12], 11, -421815835);
	    c = hh(c, d, a, b, k[15], 16, 530742520);
	    b = hh(b, c, d, a, k[2], 23, -995338651);
	
	    a = ii(a, b, c, d, k[0], 6, -198630844);
	    d = ii(d, a, b, c, k[7], 10, 1126891415);
	    c = ii(c, d, a, b, k[14], 15, -1416354905);
	    b = ii(b, c, d, a, k[5], 21, -57434055);
	    a = ii(a, b, c, d, k[12], 6, 1700485571);
	    d = ii(d, a, b, c, k[3], 10, -1894986606);
	    c = ii(c, d, a, b, k[10], 15, -1051523);
	    b = ii(b, c, d, a, k[1], 21, -2054922799);
	    a = ii(a, b, c, d, k[8], 6, 1873313359);
	    d = ii(d, a, b, c, k[15], 10, -30611744);
	    c = ii(c, d, a, b, k[6], 15, -1560198380);
	    b = ii(b, c, d, a, k[13], 21, 1309151649);
	    a = ii(a, b, c, d, k[4], 6, -145523070);
	    d = ii(d, a, b, c, k[11], 10, -1120210379);
	    c = ii(c, d, a, b, k[2], 15, 718787259);
	    b = ii(b, c, d, a, k[9], 21, -343485551);
	
	    x[0] = add32(a, x[0]);
	    x[1] = add32(b, x[1]);
	    x[2] = add32(c, x[2]);
	    x[3] = add32(d, x[3]);
	}
	
	function cmn(q, a, b, x, s, t) {
	    a = add32(add32(a, q), add32(x, t));
	    return add32(a << s | a >>> 32 - s, b);
	}
	
	function ff(a, b, c, d, x, s, t) {
	    return cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function gg(a, b, c, d, x, s, t) {
	    return cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	function md51(s) {
	    var n = s.length,
	        state = [1732584193, -271733879, -1732584194, 271733878],
	        i;
	    for (i = 64; i <= s.length; i += 64) {
	        md5cycle(state, md5blk(s.substring(i - 64, i)));
	    }
	    s = s.substring(i - 64);
	    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	    for (i = 0; i < s.length; i++) {
	        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
	    }tail[i >> 2] |= 0x80 << (i % 4 << 3);
	    if (i > 55) {
	        md5cycle(state, tail);
	        for (i = 0; i < 16; i++) {
	            tail[i] = 0;
	        }
	    }
	    tail[14] = n * 8;
	    md5cycle(state, tail);
	    return state;
	}
	
	function md5blk(s) {
	    var md5blks = [],
	        i;
	    for (i = 0; i < 64; i += 4) {
	        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
	    }
	    return md5blks;
	}
	
	var hex_chr = '0123456789abcdef'.split('');
	
	function rhex(n) {
	    var s = '',
	        j = 0;
	    for (; j < 4; j++) {
	        s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
	    }return s;
	}
	
	function hex(x) {
	    for (var i = 0; i < x.length; i++) {
	        x[i] = rhex(x[i]);
	    }return x.join('');
	}
	
	function md5(s) {
	    return hex(md51(s));
	}
	
	function add32(a, b) {
	    return a + b & 0xFFFFFFFF;
	}
	
	if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
	    var _add = function _add(x, y) {
	        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return msw << 16 | lsw & 0xFFFF;
	    };
	}
	
	exports.md5 = md5;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AliasRewriter = function () {
	    function AliasRewriter() {
	        (0, _classCallCheck3.default)(this, AliasRewriter);
	
	        this.recursiveDepth = 3;
	
	        this.depth = 0;
	
	        this.aliases = {};
	    }
	
	    (0, _createClass3.default)(AliasRewriter, [{
	        key: 'importFromString',
	        value: function importFromString(str) {
	            var _this = this;
	
	            this.aliases = {};
	
	            str.split('\n').forEach(function (line) {
	                if (line[0] !== '/') {
	                    return;
	                }
	
	                var spaceSep = line.indexOf(' ');
	                if (spaceSep === -1) {
	                    return;
	                }
	
	                var command = line.substring(0, spaceSep);
	                var actions = line.substring(spaceSep + 1).trim();
	                if (!actions) {
	                    return;
	                }
	
	                _this.aliases[command.toLowerCase()] = actions;
	            });
	        }
	    }, {
	        key: 'processInput',
	        value: function processInput(input, vars) {
	            var words = input || [];
	            var alias = this.aliases[words[0].toLowerCase()];
	            var aliasLen = void 0;
	            var currentAliasWord = '';
	            var currentAliasWordLen = 0;
	            var processedConditionals = false;
	            var compiled = [];
	
	            if (!alias) return input;
	
	            alias = alias.split(' ');
	            aliasLen = alias.length;
	
	            for (var i = 0; i < aliasLen; i++) {
	                currentAliasWord = alias[i];
	                currentAliasWordLen = currentAliasWord.length;
	
	                if (!processedConditionals && currentAliasWord[0] === '$' && currentAliasWord[currentAliasWordLen - 1] === '?') {
	                    var checkVar = currentAliasWord.substr(1, currentAliasWordLen - 2);
	                    if (!vars[checkVar]) {
	                        compiled = [];
	                        break;
	                    } else {
	                        continue;
	                    }
	                } else {
	                    processedConditionals = true;
	                }
	
	                if (currentAliasWord[0] !== '$') {
	                    compiled.push(currentAliasWord);
	                    continue;
	                }
	
	                if (!isNaN(currentAliasWord[1])) {
	                    var num = currentAliasWord.match(/\$(\d+)(\+)?(\d+)?/);
	
	                    if (!num || !words[num[1]]) continue;
	
	                    if (num[2] === '+' && num[3]) {
	                        compiled = compiled.concat(words.slice(parseInt(num[1], 10), parseInt(num[1], 10) + parseInt(num[3], 10)));
	                    } else if (num[2] === '+') {
	                        compiled = compiled.concat(words.slice(parseInt(num[1], 10)));
	                    } else {
	                        compiled.push(words[parseInt(num[1], 10)]);
	                    }
	
	                    continue;
	                }
	
	                if (typeof vars[currentAliasWord.substr(1)] !== 'undefined') {
	                    compiled.push(vars[currentAliasWord.substr(1)]);
	
	                    continue;
	                }
	            }
	
	            return compiled;
	        }
	    }, {
	        key: 'process',
	        value: function process(input, vars) {
	            var line = input || '';
	            var words = line.split(' ');
	            var firstWord = (words[0] || '').toLowerCase();
	
	            this.depth++;
	            if (this.depth >= this.recursiveDepth) {
	                this.depth--;
	                return line;
	            }
	
	            if (this.aliases[firstWord]) {
	                words = this.processInput(words, vars);
	                firstWord = (words[0] || '').toLowerCase();
	
	                if (this.aliases[firstWord]) {
	                    words = this.process(words.join(' '), vars).split(' ');
	                }
	            }
	
	            this.depth--;
	            return words.join(' ');
	        }
	    }]);
	    return AliasRewriter;
	}();
	
	exports.default = AliasRewriter;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioBleep = undefined;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.listenForHighlights = listenForHighlights;
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioBleep = exports.AudioBleep = function () {
	    function AudioBleep() {
	        (0, _classCallCheck3.default)(this, AudioBleep);
	
	        this.lastPlayed = 0;
	
	        this.audio = document.createElement('audio');
	        var source = document.createElement('source');
	
	        if (this.audio.canPlayType('audio/mpeg;')) {
	            source.type = 'audio/mpeg';
	            source.src = 'static/highlight.mp3';
	        } else {
	            source.type = 'audio/ogg';
	            source.src = 'static/highlight.ogg';
	        }
	
	        this.audio.appendChild(source);
	    }
	
	    (0, _createClass3.default)(AudioBleep, [{
	        key: 'play',
	        value: function play() {
	            if (!this.lastPlayed || Date.now() - this.lastPlayed > 2000) {
	                this.audio.play();
	                this.lastPlayed = Date.now();
	            }
	        }
	    }]);
	    return AudioBleep;
	}();
	
	function listenForHighlights(state) {
	    var bleep = new AudioBleep();
	
	    state.$on('message.new', function (message, buffer) {
	        if (buffer.setting('mute_sound')) {
	            return;
	        }
	
	        if (message.type === 'connection') {
	            return;
	        }
	
	        var network = buffer.getNetwork();
	        var isHighlight = Misc.mentionsNick(message.message, network.nick);
	        var isActiveBuffer = state.getActiveBuffer() === buffer;
	        var inFocus = isActiveBuffer && state.ui.app_has_focus;
	
	        if (isHighlight || buffer.isQuery() && !inFocus) {
	            bleep.play();
	        }
	    });
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _promise = __webpack_require__(38);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = bouncerMiddleware;
	
	var _strftime = __webpack_require__(71);
	
	var _strftime2 = _interopRequireDefault(_strftime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bouncerMiddleware() {
	    var networks = [];
	    var buffers = {};
	
	    return function middleware(client, rawEvents, parsedEvents) {
	        client.requestCap('bouncer');
	        addFunctionsToClient(client);
	        rawEvents.use(theMiddleware);
	    };
	
	    function theMiddleware(command, message, rawLine, client, next) {
	        if (command !== 'BOUNCER') {
	            next();
	            return;
	        }
	
	        var params = message.params;
	
	        if (params[0] === 'listnetworks' && params[1] === 'end') {
	            client.emit('bouncer networks', networks);
	            networks = [];
	        } else if (params[0] === 'listnetworks') {
	            var tags = parseTags(params[1]);
	            networks.push({
	                name: tags.network,
	                host: tags.host,
	                port: parseInt(tags.port, 10),
	                tls: tags.tls === '1',
	                connect: tags.state === 'connected',
	                nick: tags.nick,
	                currentNick: tags.currentNick,
	                password: tags.password || ''
	            });
	        } else if (params[0] === 'listbuffers' && params[2] === 'end') {
	            var netName = (params[1] || '').toLowerCase();
	            var detectedBuffers = buffers[netName] || [];
	            delete buffers[netName];
	
	            client.emit('bouncer buffers', detectedBuffers);
	            client.emit('bouncer buffers ' + netName, detectedBuffers);
	        } else if (params[0] === 'listbuffers') {
	            var _netName = (params[1] || '').toLowerCase();
	            var _tags = parseTags(params[2]);
	            buffers[_netName] = buffers[_netName] || [];
	            buffers[_netName].push({
	                network: _tags.network,
	                name: _tags.buffer,
	                topic: _tags.topic,
	                joined: _tags.joined === '1',
	                seen: _tags.seen
	            });
	        }
	
	        if (params[0] === 'addnetwork' && params[2].substr(0, 4) === 'ERR_') {
	            var _netName2 = (params[1] || '').toLowerCase();
	            var eventObj = {
	                error: params[2],
	                reason: params[3] || ''
	            };
	            client.emit('bouncer addnetwork error', eventObj);
	            client.emit('bouncer addnetwork error ' + _netName2, eventObj);
	        } else if (params[0] === 'addnetwork' && params[2] === 'RPL_OK') {
	            var _netName3 = (params[1] || '').toLowerCase();
	            var _eventObj = {
	                network: params[2]
	            };
	            client.emit('bouncer addnetwork ok', _eventObj);
	            client.emit('bouncer addnetwork ok ' + _netName3, _eventObj);
	        }
	    }
	}
	
	function addFunctionsToClient(client) {
	    var bnc = client.bnc = {};
	
	    bnc.getNetworks = function getNetworks() {
	        return new _promise2.default(function (resolve, reject) {
	            client.raw('BOUNCER listnetworks');
	            client.once('bouncer networks', function (networks) {
	                resolve(networks);
	            });
	        });
	    };
	
	    bnc.getBuffers = function getBuffers(netName) {
	        return new _promise2.default(function (resolve, reject) {
	            client.raw('BOUNCER listbuffers ' + netName);
	            client.once('bouncer buffers ' + netName.toLowerCase(), function (buffers) {
	                resolve(buffers);
	            });
	        });
	    };
	
	    bnc.closeBuffer = function closeBuffer(netName, bufferName) {
	        return new _promise2.default(function (resolve, reject) {
	            client.raw('BOUNCER delbuffer ' + netName + ' ' + bufferName);
	        });
	    };
	
	    bnc.bufferSeen = function bufferSeen(netName, bufferName, seenTime) {
	        return new _promise2.default(function (resolve, reject) {
	            var timeStr = (0, _strftime2.default)('%FT%T.%L%:z', seenTime);
	            client.raw('BOUNCER changebuffer ' + netName + ' ' + bufferName + ' seen=' + timeStr);
	        });
	    };
	
	    bnc.addNetwork = function addNetwork(netName, host, port, tls, nick, user, password) {
	        var tags = {};
	        tags.network = netName;
	        tags.host = host;
	        tags.port = port;
	        tags.tls = tls ? 1 : 0;
	        tags.nick = nick;
	        tags.password = password;
	
	        if (user) {
	            tags.user = user;
	        }
	
	        var tagString = createTagString(tags);
	        return new _promise2.default(function (resolve, reject) {
	            client.raw('BOUNCER addnetwork ' + tagString);
	            client.once('bouncer addnetwork ok', onOk);
	            client.once('bouncer addnetwork error', onError);
	
	            function onOk(event) {
	                client.off('bouncer addnetwork error', onError);
	                resolve();
	            }
	            function onError(event) {
	                client.off('bouncer addnetwork ok', onOk);
	                reject({
	                    error: event.error,
	                    reason: event.reason
	                });
	            }
	        });
	    };
	
	    bnc.removeNetwork = function removeNetwork(netName, bufferName) {
	        return new _promise2.default(function (resolve, reject) {
	            client.raw('BOUNCER delnetwork ' + netName);
	        });
	    };
	
	    bnc.saveNetwork = function saveNetwork(netName, opts) {
	        var tags = {};
	
	        if (typeof opts.host !== 'undefined') {
	            tags.host = opts.host;
	        }
	        if (typeof opts.port !== 'undefined') {
	            tags.port = opts.port;
	        }
	        if (typeof opts.tls !== 'undefined') {
	            tags.tls = opts.tls ? 1 : 0;
	        }
	        if (typeof opts.nick !== 'undefined') {
	            tags.nick = opts.nick;
	        }
	        if (typeof opts.user !== 'undefined') {
	            tags.user = opts.user;
	        }
	        if (typeof opts.password !== 'undefined') {
	            tags.password = opts.password;
	        }
	
	        var tagString = createTagString(tags);
	        return new _promise2.default(function (resolve, reject) {
	            if (tagString.length === 0) {
	                resolve();
	            } else {
	                client.raw('BOUNCER changenetwork ' + netName + ' ' + tagString);
	            }
	        });
	    };
	}
	
	function parseTags(tagString) {
	    var tags = (0, _create2.default)(null);
	    (tagString || '').split(';').forEach(function (tag) {
	        var parts = tag.replace('\\s', ' ').replace('\\:', ';').split('=');
	
	        tags[parts[0]] = parts[1] || null;
	    });
	
	    return tags;
	}
	
	function createTagString(tags) {
	    var tagParts = [];
	
	    for (var tag in tags) {
	        if (tags.hasOwnProperty(tag)) {
	            var val = tags[tag];
	            if (typeof val !== 'undefined') {
	                val = val.toString().replace(' ', '\\s').replace(';', '\\:');
	                tagParts.push(tag + '=' + val);
	            } else {
	                tagParts.push(tag);
	            }
	        }
	    }
	
	    return tagParts.join(';');
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(38);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _xhr = __webpack_require__(512);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = _Logger2.default.namespace('ConfigLoader');
	
	var ConfigLoader = function () {
	    function ConfigLoader() {
	        (0, _classCallCheck3.default)(this, ConfigLoader);
	
	        this.config = (0, _create2.default)(null);
	    }
	
	    (0, _createClass3.default)(ConfigLoader, [{
	        key: 'loadFromUrl',
	        value: function loadFromUrl(configUrl) {
	            var _this = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                (0, _xhr2.default)({ url: configUrl }, function (err, response) {
	                    if (err) {
	                        reject();
	                        return;
	                    }
	
	                    var configObj = null;
	                    try {
	                        configObj = JSON.parse(response.body);
	                    } catch (parseErr) {
	                        log.error('Config file: ' + parseErr.stack);
	                        reject();
	                        return;
	                    }
	
	                    _this.setConfig(configObj);
	                    resolve(_this.config);
	                });
	            });
	        }
	    }, {
	        key: 'loadFromObj',
	        value: function loadFromObj(configObj) {
	            var _this2 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this2.setConfig(configObj);
	                resolve(_this2.config);
	            });
	        }
	    }, {
	        key: 'setConfig',
	        value: function setConfig(confObj) {
	            var _this3 = this;
	
	            this.config = (0, _create2.default)(null);
	            _lodash2.default.each(confObj, function (_val, key) {
	                var val = _val;
	                if (typeof val === 'string') {
	                    val = _this3.insertReplacements(val);
	                }
	
	                _this3.config[key] = val;
	            });
	        }
	    }, {
	        key: 'insertReplacements',
	        value: function insertReplacements(input) {
	            var out = input;
	            out = out.replace('{{hostname}}', window.location.hostname);
	            out = out.replace('{{host}}', window.location.host);
	            out = out.replace('{{port}}', window.location.port || 80);
	            out = out.replace('{{hash}}', (window.location.hash || '').substr(1));
	            out = out.replace('{{query}}', (window.location.search || '').substr(1));
	            out = out.replace('{{referrer}}', window.document.referrer);
	            return out;
	        }
	    }]);
	    return ConfigLoader;
	}();
	
	exports.default = ConfigLoader;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AliasRewriter = __webpack_require__(159);
	
	var _AliasRewriter2 = _interopRequireDefault(_AliasRewriter);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputCommands = {};
	
	var InputHandler = function () {
	    function InputHandler(state) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, InputHandler);
	
	        this.state = state;
	        this.aliasRewriter = new _AliasRewriter2.default();
	
	        this.aliasRewriter.importFromString(state.setting('aliases'));
	
	        state.$watch('user_settings.aliases', function (newVal) {
	            _this.aliasRewriter.importFromString(state.setting('aliases'));
	        });
	
	        this.addInputCommands();
	        this.listenForInput();
	    }
	
	    (0, _createClass3.default)(InputHandler, [{
	        key: 'listenForInput',
	        value: function listenForInput() {
	            var _this2 = this;
	
	            this.state.$on('input.raw', function (input) {
	                var lines = input.split('\n');
	                lines.forEach(function (line) {
	                    return _this2.processLine(line);
	                });
	            });
	        }
	    }, {
	        key: 'processLine',
	        value: function processLine(rawLine) {
	            var line = rawLine;
	            var activeNetwork = this.state.getActiveNetwork();
	            var activeBuffer = this.state.getActiveBuffer();
	
	            var escapedCommand = line.substr(0, 2) === '//';
	            if (line[0] !== '/' || escapedCommand) {
	                if (escapedCommand) {
	                    line = line.substr(1);
	                }
	
	                if (activeBuffer.isServer()) {
	                    line = '/quote ' + line;
	                } else {
	                    line = '/msg ' + activeBuffer.name + ' ' + line;
	                }
	            }
	
	            var aliasVars = {
	                server: activeNetwork.name,
	                channel: activeNetwork.isChannelName(activeBuffer.name) ? activeBuffer.name : '',
	                query: activeNetwork.isChannelName(activeBuffer.name) ? '' : activeBuffer.name,
	                destination: activeBuffer.name,
	                nick: activeNetwork.nick
	            };
	            line = this.aliasRewriter.process(line, aliasVars);
	
	            if (!line) {
	                return;
	            }
	
	            line = line.substr(1);
	
	            var spaceIdx = line.indexOf(' ');
	            if (spaceIdx === -1) spaceIdx = line.length;
	
	            var command = line.substr(0, spaceIdx);
	            var params = line.substr(spaceIdx + 1);
	
	            var eventObj = {
	                handled: false,
	                raw: rawLine,
	                command: command,
	                params: params
	            };
	
	            this.state.$emit('input.command.' + command, eventObj, command, params);
	
	            if (!eventObj.handled) {
	                activeNetwork.ircClient.raw(line);
	            }
	        }
	    }, {
	        key: 'addInputCommands',
	        value: function addInputCommands() {
	            var _this3 = this;
	
	            _lodash2.default.each(inputCommands, function (fn, event) {
	                _this3.state.$on('input.command.' + event, fn.bind(_this3));
	            });
	        }
	    }]);
	    return InputHandler;
	}();
	
	exports.default = InputHandler;
	
	inputCommands.lines = function inputCommandLines(event, command, line) {
	    var _this4 = this;
	
	    event.handled = true;
	
	    line.split('|').forEach(function (subLine) {
	        _this4.processLine(subLine.trim());
	    });
	};
	
	function handleMessage(type, event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	
	    var spaceIdx = line.indexOf(' ');
	    if (spaceIdx === -1) spaceIdx = line.length;
	
	    var bufferName = line.substr(0, spaceIdx);
	    var message = line.substr(spaceIdx + 1);
	
	    var buffer = this.state.getBufferByName(network.id, bufferName);
	    if (buffer) {
	        var newMessage = {
	            time: Date.now(),
	            nick: this.state.getActiveNetwork().nick,
	            message: message,
	            type: type
	        };
	
	        this.state.addMessage(buffer, newMessage);
	    }
	
	    var fnNames = {
	        privmsg: 'say',
	        action: 'action',
	        notice: 'notice'
	    };
	    var fnName = fnNames[type] || 'say';
	    network.ircClient[fnName](bufferName, message);
	}
	
	inputCommands.msg = function inputCommandMsg(event, command, line) {
	    handleMessage.call(this, 'privmsg', event, command, line);
	};
	inputCommands.action = function inputCommandMsg(event, command, line) {
	    handleMessage.call(this, 'action', event, command, line);
	};
	inputCommands.notice = function inputCommandMsg(event, command, line) {
	    handleMessage.call(this, 'notice', event, command, line);
	};
	
	inputCommands.ctcp = function inputCommandCtcp(event, command, line) {
	    event.handled = true;
	
	    var params = line.split(' ');
	    var target = params.shift();
	    var ctcpType = params.shift();
	
	    if (!ctcpType || !target) {
	        return;
	    }
	
	    var network = this.state.getActiveNetwork();
	    network.ircClient.ctcpRequest.apply(network.ircClient, [target, ctcpType].concat(params));
	};
	
	inputCommands.join = function inputCommandJoin(event, command, line) {
	    var _this5 = this;
	
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var bufferObjs = Misc.extractBuffers(line);
	
	    var hasSwitchedActiveBuffer = false;
	    bufferObjs.forEach(function (bufferObj) {
	        if (bufferObj.name === '0') {
	            return;
	        }
	
	        var chanName = network.isChannelName(bufferObj.name) ? bufferObj.name : '#' + bufferObj.name;
	
	        var newBuffer = _this5.state.addBuffer(network.id, chanName);
	
	        if (newBuffer && !hasSwitchedActiveBuffer) {
	            _this5.state.setActiveBuffer(network.id, newBuffer.name);
	            hasSwitchedActiveBuffer = true;
	        }
	
	        if (bufferObj.key) {
	            newBuffer.key = bufferObj.key;
	        }
	
	        network.ircClient.join(chanName, bufferObj.key);
	    });
	};
	
	inputCommands.part = function inputCommandPart(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var bufferNames = [];
	    var message = '';
	
	    if (line === '') {
	        bufferNames = [this.state.getActiveBuffer().name];
	    } else {
	        var lineParts = line.split(' ');
	        if (network.isChannelName(lineParts[0])) {
	            bufferNames = _lodash2.default.compact(lineParts[0].split(','));
	            message = lineParts.slice(1).join(' ');
	        } else {
	            bufferNames = [this.state.getActiveBuffer().name];
	            message = line;
	        }
	    }
	
	    bufferNames.forEach(function (bufferName) {
	        network.ircClient.part(bufferName, message);
	    });
	};
	
	inputCommands.topic = function inputCommandTopic(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var bufferName = '';
	    var newTopic = '';
	
	    if (line === '') {
	        return;
	    }
	
	    var lineParts = line.split(' ');
	    if (network.isChannelName(lineParts[0])) {
	        bufferName = lineParts[0];
	        newTopic = lineParts.slice(1).join(' ');
	    } else {
	        bufferName = this.state.getActiveBuffer().name;
	        newTopic = line;
	    }
	
	    network.ircClient.setTopic(bufferName, newTopic);
	};
	
	inputCommands.kick = function inputCommandKick(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var toKick = '';
	    var bufferName = '';
	    var kickReason = '';
	
	    if (line === '') {
	        return;
	    }
	
	    var lineParts = line.split(' ');
	
	    if (network.isChannelName(lineParts[0])) {
	        bufferName = lineParts.shift();
	    }
	
	    toKick = lineParts.shift();
	    kickReason = lineParts.join(' ');
	
	    if (!bufferName) {
	        bufferName = this.state.getActiveBuffer().name;
	    }
	    if (!toKick) {
	        return;
	    }
	
	    network.ircClient.raw('KICK', bufferName, toKick, kickReason);
	};
	
	inputCommands.ignore = function inputCommandIgnore(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var toIgnore = line.split(' ').shift();
	
	    if (!toIgnore) {
	        return;
	    }
	
	    var user = this.state.getUser(network.id, toIgnore);
	    if (user) {
	        user.ignore = true;
	        var buffer = this.state.getActiveBuffer();
	        this.state.addMessage(buffer, {
	            nick: '*',
	            message: 'Ignoring ' + user.nick,
	            type: 'message'
	        });
	    }
	};
	
	inputCommands.unignore = function inputCommandUnignore(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var toUnignore = line.split(' ').shift();
	
	    if (!toUnignore) {
	        return;
	    }
	
	    var user = this.state.getUser(network.id, toUnignore);
	    if (user) {
	        user.ignore = false;
	        var buffer = this.state.getActiveBuffer();
	        this.state.addMessage(buffer, {
	            nick: '*',
	            message: 'No longer ignoring ' + user.nick,
	            type: 'message'
	        });
	    }
	};
	
	inputCommands.close = function inputCommandClose(event, command, line) {
	    var _this6 = this;
	
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var bufferNames = _lodash2.default.compact(line.split(/[, ]/));
	    if (bufferNames.length === 0) {
	        bufferNames = [this.state.getActiveBuffer().name];
	    }
	
	    bufferNames.forEach(function (bufferName) {
	        var buffer = network.bufferByName(bufferName);
	        if (!buffer) {
	            return;
	        }
	
	        network.ircClient.part(bufferName);
	        _this6.state.removeBuffer(buffer);
	    });
	};
	
	inputCommands.query = function inputCommandQuery(event, command, line) {
	    var _this7 = this;
	
	    event.handled = true;
	
	    var nicks = line.split(' ');
	    var network = this.state.getActiveNetwork();
	
	    var hasSwitchedActiveBuffer = false;
	    nicks.forEach(function (bufferName, idx) {
	        var newBuffer = _this7.state.addBuffer(network.id, bufferName);
	
	        if (newBuffer && !hasSwitchedActiveBuffer) {
	            _this7.state.setActiveBuffer(network.id, newBuffer.name);
	            hasSwitchedActiveBuffer = true;
	        }
	    });
	};
	
	inputCommands.invite = function inputCommandInvite(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var buffer = this.state.getActiveBuffer();
	
	    var lineParts = line.split(' ');
	    var nick = lineParts.shift();
	    var channel = lineParts.shift();
	
	    if (!channel) {
	        channel = buffer.name;
	    }
	
	    if (!network.isChannelName(channel)) {
	        return;
	    }
	
	    network.ircClient.raw('INVITE', nick, channel);
	    this.state.addMessage(buffer, {
	        nick: '*',
	        message: 'Invited ' + nick + ' to ' + channel,
	        type: 'message'
	    });
	};
	
	inputCommands.nick = function inputCommandNick(event, command, line) {
	    event.handled = true;
	
	    var spaceIdx = line.indexOf(' ');
	    if (spaceIdx === -1) spaceIdx = line.length;
	
	    var newNick = line.substr(0, spaceIdx);
	    var network = this.state.getActiveNetwork();
	    network.ircClient.changeNick(newNick);
	};
	
	inputCommands.quote = function inputCommandQuote(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    network.ircClient.raw(line);
	};
	
	inputCommands.whois = function inputCommandWhois(event, command, line) {
	    var _this8 = this;
	
	    event.handled = true;
	
	    var parts = line.split(' ');
	    var network = this.state.getActiveNetwork();
	    var buffer = this.state.getActiveBuffer();
	
	    network.ircClient.whois(parts[0], parts[0], function (whoisData) {
	        var out = [];
	        var display = function display(message) {
	            if (!message) {
	                return;
	            }
	
	            out.push(message);
	        };
	        var formats = {
	            account: 'User account: {{account}}',
	            server: 'Connected to server {{server}} ({{server_info}})',
	            secure: 'Using a secure connection',
	            channels: 'Also on channels {{channels}}',
	            mask: '{{nick}}!{{user}}@{{host}} ({{real_name}})',
	            idle: 'Idle for {{idle}} seconds',
	            logon: 'Connected at {{logon}}',
	            actualip: 'Real IP: {{actualip}}',
	            actualhost: 'Real hostname: {{actualhost}}',
	
	            nick: '',
	            user: '',
	            host: '',
	            real_name: '',
	            server_info: ''
	        };
	
	        if (whoisData.account) {
	            display(formats.account.replace('{{account}}', whoisData.account));
	        }
	        if (whoisData.nick) {
	            display(formats.mask.replace('{{nick}}', whoisData.nick).replace('{{user}}', whoisData.user).replace('{{host}}', whoisData.host).replace('{{real_name}}', whoisData.real_name));
	        }
	        if (whoisData.server) {
	            display(formats.server.replace('{{server}}', whoisData.server).replace('{{server_info}}', whoisData.server_info));
	        }
	        if (whoisData.secure) {
	            display(formats.secure);
	        }
	        if (whoisData.idle) {
	            var idleSeconds = Math.floor(parseInt(whoisData.idle, 10) / 1000);
	            display(formats.idle.replace('{{idle}}', idleSeconds));
	        }
	        if (whoisData.logon) {
	            var logonTime = parseInt(whoisData.logon, 10);
	            if (!isNaN(logonTime)) {
	                var logonDate = new Date(logonTime * 1000);
	                display(formats.logon.replace('{{logon}}', logonDate));
	            }
	        }
	        if (whoisData.channels) {
	            display(formats.channels.replace('{{channels}}', whoisData.channels));
	        }
	        if (whoisData.actualip) {
	            display(formats.actualip.replace('{{actualip}}', whoisData.actualip));
	        }
	        if (whoisData.actualhost) {
	            display(formats.actualhost.replace('{{actualhost}}', whoisData.actualhost));
	        }
	
	        _lodash2.default.each(whoisData, function (val, key) {
	            if (typeof formats[key] === 'undefined') {
	                display(key + ': ' + val);
	            }
	        });
	
	        out.forEach(function (l) {
	            _this8.state.addMessage(buffer, {
	                nick: parts[0],
	                message: l,
	                type: 'whois'
	            });
	        });
	    });
	};
	
	inputCommands.mode = function inputCommandMode(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var target = network.nick;
	
	    var parts = _lodash2.default.compact(line.split(' '));
	
	    if (line && line[0] !== '+' && line[0] !== '-') {
	        target = parts.shift();
	    }
	
	    if (parts[0]) {
	        network.ircClient.mode(target, parts[0], parts[1]);
	    } else {
	        network.ircClient.mode(target);
	    }
	};
	
	inputCommands.names = function inputCommandNames(event, command, line) {
	    event.handled = true;
	
	    var network = this.state.getActiveNetwork();
	    var args = line;
	
	    if (!args) {
	        args = this.state.getActiveBuffer().name;
	    }
	
	    network.ircClient.raw('NAMES ' + args);
	};
	
	inputCommands.clear = function inputCommandClear(event, command, line) {
	    event.handled = true;
	
	    var buffer = this.state.getActiveBuffer();
	    var messages = buffer.getMessages();
	    messages.splice(0, messages.length);
	
	    this.state.addMessage(buffer, {
	        nick: '*',
	        message: 'Scrollback cleared'
	    });
	};
	
	inputCommands.echo = function inputCommandEcho(event, command, line) {
	    event.handled = true;
	
	    var buffer = this.state.getActiveBuffer();
	
	    this.state.addMessage(buffer, {
	        nick: '*',
	        message: line
	    });
	};
	
	inputCommands.server = function inputCommandServer(event, command, line) {
	    event.handled = true;
	
	    var parts = line.split(' ');
	    var serverAddr = parts[0];
	    var serverPort = parts[1] || 6667;
	    var serverTls = false;
	    var serverPassword = parts[2];
	    var nick = parts[3] || 'ircuser';
	
	    if (serverPort[0] === '+') {
	        serverTls = true;
	        serverPort = parseInt(serverPort.substr(1), 10);
	    } else {
	        serverTls = false;
	        serverPort = parseInt(serverPort, 10);
	    }
	
	    this.state.addNetwork(serverAddr, nick, {
	        server: serverAddr,
	        port: serverPort,
	        tls: serverTls,
	        password: serverPassword
	    });
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.create = create;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _strftime = __webpack_require__(71);
	
	var _strftime2 = _interopRequireDefault(_strftime);
	
	var _browser = __webpack_require__(176);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _BouncerMiddleware = __webpack_require__(161);
	
	var _BouncerMiddleware2 = _interopRequireDefault(_BouncerMiddleware);
	
	var _ServerConnection = __webpack_require__(169);
	
	var ServerConnection = _interopRequireWildcard(_ServerConnection);
	
	var _TextFormatting = __webpack_require__(35);
	
	var TextFormatting = _interopRequireWildcard(_TextFormatting);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function create(state, networkid) {
	    var network = state.getNetwork(networkid);
	
	    var clientOpts = {
	        host: network.connection.server,
	        port: network.connection.port,
	        tls: network.connection.tls,
	        path: network.connection.path,
	        password: network.connection.password,
	        nick: network.nick,
	        username: network.username || network.nick,
	        gecos: network.gecos || 'https://kiwiirc.com/',
	        version: null,
	        auto_reconnect: false,
	        encoding: network.connection.encoding
	    };
	
	    if (!network.connection.direct) {
	        clientOpts.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
	    }
	
	    var ircClient = new _browser2.default.Client(clientOpts);
	    ircClient.requestCap('znc.in/self-message');
	    ircClient.use(clientMiddleware(state, networkid));
	    ircClient.use((0, _BouncerMiddleware2.default)());
	
	    var originalIrcClientConnect = ircClient.connect;
	    ircClient.connect = function connect() {
	        var bnc = state.setting('bnc');
	        if (bnc.active) {
	            var netname = network.connection.bncname;
	            var password = '';
	
	            if (network.name === 'bnccontrol') {
	                password = bnc.username + ':' + bnc.password;
	            } else {
	                password = bnc.username + '/' + netname + ':' + bnc.password;
	            }
	
	            ircClient.options.host = bnc.server;
	            ircClient.options.port = bnc.port;
	            ircClient.options.tls = bnc.tls;
	            ircClient.options.password = password;
	            ircClient.options.nick = network.nick;
	            ircClient.options.encoding = network.connection.encoding;
	        } else {
	            ircClient.options.host = network.connection.server;
	            ircClient.options.port = network.connection.port;
	            ircClient.options.tls = network.connection.tls;
	            ircClient.options.password = network.connection.password;
	            ircClient.options.nick = network.nick;
	            ircClient.options.username = network.username || network.nick;
	            ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
	            ircClient.options.encoding = network.connection.encoding;
	        }
	
	        state.$emit('network.connecting', { network: network });
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        originalIrcClientConnect.apply(ircClient, args);
	    };
	
	    ircClient.on('raw', function (event) {
	        if (!network.setting('show_raw')) {
	            return;
	        }
	
	        var buffer = state.getOrAddBufferByName(networkid, '*raw');
	        state.addMessage(buffer, {
	            time: Date.now(),
	            nick: '',
	            message: (event.from_server ? '[S] ' : '[C] ') + event.line
	        });
	    });
	
	    return ircClient;
	}
	
	function clientMiddleware(state, networkid) {
	    var network = state.getNetwork(networkid);
	    var numConnects = 0;
	
	    var requestedCh = false;
	
	    return function middlewareFn(client, rawEvents, parsedEvents) {
	        parsedEvents.use(parsedEventsHandler);
	        rawEvents.use(rawEventsHandler);
	
	        client.on('connecting', function () {
	            network.state_error = '';
	            network.state = 'connecting';
	        });
	
	        client.on('connected', function () {
	            network.state_error = '';
	            network.state = 'connected';
	
	            network.buffers.forEach(function (buffer) {
	                if (!buffer) {
	                    return;
	                }
	
	                var messageBody = TextFormatting.formatText('network_connected', {
	                    text: 'Connected'
	                });
	
	                state.addMessage(buffer, {
	                    time: Date.now(),
	                    nick: '',
	                    message: messageBody,
	                    type: 'connection',
	                    type_extra: 'connected'
	                });
	            });
	        });
	
	        client.on('socket close', function (err) {
	            network.state = 'disconnected';
	            network.state_error = err || '';
	
	            network.buffers.forEach(function (buffer) {
	                if (!buffer) {
	                    return;
	                }
	
	                var messageBody = TextFormatting.formatText('network_disconnected', {
	                    text: 'Disconnected'
	                });
	
	                state.addMessage(buffer, {
	                    time: Date.now(),
	                    nick: '',
	                    message: messageBody,
	                    type: 'connection',
	                    type_extra: 'disconnected'
	                });
	            });
	        });
	    };
	
	    function rawEventsHandler(command, event, rawLine, client, next) {
	        state.$emit('irc:raw', command, event, network);
	        next();
	    }
	
	    function parsedEventsHandler(command, event, client, next) {
	        var ircEventObj = { handled: false };
	        state.$emit('irc:' + command, event, network, ircEventObj);
	        if (ircEventObj.handled) {
	            next();
	            return;
	        }
	
	        if (command === 'registered') {
	            if (client.options.nickserv) {
	                var options = client.options.nickserv;
	                client.say('nickserv', 'identify ' + options.account + ' ' + options.password);
	            }
	
	            network.nick = event.nick;
	            state.addUser(networkid, { nick: event.nick, username: client.user.username });
	
	            var serverBuffer = network.serverBuffer();
	            state.addMessage(serverBuffer, {
	                time: Date.now(),
	                nick: '',
	                message: 'Connected to ' + client.network.name + '!'
	            });
	
	            client.raw('WHO ' + event.nick);
	
	            if (network.auto_commands) {
	                network.auto_commands.split('\n').forEach(function (line) {
	                    state.$emit('input.raw', line[0] === '/' ? line : '/' + line);
	                });
	            }
	
	            if (!network.connection.bncname) {
	                network.buffers.forEach(function (buffer) {
	                    if (buffer.isChannel() && buffer.enabled) {
	                        client.join(buffer.name, buffer.key);
	                    }
	                });
	            }
	
	            requestedCh = false;
	            numConnects++;
	        }
	
	        if (command === 'server options') {
	            if (client.network.name !== 'Network') {
	                network.name = client.network.name;
	            }
	
	            var historySupport = !!network.ircClient.network.supports('chathistory');
	
	            if (numConnects > 1 && !requestedCh && historySupport && network.connection.bncname) {
	                requestedCh = true;
	                network.buffers.forEach(function (buffer) {
	                    if (buffer.isChannel() || buffer.isQuery()) {
	                        buffer.requestScrollback('forward');
	                    }
	                });
	            }
	
	            if (numConnects === 1 && !requestedCh && historySupport && network.connection.bncname) {
	                requestedCh = true;
	                var time = (0, _strftime2.default)('%FT%T.%L%:z', new Date());
	                network.ircClient.raw('CHATHISTORY * timestamp=' + time + ' message_count=-50');
	            }
	        }
	
	        if (command === 'unknown command') {
	            var buffer = network.serverBuffer();
	            var message = '';
	
	            if (!event.command.match(/^\d+$/)) {
	                message += event.command + ' ';
	            }
	
	            var containsNick = event.params[0] === network.ircClient.user.nick;
	            var isChannelMessage = network.isChannelName(event.params[1]);
	
	            if (containsNick && isChannelMessage) {
	                var channelBuffer = network.bufferByName(event.params[1]);
	                if (channelBuffer) {
	                    buffer = channelBuffer;
	                }
	                message += event.params.slice(2).join(', ');
	            } else if (containsNick) {
	                message += event.params.slice(1).join(', ');
	            } else {
	                message += event.params.join(', ');
	            }
	
	            state.addMessage(buffer, {
	                nick: '',
	                message: message
	            });
	        }
	
	        if (command === 'message') {
	            var isPrivateMessage = false;
	            var bufferName = event.from_server ? '*' : event.target;
	
	            if (!event.from_server && event.target === client.user.nick) {
	                isPrivateMessage = true;
	                bufferName = event.nick;
	            }
	
	            if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
	                bufferName = event.message.substr(1, event.message.indexOf(']') - 1);
	            }
	
	            if (event.type === 'notice') {
	                var existingBuffer = state.getBufferByName(networkid, bufferName);
	                if (!existingBuffer) {
	                    bufferName = '*';
	                }
	            }
	
	            var _buffer = state.getOrAddBufferByName(networkid, bufferName);
	
	            var textFormatType = 'privmsg';
	            if (event.type === 'action') {
	                textFormatType = 'action';
	            } else if (event.type === 'notice') {
	                textFormatType = 'notice';
	            }
	
	            var messageBody = TextFormatting.formatText(textFormatType, {
	                nick: event.nick,
	                username: event.ident,
	                host: event.hostname,
	                text: event.message
	            });
	
	            state.addMessage(_buffer, {
	                time: event.time || Date.now(),
	                nick: event.nick,
	                message: messageBody,
	                type: event.type,
	                tags: event.tags
	            });
	        }
	
	        if (command === 'wallops') {
	            var _buffer2 = state.getOrAddBufferByName(networkid, '*');
	            var _messageBody = TextFormatting.formatText('wallops', {
	                text: event.message
	            });
	
	            state.addMessage(_buffer2, {
	                time: event.time || Date.now(),
	                nick: event.nick,
	                message: _messageBody,
	                type: 'wallops'
	            });
	        }
	
	        if (command === 'join') {
	            var _buffer3 = state.getOrAddBufferByName(networkid, event.channel);
	            state.addUserToBuffer(_buffer3, {
	                nick: event.nick,
	                username: event.ident,
	                host: event.hostname,
	                realname: event.gecos
	            });
	
	            if (event.nick === client.user.nick) {
	                _buffer3.joined = true;
	                network.ircClient.raw('MODE', event.channel);
	                network.ircClient.who(event.channel);
	            }
	
	            var _messageBody2 = TextFormatting.formatText('channel_join', {
	                nick: event.nick,
	                username: event.ident,
	                host: event.hostname,
	                text: 'has joined'
	            });
	
	            state.addMessage(_buffer3, {
	                time: Date.now(),
	                nick: event.nick,
	                message: _messageBody2,
	                type: 'traffic',
	                type_extra: 'join'
	            });
	        }
	        if (command === 'kick') {
	            var _buffer4 = state.getOrAddBufferByName(networkid, event.channel);
	            state.removeUserFromBuffer(_buffer4, event.kicked);
	
	            var _messageBody3 = '';
	
	            if (event.kicked === client.user.nick) {
	                _buffer4.joined = false;
	                _buffer4.clearUsers();
	                _messageBody3 = TextFormatting.formatText('channel_selfkick', {
	                    nick: event.nick,
	                    username: event.ident,
	                    host: event.hostname,
	                    text: event.nick + ' kicked you from ' + event.channel + ' (' + event.message + ')'
	                });
	            } else {
	                _messageBody3 = TextFormatting.formatText('channel_kicked', {
	                    nick: event.nick,
	                    username: event.ident,
	                    host: event.hostname,
	                    text: event.kicked + ' was kicked from ' + event.channel + ' by ' + event.nick + (' (' + event.message + ')')
	                });
	            }
	
	            state.addMessage(_buffer4, {
	                time: Date.now(),
	                nick: event.nick,
	                message: _messageBody3,
	                type: 'traffic',
	                type_extra: 'kick'
	            });
	        }
	        if (command === 'part') {
	            var _buffer5 = state.getBufferByName(networkid, event.channel);
	            if (!_buffer5) {
	                return;
	            }
	
	            state.removeUserFromBuffer(_buffer5, event.nick);
	            if (event.nick === client.user.nick) {
	                _buffer5.joined = false;
	                _buffer5.clearUsers();
	            }
	
	            var _messageBody4 = TextFormatting.formatText('channel_part', {
	                nick: event.nick,
	                username: event.ident,
	                host: event.hostname,
	                text: 'has left (' + event.message + ')'
	            });
	            state.addMessage(_buffer5, {
	                time: Date.now(),
	                nick: event.nick,
	                message: _messageBody4,
	                type: 'traffic',
	                type_extra: 'part'
	            });
	        }
	        if (command === 'quit') {
	            var buffers = state.getBuffersWithUser(networkid, event.nick);
	
	            buffers.forEach(function (buffer) {
	                if (!buffer) {
	                    return;
	                }
	
	                if (event.nick === client.user.nick) {
	                    buffer.joined = false;
	                    buffer.clearUsers();
	                }
	
	                var messageBody = TextFormatting.formatText('channel_quit', {
	                    nick: event.nick,
	                    username: event.ident,
	                    host: event.hostname,
	                    text: 'has left (' + event.message + ')'
	                });
	
	                state.addMessage(buffer, {
	                    time: Date.now(),
	                    nick: event.nick,
	                    message: messageBody,
	                    type: 'traffic',
	                    type_extra: 'quit'
	                });
	            });
	
	            var queryBuffer = network.bufferByName(event.nick);
	            if (queryBuffer) {
	                var _messageBody5 = TextFormatting.formatText('channel_quit', {
	                    nick: event.nick,
	                    username: event.ident,
	                    host: event.hostname,
	                    text: 'has left (' + event.message + ')'
	                });
	
	                state.addMessage(queryBuffer, {
	                    time: Date.now(),
	                    nick: event.nick,
	                    message: _messageBody5,
	                    type: 'traffic',
	                    type_extra: 'quit'
	                });
	            }
	
	            state.removeUser(networkid, {
	                nick: event.nick
	            });
	        }
	
	        if (command === 'invite') {
	            var _buffer6 = network.serverBuffer();
	            state.addMessage(_buffer6, {
	                nick: '*',
	                message: event.nick + ' invited you to join ' + event.channel
	            });
	        }
	
	        if (command === 'whois') {
	            var obj = {
	                nick: event.nick,
	                host: event.host,
	                username: event.user,
	                away: event.away || '',
	                realname: event.real_name
	            };
	
	            ['actuallhost', 'helpop', 'bot', 'server', 'server_info', 'operator', 'channels', 'modes', 'idle', 'logon', 'registered_nick', 'account', 'secure', 'special'].forEach(function (prop) {
	                if (typeof event[prop] !== 'undefined') {
	                    obj[prop] = event[prop];
	                }
	            });
	
	            state.addUser(networkid, obj);
	        }
	
	        if (command === 'away') {
	            state.addUser(networkid, {
	                nick: event.nick,
	                away: event.message || ''
	            });
	        }
	
	        if (command === 'wholist') {
	            state.usersTransaction(networkid, function (users) {
	                event.users.forEach(function (user) {
	                    var userObj = {
	                        nick: user.nick,
	                        host: user.hostname || undefined,
	                        username: user.ident || undefined,
	                        away: user.away ? 'Away' : '',
	                        realname: user.real_name
	                    };
	                    state.addUser(networkid, userObj, users);
	                });
	            });
	        }
	
	        if (command === 'channel list start') {
	            network.channel_list_cache = [];
	            network.channel_list_state = 'updating';
	        }
	        if (command === 'channel list') {
	            network.channel_list_cache = network.channel_list_cache.concat(event);
	        }
	        if (command === 'channel list end') {
	            network.channel_list = network.channel_list_cache;
	            delete network.channel_list_cache;
	            network.channel_list_state = '';
	        }
	
	        if (command === 'motd') {
	            var _buffer7 = network.serverBuffer();
	            var _messageBody6 = TextFormatting.formatText('motd', {
	                text: event.motd
	            });
	            state.addMessage(_buffer7, {
	                time: event.time || Date.now(),
	                nick: '',
	                message: _messageBody6,
	                type: 'motd'
	            });
	        }
	
	        if (command === 'nick in use' && !client.connection.registered) {
	            var newNick = client.user.nick + rand(1, 100);
	            var _serverBuffer = network.serverBuffer();
	            var _messageBody7 = TextFormatting.formatText('nickname_alreadyinuse', {
	                text: 'Nickname \'' + client.user.nick + '\' is already in use. Trying \'' + newNick + '\'..'
	            });
	            state.addMessage(_serverBuffer, {
	                time: Date.now(),
	                nick: '',
	                message: _messageBody7
	            });
	            client.changeNick(newNick);
	        }
	
	        if (command === 'nick') {
	            if (event.nick === client.user.nick) {
	                network.nick = event.new_nick;
	            }
	
	            state.changeUserNick(networkid, event.nick, event.new_nick);
	
	            var _messageBody8 = TextFormatting.formatText('nick_changed', {
	                text: event.nick + ' is now known as ' + event.new_nick
	            });
	
	            var _buffers = state.getBuffersWithUser(networkid, event.new_nick);
	            _buffers.forEach(function (buffer) {
	                state.addMessage(buffer, {
	                    time: event.time || Date.now(),
	                    nick: '',
	                    message: _messageBody8,
	                    type: 'nick'
	                });
	            });
	        }
	
	        if (command === 'userlist') {
	            var _buffer8 = state.getOrAddBufferByName(networkid, event.channel);
	            var users = [];
	            event.users.forEach(function (user) {
	                users.push({
	                    user: {
	                        nick: user.nick,
	                        username: user.ident,
	                        hostname: user.hostname
	                    },
	                    modes: user.modes
	                });
	            });
	            state.addMultipleUsersToBuffer(_buffer8, users);
	        }
	
	        if (command === 'channel info') {
	            var _buffer9 = network.bufferByName(event.channel);
	            if (!_buffer9) {
	                return;
	            }
	
	            if (event.modes) {
	                event.modes.forEach(function (mode) {
	                    var adding = mode.mode[0] === '+';
	                    var modeChar = mode.mode.substr(1);
	
	                    if (adding) {
	                        state.$set(_buffer9.modes, modeChar, mode.param);
	                    } else if (!adding) {
	                        state.$delete(_buffer9.modes, modeChar);
	                    }
	                });
	            }
	        }
	
	        if (command === 'mode') {
	            var _buffer10 = network.bufferByName(event.target);
	            if (_buffer10) {
	                event.modes.forEach(function (mode) {
	                    var messageBody = TextFormatting.formatText('mode', {
	                        nick: event.nick,
	                        username: event.ident,
	                        host: event.hostname,
	                        text: 'set ' + mode.mode + ' ' + (mode.param || '')
	                    });
	                    state.addMessage(_buffer10, {
	                        time: event.time || Date.now(),
	                        nick: '',
	                        message: messageBody,
	                        type: 'mode'
	                    });
	
	                    var prefix = _lodash2.default.find(network.ircClient.network.options.PREFIX, {
	                        mode: mode.mode[1]
	                    });
	
	                    if (prefix) {
	                        var user = state.getUser(network.id, mode.param);
	                        if (user) {
	                            var adding = mode.mode[0] === '+';
	                            var modes = user.buffers[_buffer10.id].modes;
	                            var modeIdx = modes.indexOf(prefix.mode);
	
	                            if (adding && modeIdx === -1) {
	                                modes.push(prefix.mode);
	                            } else if (!adding && modeIdx > -1) {
	                                modes.splice(modeIdx, 1);
	                            }
	                        }
	                    } else {
	                        var _adding = mode.mode[0] === '+';
	                        var modeChar = mode.mode.substr(1);
	
	                        if (_adding) {
	                            state.$set(_buffer10.modes, modeChar, mode.param);
	                        } else if (!_adding) {
	                            state.$delete(_buffer10.modes, modeChar);
	                        }
	                    }
	                });
	            }
	        }
	
	        if (command === 'topic') {
	            var _buffer11 = state.getOrAddBufferByName(networkid, event.channel);
	            _buffer11.topic = event.topic || '';
	            var _messageBody9 = TextFormatting.formatText('channel_topic', {
	                nick: event.nick,
	                username: event.ident,
	                host: event.hostname,
	                text: event.nick ? event.nick + ' changed the topic to: ' + event.topic : event.topic
	            });
	            state.addMessage(_buffer11, {
	                time: event.time || Date.now(),
	                nick: '',
	                message: _messageBody9,
	                type: 'topic'
	            });
	        }
	
	        if (command === 'ctcp response' || command === 'ctcp request') {
	            var _buffer12 = network.bufferByName(event.target) || network.serverBuffer();
	            var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';
	            var _messageBody10 = TextFormatting.formatText(textFormatId, {
	                nick: event.nick,
	                message: event.message,
	                type: event.type
	            });
	
	            state.addMessage(_buffer12, {
	                time: event.time || Date.now(),
	                nick: '',
	                message: _messageBody10,
	                type: 'error'
	            });
	
	            if (command === 'ctcp request' && event.type === 'VERSION') {
	                client.ctcpResponse(event.nick, 'VERSION', 'Kiwi IRC');
	            }
	        }
	
	        if (command === 'irc error') {
	            var _buffer13 = void 0;
	            if (event.channel) {
	                _buffer13 = state.getOrAddBufferByName(network.id, event.channel);
	            }
	            if (!_buffer13) {
	                _buffer13 = network.serverBuffer();
	            }
	
	            if (event.reason) {
	                var _messageBody11 = TextFormatting.formatText('general_error', {
	                    text: event.reason || event.error
	                });
	                state.addMessage(_buffer13, {
	                    time: event.time || Date.now(),
	                    nick: '',
	                    message: _messageBody11,
	                    type: 'error'
	                });
	            }
	        }
	
	        next();
	    }
	}
	
	function rand(min, max) {
	    return Math.floor(Math.random() * (max - min + 1) + min);
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TextFormatting = __webpack_require__(35);
	
	var TextFormatting = _interopRequireWildcard(_TextFormatting);
	
	var _MessageFormatter = __webpack_require__(166);
	
	var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);
	
	var _GlobalApi = __webpack_require__(36);
	
	var _GlobalApi2 = _interopRequireDefault(_GlobalApi);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nextId = 0;
	
	var Message = function () {
	    function Message(message, user) {
	        (0, _classCallCheck3.default)(this, Message);
	
	        this.id = message.tags && message.tags['draft/msgid'] ? message.tags['draft/msgid'] : nextId++;
	        this.time = message.time || Date.now();
	        this.nick = message.nick;
	        this.message = message.message;
	        this.tags = message.tags;
	        this.type = message.type || 'message';
	        this.type_extra = message.type_extra;
	        this.ignore = false;
	        this.mentioned_urls = [];
	        this.html = '';
	
	        Object.defineProperty(this, 'user', {
	            value: user
	        });
	    }
	
	    (0, _createClass3.default)(Message, [{
	        key: 'toHtml',
	        value: function toHtml(messageList) {
	            var _this = this;
	
	            if (this.html) {
	                return this.html;
	            }
	
	            _GlobalApi2.default.singleton().emit('message:render', { message: this });
	            if (this.html) {
	                return this.html;
	            }
	
	            var showEmoticons = _state2.default.setting('buffers.show_emoticons') && !messageList.buffer.isSpecial();
	            var emojiList = _state2.default.setting('emojis');
	            var emojiLocation = _state2.default.setting('emojiLocation');
	            var userList = messageList.buffer.users;
	            var useExtraFormatting = !messageList.buffer.isSpecial() && messageList.useExtraFormatting && this.type === 'privmsg';
	
	            var html = '';
	            var blocks = (0, _MessageFormatter2.default)(this.message, {
	                extras: useExtraFormatting
	            });
	
	            blocks.forEach(function (bl, idx) {
	                var style = '';
	                var classes = '';
	
	                (0, _keys2.default)(bl.styles).forEach(function (s) {
	                    if (s === 'underline') {
	                        style += 'text-decoration:underline;';
	                    } else if (s === 'bold') {
	                        style += 'font-weight:bold;';
	                    } else if (s === 'italic') {
	                        style += 'font-style:italic;';
	                    } else if (s === 'quote') {
	                        classes += 'kiwi-formatting-extras-quote ';
	                    } else if (s === 'block') {
	                        classes += 'kiwi-formatting-extras-block ';
	                    } else if (s === 'color') {
	                        classes += 'irc-fg-colour-' + bl.styles[s] + ' ';
	                    } else if (s === 'background') {
	                        classes += 'irc-bg-colour-' + bl.styles[s] + ' ';
	                    }
	                });
	
	                var content = _this.enrichText(bl.content, showEmoticons, emojiList, emojiLocation, userList);
	
	                if (style === '' && classes === '') {
	                    html += content;
	                } else if (style !== '' && classes !== '') {
	                    html += '<span style="' + style + '" class="' + classes + '">' + content + '</span>';
	                } else if (style !== '') {
	                    html += '<span style="' + style + '">' + content + '</span>';
	                } else if (classes !== '') {
	                    html += '<span class="' + classes + '">' + content + '</span>';
	                }
	            });
	
	            this.html = html;
	            return this.html;
	        }
	    }, {
	        key: 'enrichText',
	        value: function enrichText(text, showEmoticons, emojiList, emojiLocation, userList) {
	            var _this2 = this;
	
	            var words = text.split(' ');
	            words = words.map(function (word, wordIdx) {
	                var parsed = void 0;
	
	                var linkified = TextFormatting.linkifyUrls(word, {
	                    addHandle: true,
	                    handleClass: 'fa fa-chevron-right kiwi-messagelist-message-linkhandle'
	                });
	                if (linkified.urls.length > 0) {
	                    _this2.mentioned_urls = _this2.mentioned_urls.concat(linkified.urls);
	                }
	                if (linkified.html !== word) return linkified.html;
	
	                parsed = TextFormatting.linkifyChannels(word);
	                if (parsed !== word) return parsed;
	
	                parsed = TextFormatting.linkifyUsers(word, userList);
	                if (parsed !== word) return parsed;
	
	                if (showEmoticons) {
	                    parsed = TextFormatting.addEmojis({ word: word, words: words, wordIdx: wordIdx }, emojiList, emojiLocation);
	                    if (parsed !== word) return parsed;
	                }
	
	                return _lodash2.default.escape(word);
	            });
	
	            return words.join(' ');
	        }
	    }]);
	    return Message;
	}();
	
	exports.default = Message;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.default = parse;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tokens = (0, _create2.default)(null);
	
	tokens['_'] = {
	    token: '_',
	    extra: true,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.underline;
	            openToks[this.token] = null;
	            prevBlock.content += this.token;
	            return null;
	        }
	
	        if (block.styles.underline === true) {
	            return -1;
	        }
	
	        if (pos > 0 && inp[pos - 1] !== ' ') {
	            return -1;
	        }
	
	        if (inp.substr(pos).indexOf(this.token) === -1) {
	            return -1;
	        }
	
	        openToks[this.token] = true;
	        block.styles.underline = true;
	        block.content += this.token;
	
	        return null;
	    }
	};
	tokens['*'] = {
	    token: '*',
	    extra: true,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.bold;
	            openToks[this.token] = null;
	            prevBlock.content += this.token;
	            return null;
	        }
	
	        if (block.styles.bold === true) {
	            return -1;
	        }
	
	        if (inp[pos - 1] === ':') {
	            return -1;
	        }
	
	        if (inp.substr(pos + 1).indexOf(this.token) === -1) {
	            return -1;
	        }
	
	        openToks[this.token] = true;
	        block.styles.bold = true;
	        block.content += this.token;
	
	        return null;
	    }
	};
	tokens['**'] = {
	    token: '**',
	    extra: true,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.italic;
	            openToks[this.token] = null;
	            prevBlock.content += this.token;
	            return null;
	        }
	
	        if (block.styles.italic === true) {
	            return -1;
	        }
	
	        if (inp.substr(pos).indexOf(this.token) > -1) {
	            openToks[this.token] = true;
	            block.styles.italic = true;
	            block.content += this.token;
	        }
	
	        return null;
	    }
	};
	tokens['`'] = {
	    token: '`',
	    extra: true,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.quote;
	            openToks[this.token] = null;
	            prevBlock.content += this.token;
	            return null;
	        }
	
	        var str = inp.substr(pos + 1);
	        var endPos = str.indexOf(this.token);
	        if (endPos === -1) {
	            return -1;
	        }
	
	        openToks[this.token] = true;
	        block.styles.quote = true;
	        block.content += this.token + str.substr(0, endPos);
	        block.containsContent = true;
	
	        return pos + endPos + 1;
	    }
	};
	
	tokens['\x02'] = {
	    token: '\x02',
	    extra: false,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.bold;
	            openToks[this.token] = null;
	        } else {
	            openToks[this.token] = true;
	            block.styles.bold = true;
	        }
	
	        return null;
	    }
	};
	
	tokens['\x1D'] = {
	    token: '\x1D',
	    extra: false,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.italic;
	            openToks[this.token] = null;
	        } else {
	            openToks[this.token] = true;
	            block.styles.italic = true;
	        }
	
	        return null;
	    }
	};
	
	tokens['\x1F'] = {
	    token: '\x1F',
	    extra: false,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        if (openToks[this.token]) {
	            delete block.styles.underline;
	            openToks[this.token] = null;
	        } else {
	            openToks[this.token] = true;
	            block.styles.underline = true;
	        }
	
	        return null;
	    }
	};
	
	tokens['\x0F'] = {
	    token: '\x0F',
	    extra: false,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        (0, _keys2.default)(block.styles).forEach(function (k) {
	            return delete block.styles[k];
	        });
	        (0, _keys2.default)(openToks).forEach(function (k) {
	            return delete openToks[k];
	        });
	
	        return null;
	    }
	};
	
	tokens['\x03'] = {
	    token: '\x03',
	    extra: false,
	    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
	        var colours = {
	            0: 'white',
	            1: 'black',
	            2: 'blue',
	            3: 'green',
	            4: 'light-red',
	            5: 'brown',
	            6: 'purple',
	            7: 'orange',
	            8: 'yellow',
	            9: 'light-green',
	            10: 'cyan',
	            11: 'light-cyan',
	            12: 'light-blue',
	            13: 'pink',
	            14: 'grey',
	            15: 'light-grey'
	        };
	
	        var colourMatchRegexp = /^\x03(([0-9][0-9]?)(,([0-9][0-9]?))?)/;
	        var match = colourMatchRegexp.exec(inp.substr(pos, 6));
	        if (match) {
	            var fgColour = colours[parseInt(match[2], 10)];
	            var bgColour = colours[parseInt(match[4], 10)];
	            if (typeof fgColour !== 'undefined') {
	                block.styles.color = fgColour;
	            }
	            if (typeof bgColour !== 'undefined') {
	                block.styles.background = bgColour;
	            }
	
	            return pos + match[0].length;
	        }
	
	        delete block.styles.color;
	        delete block.styles.background;
	
	        return null;
	    }
	};
	
	function parse(inp, _opts) {
	    var opts = _opts || {};
	    var block = createNewBlock();
	    var blocks = [block];
	    var openTokens = (0, _create2.default)(null);
	
	    var pos = 0;
	    var len = inp.length;
	
	    while (pos < len) {
	        var tok = findTokenAtPosition();
	        if (!tok || !opts.extras && tok.extra) {
	            block.content += inp[pos];
	            block.containsContent = true;
	            pos++;
	            continue;
	        }
	
	        var newBlock = null;
	
	        if (block.containsContent) {
	            newBlock = createNewBlock();
	        } else {
	            newBlock = block;
	        }
	
	        (0, _assign2.default)(newBlock.styles, block.styles);
	        var newPos = tok.fn(inp, pos, newBlock, block, openTokens);
	
	        if (newPos === -1) {
	            block.content += tok.token;
	            block.containsContent = true;
	            pos += tok.token.length;
	            continue;
	        }
	
	        block = newBlock;
	
	        if (blocks[blocks.length - 1] !== newBlock) {
	            blocks.push(newBlock);
	        }
	
	        if (typeof newPos === 'number') {
	            pos = newPos;
	        } else {
	            pos += tok.token.length;
	        }
	    }
	
	    return blocks;
	
	    function findTokenAtPosition() {
	        var tok = tokens[inp.substr(pos, 2)] || tokens[inp[pos]];
	        return tok;
	    }
	
	    function createNewBlock() {
	        var newBlock = {
	            styles: {},
	            content: '',
	            containsContent: false
	        };
	        return newBlock;
	    }
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _eventEmitter = __webpack_require__(93);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkProvider = function () {
	    function NetworkProvider() {
	        (0, _classCallCheck3.default)(this, NetworkProvider);
	
	        (0, _eventEmitter2.default)(this);
	        this.providers = [];
	    }
	
	    (0, _createClass3.default)(NetworkProvider, [{
	        key: 'addProvider',
	        value: function addProvider(provider) {
	            var _this = this;
	
	            this.providers.push(provider);
	            provider.on('networks', function (networks) {
	                _this.emit('networks', _this.availableNetworks());
	            });
	        }
	    }, {
	        key: 'availableNetworks',
	        value: function availableNetworks() {
	            var networks = (0, _create2.default)(null);
	
	            this.providers.forEach(function (provider) {
	                var pType = provider.type;
	                if (provider.networks.length > 0) {
	                    networks[pType] = networks[pType] || [];
	                    networks[pType] = networks[pType].concat(provider.networks);
	                }
	            });
	
	            return networks;
	        }
	    }]);
	    return NetworkProvider;
	}();
	
	exports.default = NetworkProvider;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.requestPermission = requestPermission;
	exports.show = show;
	exports.listenForNewMessages = listenForNewMessages;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEnabled = false;
	
	function requestPermission() {
	    if (!('Notification' in window)) {
	        isEnabled = false;
	        return;
	    }
	
	    if (Notification.permission === 'granted') {
	        isEnabled = true;
	    }
	
	    if (Notification.permission !== 'denied') {
	        Notification.requestPermission(function (permission) {
	            if (permission === 'granted') {
	                isEnabled = true;
	            } else {
	                isEnabled = false;
	            }
	        });
	    }
	}
	
	function show(title, body, opts) {
	    if (!isEnabled) {
	        return false;
	    }
	
	    var notify = new Notification(title, {
	        body: body,
	        icon: opts.icon
	    });
	
	    if (opts.ttl) {
	        setTimeout(notify.close.bind(notify), opts.ttl);
	    }
	
	    return notify;
	}
	
	var throttledShow = _lodash2.default.throttle(show, 2000);
	
	function listenForNewMessages(state) {
	    state.$on('notification.show', function (message, _opts) {
	        if (!isEnabled) {
	            return;
	        }
	
	        var opts = (0, _assign2.default)({
	            title: 'Kiwi IRC',
	            message: message,
	            icon: '',
	            onclick: null,
	            ttl: 10000
	        }, _opts);
	
	        if (!opts.message) {
	            return;
	        }
	
	        var notification = throttledShow(opts.title, opts.message, {
	            ttl: opts.ttl
	        });
	
	        if (notification && typeof opts.onclick === 'function') {
	            notification.onclick = opts.onclick;
	        }
	    });
	}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.createChannelConstructor = createChannelConstructor;
	
	var _sockjsClient = __webpack_require__(402);
	
	var _sockjsClient2 = _interopRequireDefault(_sockjsClient);
	
	var _eventemitter = __webpack_require__(48);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serverConnections = (0, _create2.default)(null);
	var createdChannels = (0, _create2.default)(null);
	var controlChannel = '0';
	
	function createChannelConstructor(_addr, sessionId, _socketChannel) {
	    var addr = _addr.toLowerCase();
	
	    if (!serverConnections[addr]) {
	        serverConnections[addr] = createNewConnection(addr, sessionId);
	    }
	
	    var socketChannel = _socketChannel;
	    if (!socketChannel) {
	        socketChannel = serverConnections[addr].nextChannelId++;
	    }
	
	    return createChannelOnConnection(serverConnections[addr], socketChannel);
	}
	
	function createNewConnection(wsAddr, sessionId) {
	    var connection = new _eventemitter2.default();
	    connection.sessionId = '';
	
	    serverConnections[wsAddr] = connection;
	
	    connection.nextChannelId = 1;
	    connection.connected = false;
	
	    connection.reconnect = connection.connect = function connect() {
	        if (connection.ws) {
	            try {
	                connection.ws.close();
	            } catch (err) {}
	
	            connection.ws = null;
	        }
	        connection.ws = new _sockjsClient2.default(wsAddr);
	        connection.ws.onopen = function () {
	            var connectStr = sessionId ? 'CONTROL SESSION ' + sessionId : 'CONTROL START';
	            connection.ws.send(':' + controlChannel + ' ' + connectStr);
	            connection.connected = true;
	            connection.emit('open');
	        };
	        connection.ws.onclose = function () {
	            connection.connected = false;
	            connection.ws = null;
	            connection.emit('close');
	        };
	        connection.ws.onmessage = function (event) {
	            connection.emit('message', event);
	
	            if (event.data[0] === ':') {
	                var message = event.data;
	                var spacePos = message.indexOf(' ');
	
	                if (spacePos === -1) {
	                    connection.emit('open.' + message.substr(1));
	                    return;
	                }
	
	                var channelId = message.substr(1, spacePos - 1);
	                event.data = message.substr(spacePos + 1);
	                connection.emit('message.' + channelId, event);
	            } else {
	                var parts = event.data.split(' ');
	
	                if (parts[0] === 'SESSION') {
	                    connection.sessionId = parts[1];
	                }
	            }
	        };
	    };
	
	    connection.connect();
	    return connection;
	}
	
	function createChannelOnConnection(connection, channelId) {
	    return function ConnectionChannelWrapper(options) {
	        if (!createdChannels[channelId]) {
	            createdChannels[channelId] = new ConnectionChannel(options);
	        } else {
	            if (connection.connected) {
	                createdChannels[channelId].initChannel();
	            }
	        }
	
	        return createdChannels[channelId];
	    };
	
	    function ConnectionChannel(options) {
	        var sendControlBuffer = [];
	        var encoding = 'utf8';
	        var channel = new _eventemitter2.default();
	        channel.id = channelId;
	        channel.isOpen = false;
	        channel.state = 0;
	        channel.remoteState = 0;
	
	        connection.on('open', function () {
	            connection.ws.send(':' + channelId);
	        });
	
	        connection.on('open.' + channelId, function () {
	            channel.isOpen = true;
	
	            if (sendControlBuffer.length) {
	                sendControlBuffer.forEach(function (line) {
	                    channel.sendControl(line);
	                });
	                sendControlBuffer = [];
	            }
	
	            channel.setEncoding(encoding);
	
	            channel.remoteState = 1;
	            channel.emit('open');
	        });
	        connection.on('close', function () {
	            channel.state = 3;
	            channel.remoteState = 0;
	            channel.isOpen = false;
	            channel.emit('close');
	        });
	        connection.on('message.' + channelId, function (event) {
	            if (event.data.indexOf('control ') === 0) {
	                if (event.data.indexOf('control connected') === 0) {
	                    channel.remoteState = 1;
	                }
	
	                if (event.data.indexOf('control closed') === 0) {
	                    var err = event.data.split(' ')[2];
	                    channel.remoteState = 0;
	                    channel.emit('close', err);
	                }
	            }
	
	            if (channel.remoteState === 1) {
	                channel.emit('line', event.data);
	            }
	        });
	
	        channel.sendControl = function writeTarget(data) {
	            if (channel.isOpen) {
	                connection.ws.send(':' + channelId + ' ' + data);
	            } else {
	                sendControlBuffer.push(data);
	            }
	        };
	
	        channel.writeLine = function writeTarget(data) {
	            if (channel.remoteState >= 1) {
	                connection.ws.send(':' + channelId + ' ' + data);
	            }
	        };
	
	        channel.connect = function connect() {
	            sendControlBuffer = [];
	
	            if (!connection.ws) {
	                connection.reconnect();
	            }
	
	            var host = options.host;
	            var port = options.port;
	            var tls = options.tls || options.ssl;
	            channel.sendControl('HOST ' + host + ':' + (tls ? '+' : '') + port);
	        };
	
	        channel.setEncoding = function setEncoding(newEncoding) {
	            encoding = newEncoding;
	            if (connection.connected) {
	                connection.ws.send(':' + channelId + ' ENCODING ' + newEncoding);
	            }
	            return true;
	        };
	
	        channel.initChannel = function initChannel() {
	            connection.ws.send(':' + channelId);
	        };
	
	        if (connection.connected) {
	            channel.initChannel();
	        }
	
	        return channel;
	    }
	}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatePersistence = function () {
	    function StatePersistence(storageKey, state, storage, logger) {
	        (0, _classCallCheck3.default)(this, StatePersistence);
	
	        this.storageKey = storageKey;
	        this.state = state;
	        this.storage = storage;
	        this.logger = logger;
	        this.isPersisting = false;
	        this.includeBuffers = true;
	
	        this.state.persistence = this;
	    }
	
	    (0, _createClass3.default)(StatePersistence, [{
	        key: 'loadStateIfExists',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                var storedState;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (this.storageKey) {
	                                    _context.next = 2;
	                                    break;
	                                }
	
	                                return _context.abrupt('return');
	
	                            case 2:
	                                _context.next = 4;
	                                return this.storage.get(this.storageKey);
	
	                            case 4:
	                                storedState = _context.sent;
	
	                                if (storedState) {
	                                    if (this.logger) {
	                                        this.logger('Importing state', storedState);
	                                    }
	
	                                    this.state.importState(storedState);
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadStateIfExists() {
	                return _ref.apply(this, arguments);
	            }
	
	            return loadStateIfExists;
	        }()
	    }, {
	        key: 'watchStateForChanges',
	        value: function watchStateForChanges() {
	            var _this = this;
	
	            if (!this.storageKey) {
	                return;
	            }
	
	            var debouncedSaveState = _lodash2.default.debounce(function () {
	                if (_this.logger) {
	                    _this.logger('State updated, setting localStorage');
	                }
	
	                _this.storage.set(_this.storageKey, _this.state.exportState(_this.includeBuffers));
	            }, 1000);
	
	            this.state.$watch('networks', debouncedSaveState, { deep: true });
	            this.state.$watch('user_settings', debouncedSaveState, { deep: true });
	
	            this.isPersisting = true;
	        }
	    }, {
	        key: 'forgetState',
	        value: function forgetState() {
	            this.state.resetState();
	            this.storage.set(this.storageKey, null);
	        }
	    }]);
	    return StatePersistence;
	}();
	
	exports.default = StatePersistence;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = batchedAdd;
	function batchedAdd(singleFn, batchedFn) {
	    var queue = [];
	    var numInLastSec = 0;
	    var isLooping = false;
	    var loopInterval = 1000;
	
	    function queueLoop() {
	        numInLastSec = 0;
	        if (queue.length) {
	            batchedFn(queue);
	            queue = [];
	            setTimeout(queueLoop, loopInterval);
	        } else {
	            isLooping = false;
	        }
	    }
	
	    function maybeStartLoop() {
	        if (isLooping) {
	            return;
	        }
	
	        isLooping = true;
	        setTimeout(queueLoop, loopInterval);
	    }
	    function batchFn(item) {
	        if (queue.length || numInLastSec > 3) {
	            queue.push(item);
	            maybeStartLoop();
	        } else {
	            singleFn(item);
	        }
	
	        numInLastSec++;
	    }
	    batchFn.queue = function getQueue() {
	        return queue;
	    };
	
	    return batchFn;
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _promise = __webpack_require__(38);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(14);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _eventEmitter = __webpack_require__(93);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkProviderZnc = function () {
	    function NetworkProviderZnc(state) {
	        (0, _classCallCheck3.default)(this, NetworkProviderZnc);
	
	        (0, _eventEmitter2.default)(this);
	
	        this.type = 'znc';
	        this.state = state;
	        this.networks = [];
	        this.currentTable = null;
	    }
	
	    (0, _createClass3.default)(NetworkProviderZnc, [{
	        key: 'enumNetworks',
	        value: function enumNetworks(network) {
	            var _this = this;
	
	            return this.getCommandOutput('listnetworks', network).then(function (output) {
	                _this.networks = (output.data || []).map(function (zncNet) {
	                    var password = network.connection.password;
	                    password = password.replace(/(\/[^/]*)?:/, '/' + zncNet.name + ':');
	
	                    return {
	                        name: zncNet.name,
	                        server: network.connection.server,
	                        port: network.connection.port,
	                        tls: network.connection.tls,
	                        password: password,
	                        nick: network.nick,
	                        connected: zncNet.connected
	                    };
	                });
	
	                if (_this.networks.length) {
	                    _this.emit('networks', _this.networks);
	                }
	
	                return _this.networks;
	            });
	        }
	    }, {
	        key: 'autoDetectZncNetworks',
	        value: function autoDetectZncNetworks() {
	            var _this2 = this;
	
	            this.state.$on('irc:raw', function (command, event, network) {
	                var isZnc = event.prefix && event.prefix.indexOf('irc.znc.in') > -1;
	                if (isZnc && !network.is_znc) {
	                    network.is_znc = true;
	                }
	            });
	
	            this.state.$on('irc:registered', function (event, network) {
	                if (network.is_znc) {
	                    _this2.enumNetworks(network);
	                }
	            });
	        }
	    }, {
	        key: 'getCommandOutput',
	        value: function getCommandOutput(command, network) {
	            var _this3 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                var capture = _this3.lineCapture();
	                capture.on('line', function (line) {
	                    if (!_this3.currentTable && line[0] === '+') {
	                        _this3.currentTable = tableParser(line, onTableResult);
	                    } else if (_this3.currentTable) {
	                        _this3.currentTable(line);
	                    }
	                });
	
	                network.ircClient.say('*status', command);
	                capture.start();
	
	                function onTableResult(rows, headers) {
	                    capture.stop();
	
	                    var data = parseTableContents(rows, headers);
	                    if (data.type) {
	                        resolve({
	                            data: data.data,
	                            type: data.type
	                        });
	                    } else {
	                        reject();
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'lineCapture',
	        value: function lineCapture() {
	            var _this4 = this;
	
	            var ee = (0, _eventEmitter2.default)();
	            ee.stop = function () {
	                _this4.state.$off('irc:message', onLine);
	                return ee;
	            };
	            ee.start = function () {
	                _this4.state.$on('irc:message', onLine);
	                return ee;
	            };
	
	            return ee;
	
	            function onLine(event, network, ircEventObj) {
	                var isFromZnc = event.nick === '*status' && event.ident === 'znc';
	
	                if (isFromZnc) {
	                    ee.emit('line', event.message);
	                    ircEventObj.handled = true;
	                }
	            }
	        }
	    }]);
	    return NetworkProviderZnc;
	}();
	
	exports.default = NetworkProviderZnc;
	
	function tableParser(firstLine, cb) {
	    var numSplittersReceived = 0;
	    var headers = splitTableRow(firstLine);
	    var rows = [];
	    var splitter = '';
	
	    function parseTableLine(line) {
	        if (!splitter) {
	            splitter = line.substr(0, 3);
	        }
	
	        if (line.substr(0, 3) === splitter) {
	            numSplittersReceived++;
	        }
	
	        if (numSplittersReceived === 3) {
	            composeData(cb);
	            return;
	        }
	
	        if (isDataRow(line)) {
	            if (numSplittersReceived === 1) {
	                headers = splitTableRow(line);
	            } else if (numSplittersReceived === 2) {
	                rows.push(splitTableRow(line));
	            }
	        }
	    }
	
	    function composeData() {
	        var data = [];
	        for (var i = 0; i < rows.length; i++) {
	            var row = rows[i];
	            var cRow = (0, _create2.default)(null);
	            data.push(cRow);
	            for (var j = 0; j < row.length; j++) {
	                var colName = headers[j] || '';
	                cRow[colName.toLowerCase()] = row[j] || '';
	            }
	        }
	
	        cb(data, headers);
	    }
	
	    parseTableLine(firstLine);
	    return parseTableLine;
	}
	
	function parseTableContents(data, headers) {
	    var ret = {
	        type: '',
	        data: null
	    };
	
	    var tableType = detectTableTypeFromHeaders(headers);
	
	    if (tableType === 'listnetworks') {
	        ret.type = 'listnetworks';
	        ret.data = [];
	
	        data.forEach(function (network) {
	            ret.data.push({
	                name: network.network,
	                connected: network.onirc.toLowerCase() === 'yes',
	                server: network['irc server'],
	                mask: network['irc user']
	            });
	        });
	    }
	
	    return ret;
	}
	
	function isDataRow(line) {
	    return line.substr(0, 2) === '| ';
	}
	function splitTableRow(line) {
	    var parts = line.split('|').map(function (s) {
	        return s.trim();
	    });
	    return parts.slice(1, parts.length - 1);
	}
	function detectTableTypeFromHeaders(headers) {
	    function header(idx) {
	        return headers[idx] ? headers[idx].toLowerCase() : '';
	    }
	
	    if (header(0) === 'network') {
	        return 'listnetworks';
	    }
	    if (header(0) === 'name' && header(1) === 'set by') {
	        return 'topics';
	    }
	    return '';
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(38);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.get = get;
	exports.set = set;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(name) {
	    return new _promise2.default(function (resolve) {
	        resolve(window.localStorage.getItem(name));
	    });
	}
	
	function set(name, val) {
	    return new _promise2.default(function (resolve) {
	        resolve(window.localStorage.setItem(name, val));
	    });
	}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = [{ command: 'msg', alias: [], description: 'Send a message' }, { command: 'action', alias: [], description: 'Do something physical' }, { command: 'join', alias: [], description: 'Join a channel' }, { command: 'part', alias: [], description: 'Leave a channel' }, { command: 'cycle', alias: [], description: 'Leave, then re-join a channel' }, { command: 'nick', alias: [], description: 'Change your nickname' }, { command: 'query', alias: [], description: 'Start a private conversation with someone' }, { command: 'invite', alias: [], description: 'Invite somebody into the channel' }, { command: 'topic', alias: [], description: 'Set the topic for this channel' }, { command: 'notice', alias: [], description: 'Send a notice' }, { command: 'quote', alias: [], description: 'Send a raw command to the IRC server' }, { command: 'kick', alias: [], description: 'Kick somebody from the channel' }, { command: 'clear', alias: [], description: 'Clear all messages from this window' }, { command: 'ctcp', alias: [], description: 'Send a CTCP command to somebody' }, { command: 'quit', alias: [], description: 'Disconnect from the IRC server' }, { command: 'server', alias: [], description: 'Connect to a new IRC network' }, { command: 'whois', alias: [], description: 'Request information on somebody' }, { command: 'whowas', alias: [], description: 'Request information on somebody that disconnected recently' }, { command: 'away', alias: [], description: 'Mark yourself as away' }, { command: 'encoding', alias: [], description: 'Change your connection encoding' }, { command: 'ignore', alias: [], description: 'Ignore messages from somebody' }, { command: 'unignore', alias: [], description: 'Stop ignoring somebody' }];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(472);

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(360);
	
	__webpack_require__(356);
	
	var _Welcome = __webpack_require__(466);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _ZncLogin = __webpack_require__(467);
	
	var _ZncLogin2 = _interopRequireDefault(_ZncLogin);
	
	var _CustomServer = __webpack_require__(463);
	
	var _CustomServer2 = _interopRequireDefault(_CustomServer);
	
	var _KiwiBnc = __webpack_require__(464);
	
	var _KiwiBnc2 = _interopRequireDefault(_KiwiBnc);
	
	var _Personal = __webpack_require__(465);
	
	var _Personal2 = _interopRequireDefault(_Personal);
	
	var _StateBrowser = __webpack_require__(458);
	
	var _StateBrowser2 = _interopRequireDefault(_StateBrowser);
	
	var _Container = __webpack_require__(444);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ControlInput = __webpack_require__(446);
	
	var _ControlInput2 = _interopRequireDefault(_ControlInput);
	
	var _MediaViewer = __webpack_require__(447);
	
	var _MediaViewer2 = _interopRequireDefault(_MediaViewer);
	
	var _Notifications = __webpack_require__(168);
	
	var Notifications = _interopRequireWildcard(_Notifications);
	
	var _AudioBleep = __webpack_require__(160);
	
	var AudioBleep = _interopRequireWildcard(_AudioBleep);
	
	var _ThemeManager = __webpack_require__(55);
	
	var _ThemeManager2 = _interopRequireDefault(_ThemeManager);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _state2 = __webpack_require__(3);
	
	var _state3 = _interopRequireDefault(_state2);
	
	var _InputHandler = __webpack_require__(163);
	
	var _InputHandler2 = _interopRequireDefault(_InputHandler);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = _Logger2.default.namespace('App.vue');
	
	new _InputHandler2.default(_state3.default);
	
	exports.default = {
	    created: function created() {
	        var _this = this;
	
	        this.listen(_state3.default, 'active.component', function (component, props) {
	            _this.activeComponent = null;
	            if (component) {
	                _this.activeComponentProps = props;
	                _this.activeComponent = component;
	            }
	        });
	        this.listen(_state3.default, 'network.settings', function (network) {
	            _this.activeComponent = null;
	            _state3.default.setActiveBuffer(network.id, network.serverBuffer().name);
	        });
	        this.listen(_state3.default, 'statebrowser.toggle', function () {
	            _this.stateBrowserDrawOpen = !_this.stateBrowserDrawOpen;
	        });
	        this.listen(_state3.default, 'statebrowser.show', function () {
	            _this.stateBrowserDrawOpen = true;
	        });
	        this.listen(_state3.default, 'statebrowser.hide', function () {
	            _this.stateBrowserDrawOpen = false;
	        });
	        this.listen(_state3.default, 'mediaviewer.show', function (url) {
	            _this.mediaviewerUrl = url;
	            _this.mediaviewerOpen = true;
	        });
	        this.listen(_state3.default, 'mediaviewer.hide', function () {
	            _this.mediaviewerOpen = false;
	        });
	
	        var themes = _ThemeManager2.default.instance();
	        this.themeUrl = themes.themeUrl(themes.currentTheme());
	        this.listen(_state3.default, 'theme.change', function () {
	            _this.themeUrl = themes.themeUrl(themes.currentTheme());
	        });
	
	        document.addEventListener('keydown', function (event) {
	            return _this.emitDocumentKeyDown(event);
	        }, false);
	        window.addEventListener('focus', function (event) {
	            _state3.default.ui.app_has_focus = true;
	            var buffer = _state3.default.getActiveBuffer();
	            if (buffer) {
	                buffer.markAsRead(true);
	            }
	        }, false);
	        window.addEventListener('blur', function (event) {
	            _state3.default.ui.app_has_focus = false;
	        }, false);
	        window.addEventListener('touchstart', function (event) {
	            _state3.default.ui.is_touch = true;
	        });
	    },
	    mounted: function mounted() {
	        var startupScreens = {
	            welcome: _Welcome2.default,
	            customServer: _CustomServer2.default,
	            kiwiBnc: _KiwiBnc2.default,
	            znc: _ZncLogin2.default,
	            personal: _Personal2.default
	        };
	        var extraStartupScreens = _state3.default.getStartups();
	
	        var startupName = _state3.default.settings.startupScreen || 'personal';
	        var startup = extraStartupScreens[startupName] || startupScreens[startupName];
	
	        if (!startup) {
	            _Logger2.default.error('Startup screen "' + startupName + '" does not exist');
	        } else {
	            this.startupComponent = startup;
	        }
	    },
	    components: {
	        StateBrowser: _StateBrowser2.default,
	        Container: _Container2.default,
	        ControlInput: _ControlInput2.default,
	        MediaViewer: _MediaViewer2.default
	    },
	    data: function data() {
	        return {
	            startupComponent: null,
	            hasStarted: false,
	
	            stateBrowserDrawOpen: false,
	
	            activeComponent: null,
	            activeComponentProps: {},
	
	            fallbackComponent: null,
	            fallbackComponentProps: {},
	            mediaviewerOpen: false,
	            mediaviewerUrl: '',
	            themeUrl: ''
	        };
	    },
	    computed: {
	        state: function state() {
	            return _state3.default;
	        },
	        networks: function networks() {
	            return _state3.default.networks;
	        },
	        network: function network() {
	            return _state3.default.getActiveNetwork();
	        },
	        buffer: function buffer() {
	            return _state3.default.getActiveBuffer();
	        },
	        users: function users() {
	            var activeNetwork = this.network;
	            if (!activeNetwork) {
	                return null;
	            }
	
	            return activeNetwork.users;
	        }
	    },
	    methods: {
	        startUp: function startUp(opts) {
	            log('startUp()');
	            if (opts && opts.fallbackComponent) {
	                this.fallbackComponent = opts.fallbackComponent;
	            }
	            if (opts && opts.fallbackComponentProps) {
	                this.fallbackComponentProps = opts.fallbackComponentProps;
	            }
	
	            if (!this.hasStarted) {
	                this.warnOnPageClose();
	                Notifications.requestPermission();
	                Notifications.listenForNewMessages(_state3.default);
	                AudioBleep.listenForHighlights(_state3.default);
	            }
	
	            this.hasStarted = true;
	        },
	        warnOnPageClose: function warnOnPageClose() {
	            var _this2 = this;
	
	            window.onbeforeunload = function () {
	                return _this2.$t('window_unload');
	            };
	        },
	
	        emitDocumentClick: function emitDocumentClick(event) {
	            _state3.default.$emit('document.clicked', event);
	        },
	        emitDocumentKeyDown: function emitDocumentKeyDown(event) {
	            _state3.default.$emit('document.keydown', event);
	        },
	        setting: function setting(name) {
	            return _state3.default.setting(name);
	        }
	    }
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _SettingsAliases = __webpack_require__(455);
	
	var _SettingsAliases2 = _interopRequireDefault(_SettingsAliases);
	
	var _ThemeManager = __webpack_require__(55);
	
	var _ThemeManager2 = _interopRequireDefault(_ThemeManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bindSetting(settingName) {
	    return {
	        get: function settingGetter() {
	            return this.state.setting(settingName);
	        },
	        set: function settingSetter(newVal) {
	            this.state.setting(settingName, newVal);
	        }
	    };
	}
	
	exports.default = {
	    data: function data() {
	        return {
	            state: _state2.default,
	            theme: '',
	            customThemeUrl: ''
	        };
	    },
	    computed: {
	        themeSupportsMonospace: function themeSupportsMonospace() {
	            var themeMgr = _ThemeManager2.default.instance();
	            var val = themeMgr.themeVar('supports-monospace');
	            return val === '1';
	        },
	        timestamps_24h: {
	            get: function get24Timestamps() {
	                return _state2.default.setting('buffers.timestamp_format').substr(0, 2) === '%H';
	            },
	            set: function set24Timestamps(newVal) {
	                var newFormat = newVal ? '%H:%M:%S' : '%l:%M:%S';
	                _state2.default.setting('buffers.timestamp_format', newFormat);
	            }
	        },
	        settings: function getSettings() {
	            return _state2.default.settings;
	        },
	        settingShowAutoComplete: bindSetting('showAutocomplete'),
	        settingUseMonospace: bindSetting('useMonospace'),
	        settingHighlights: bindSetting('highlights'),
	        settingBufferColourNicknames: bindSetting('buffers.colour_nicknames_in_messages'),
	        settingBufferShowTimestamps: bindSetting('buffers.show_timestamps'),
	        settingBufferShowEmoticons: bindSetting('buffers.show_emoticons'),
	        settingBufferBlockPms: bindSetting('buffers.block_pms'),
	        settingBufferScrollbackSize: bindSetting('buffers.scrollback_size'),
	        settingBufferExtraFormatting: bindSetting('buffers.extra_formatting'),
	        settingBufferTrafficAsActivity: bindSetting('buffers.traffic_as_activity'),
	        settingBufferMuteSound: bindSetting('buffers.mute_sound'),
	        settingDefaultBanMask: bindSetting('buffers.default_ban_mask'),
	        settingDefaultKickReason: bindSetting('buffers.default_kick_reason'),
	        settingMessageLayout: {
	            get: function getSettingMessageLayout() {
	                return _state2.default.setting('messageLayout') === 'compact';
	            },
	            set: function setSettingMessageLayout(newVal) {
	                if (newVal) {
	                    _state2.default.setting('messageLayout', 'compact');
	                } else {
	                    _state2.default.setting('messageLayout', 'modern');
	                }
	            }
	        }
	    },
	    components: {
	        SettingsAliases: _SettingsAliases2.default
	    },
	    methods: {
	        closeSettings: function closeSettings() {
	            _state2.default.$emit('active.component');
	        },
	        refreshTheme: function refreshTheme() {
	            _ThemeManager2.default.instance().reload();
	        },
	        listenForThemeSettings: function listenForThemeSettings() {
	            var _this = this;
	
	            var themeMgr = _ThemeManager2.default.instance();
	            var watches = [];
	
	            var updateFn = function updateFn() {
	                var theme = themeMgr.currentTheme();
	                _this.theme = theme.name;
	                _this.customThemeUrl = theme.name === 'custom' ? theme.url : '';
	            };
	
	            var watchTheme = function watchTheme(newVal) {
	                themeMgr.setTheme(newVal);
	            };
	
	            var watchCustomThemeUrl = function watchCustomThemeUrl(newVal) {
	                if (themeMgr.currentTheme().name === 'custom') {
	                    themeMgr.setCustomThemeUrl(newVal);
	                }
	            };
	
	            var teardownFn = function teardownFn() {
	                _this.state.$off('theme.change', updateFn);
	                watches.forEach(function (unwatchFn) {
	                    return unwatchFn();
	                });
	                _this.$off('hook:destroy', teardownFn);
	            };
	
	            updateFn();
	
	            this.state.$on('theme.change', updateFn);
	            this.$once('hook:destroyed', teardownFn);
	
	            watches = [this.$watch('theme', watchTheme), this.$watch('customThemeUrl', watchCustomThemeUrl)];
	        }
	    },
	    created: function created() {
	        this.listenForThemeSettings();
	    }
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            items_: [{ text: 'anick1', type: 'user' }, { text: 'anick2', type: 'user' }, { text: 'bnick3', type: 'user' }, { text: 'cnick4' }, { text: 'dnick5' }],
	            selected_idx: 0
	        };
	    },
	    props: ['filter', 'buffer', 'items'],
	    computed: {
	        filteredItems: function filteredItems() {
	            var filterVal = (this.filter || '').toLowerCase();
	
	            return (0, _lodash2.default)(this.items).filter(function (item) {
	                var s = false;
	                if (item.text.toLowerCase().indexOf(filterVal) === 0) {
	                    s = true;
	                }
	
	                return s;
	            }).sort(function (a, b) {
	                return a.text.localeCompare(b.text);
	            }).value();
	        },
	        filteredAndLimitedItems: function filteredAndLimitedItems() {
	            var _this = this;
	
	            return this.filteredItems.filter(function (item, itemIdx, items) {
	                var numItems = items.length - 1;
	                var idxFrom = _this.selected_idx - 3;
	                var idxTo = _this.selected_idx + 3;
	                var isInRange = false;
	
	                if (idxFrom < 0) {
	                    idxTo = idxTo + -idxFrom;
	                    idxFrom = 0;
	                } else if (idxTo > numItems) {
	                    idxFrom = idxFrom - (idxTo - numItems);
	                    idxTo = numItems;
	                }
	
	                if (itemIdx >= idxFrom && itemIdx <= idxTo) {
	                    isInRange = true;
	                }
	
	                item.idx = itemIdx;
	
	                return isInRange;
	            });
	        },
	        selectedItem: function selectedItem() {
	            var item = this.filteredItems[this.selected_idx];
	            return item || null;
	        }
	    },
	    methods: {
	        handleOnKeyDown: function handleOnKeyDown(event) {
	            var handled = false;
	
	            var cancelKeyCodes = [13, 188, 190];
	
	            if (cancelKeyCodes.indexOf(event.keyCode) > -1) {
	                if (!this.selectedItem) {
	                    this.cancel();
	                } else {
	                    this.selectCurrentItem();
	                    if (event.keyCode === 13) {
	                        event.preventDefault();
	                    }
	                    handled = true;
	                }
	            } else if (event.keyCode === 38 || event.keyCode === 9 && event.shiftKey) {
	                if (this.selected_idx > 0) {
	                    this.selected_idx--;
	                } else {
	                    this.selected_idx = this.filteredItems.length - 1;
	                }
	
	                event.preventDefault();
	                handled = true;
	            } else if (event.keyCode === 40 && !event.altKey || event.keyCode === 9) {
	                if (this.selected_idx < this.filteredItems.length - 1) {
	                    this.selected_idx++;
	                } else {
	                    this.selected_idx = 0;
	                }
	
	                event.preventDefault();
	                handled = true;
	            }
	
	            return handled;
	        },
	        openQuery: function openQuery(nick) {
	            var buffer = _state2.default.addBuffer(this.buffer.networkid, nick);
	            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
	            this.cancel();
	        },
	        tempCurrentItem: function tempCurrentItem() {
	            var item = this.selectedItem;
	            if (!item) {
	                return;
	            }
	            this.$emit('temp', item.value || item.text, item);
	        },
	        selectCurrentItem: function selectCurrentItem() {
	            var item = this.selectedItem;
	            var value = '';
	
	            if (item) {
	                value = item.value || item.text;
	            }
	
	            this.$emit('selected', value, item);
	        },
	        cancel: function cancel() {
	            this.$emit('cancel');
	        }
	    },
	    mounted: function mounted() {
	        this.tempCurrentItem();
	    },
	    watch: {
	        selected_idx: function watchSelectedIdx() {
	            var _this2 = this;
	
	            this.$nextTick(function () {
	                var el = _this2.$el.querySelector('.kiwi-autocomplete-item--selected');
	                if (!el) {
	                    return;
	                }
	
	                _this2.$el.scrollTop = el.offsetTop - el.getBoundingClientRect().height * 2;
	            });
	
	            this.tempCurrentItem();
	        },
	        filter: function watchFilter() {
	            var numItems = this.filteredAndLimitedItems.length - 1;
	            if (this.selected_idx > numItems) {
	                this.selected_idx = numItems;
	            }
	        }
	    }
	};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['buffer'],
	    components: {},
	    computed: {
	        settingAlertOn: {
	            get: function getSettingAlertOn() {
	                return this.buffer.setting('alert_on');
	            },
	            set: function setSettingAlertOn(val) {
	                return this.buffer.setting('alert_on', val);
	            }
	        },
	        settingMuteSound: {
	            get: function getSettingAlertOn() {
	                return this.buffer.setting('mute_sound');
	            },
	            set: function setSettingAlertOn(val) {
	                return this.buffer.setting('mute_sound', val);
	            }
	        }
	    }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            banlist: [],
	            is_refreshing: false
	        };
	    },
	    props: ['buffer'],
	    methods: {
	        updateBanlist: function updateBanlist() {
	            var _this = this;
	
	            if (this.buffer.getNetwork().state !== 'connected' || this.is_refreshing) {
	                return;
	            }
	
	            var channelName = this.buffer.name;
	            this.is_refreshing = true;
	            this.buffer.getNetwork().ircClient.banlist(channelName, function (banEvent) {
	                _this.banlist = banEvent.bans;
	                _this.is_refreshing = false;
	            });
	        },
	        removeBan: function removeBan(mask) {
	            var channelName = this.buffer.name;
	            this.buffer.getNetwork().ircClient.unban(channelName, mask);
	            this.banlist = this.banlist.filter(function (ban) {
	                return ban.banned !== mask;
	            });
	        }
	    },
	    created: function created() {
	        this.updateBanlist();
	    }
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function generateComputedMode(mode) {
	    return {
	        get: function computedModeGet() {
	            return this.modeVal(mode);
	        },
	        set: function computedModeSet(newVal) {
	            return this.setMode((newVal ? '+' : '-') + mode);
	        }
	    };
	}
	
	function generateComputedModeWithParam(mode) {
	    return {
	        get: function computedModeWithParamGet() {
	            var val = this.modeVal(mode);
	            return val === false ? '' : val;
	        },
	        set: function computedModeWithParamSet(newVal) {
	            if (newVal) {
	                this.setMode('+' + mode, newVal);
	            } else {
	                this.setMode('-' + mode);
	            }
	        }
	    };
	}
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['buffer'],
	    methods: {
	        updateBanList: function updateBanList() {
	            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, '+b');
	        },
	        setMode: function setMode(mode, param) {
	            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, mode, param);
	        },
	        modeVal: function modeVal(mode) {
	            var val = false;
	
	            if (typeof this.buffer.modes[mode] === 'undefined') {
	                val = false;
	            } else if (!this.buffer.modes[mode]) {
	                val = true;
	            } else {
	                val = this.buffer.modes[mode];
	            }
	
	            return val;
	        },
	        areWeAnOp: function areWeAnOp() {
	            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
	        }
	    },
	    computed: {
	        modeM: generateComputedMode('m'),
	        modeI: generateComputedMode('i'),
	        modeT: generateComputedMode('t'),
	        modeN: generateComputedMode('n'),
	        modeK: generateComputedModeWithParam('k'),
	        topic: {
	            get: function computedTopicGet() {
	                return this.buffer.topic;
	            },
	            set: function computedTopicSet(newVal) {
	                var newTopic = newVal.replace('\n', ' ');
	                this.buffer.getNetwork().ircClient.setTopic(this.buffer.name, newTopic);
	            }
	        }
	    },
	    created: function created() {},
	    updated: function updated() {
	        var rect = this.$el.getBoundingClientRect();
	
	        var targetTop = parseInt((this.$el.style.top || '').replace('px', ''), 10);
	
	        if (targetTop + rect.height > window.innerHeight) {
	            this.$el.style.top = window.innerHeight - rect.height + 'px';
	        }
	    }
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            sidebarOpen: false,
	            page: 0,
	            page_size: 200,
	            search: '',
	            last_updated: 0
	        };
	    },
	    props: ['network'],
	    computed: {
	        listState: function listState() {
	            return this.network.channel_list_state;
	        },
	        list: function list() {
	            return this.network.channel_list || [];
	        },
	        filteredList: function filteredList() {
	            var _this = this;
	
	            var list = [];
	
	            if (this.search.length <= 2) {
	                list = this.list;
	            } else {
	                list = this.list.filter(function (channel) {
	                    var found = false;
	                    if (channel.channel.toLowerCase().indexOf(_this.search) > -1) {
	                        found = true;
	                    }
	                    if (channel.topic.toLowerCase().indexOf(_this.search) > -1) {
	                        found = true;
	                    }
	                    return found;
	                });
	            }
	
	            return _lodash2.default.sortBy(list, 'num_users').reverse();
	        },
	        paginated: function paginated() {
	            var offset = this.page * this.page_size;
	            var list = this.filteredList;
	            var channels = [];
	            for (var i = offset; i < offset + this.page_size; i++) {
	                if (list[i]) {
	                    channels.push(list[i]);
	                }
	            }
	
	            return channels;
	        },
	        maxPages: function maxPages() {
	            return Math.floor(this.filteredList.length / this.page_size);
	        },
	        canGoForward: function canGoForward() {
	            return this.page * this.page_size >= this.filteredList.length;
	        },
	        canGoBackward: function canGoBackward() {
	            return this.page > 0;
	        }
	    },
	    methods: {
	        nextPage: function nextPage() {
	            if (this.page < this.maxPages) {
	                this.page++;
	            }
	        },
	        prevPage: function prevPage() {
	            if (this.page > 0) {
	                this.page--;
	            }
	        },
	        maybeUpdateList: function maybeUpdateList() {
	            if (this.listState !== 'updating') {
	                this.network.ircClient.raw('LIST');
	            }
	        },
	        joinChannel: function joinChannel(channelName) {
	            _state2.default.addBuffer(this.network.id, channelName);
	            this.network.ircClient.join(channelName);
	        }
	    },
	    watch: {
	        search: function watchSearch() {
	            this.page = 0;
	        }
	    }
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _ContainerHeader = __webpack_require__(445);
	
	var _ContainerHeader2 = _interopRequireDefault(_ContainerHeader);
	
	var _Sidebar = __webpack_require__(456);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MessageList = __webpack_require__(155);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _ServerView = __webpack_require__(454);
	
	var _ServerView2 = _interopRequireDefault(_ServerView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        ContainerHeader: _ContainerHeader2.default,
	        Sidebar: _Sidebar2.default,
	        MessageList: _MessageList2.default,
	        ServerView: _ServerView2.default
	    },
	    data: function data() {
	        return {
	            sidebarOpen: false
	        };
	    },
	    props: ['network', 'buffer', 'users', 'isHalfSize'],
	    computed: {
	        bufferType: function bufferType() {
	            var type = '';
	
	            if (!this.buffer) {
	                type = 'none';
	            } else if (this.buffer.isServer()) {
	                type = 'server';
	            } else if (this.buffer.isChannel()) {
	                type = 'channel';
	            } else if (this.buffer.isQuery()) {
	                type = 'query';
	            }
	
	            return type;
	        },
	        unreadMessages: function unreadMessages() {
	            var count = 0;
	            var highlight = false;
	            _state2.default.networks.forEach(function (network) {
	                network.buffers.forEach(function (buffer) {
	                    count += buffer.flags.unread || 0;
	                    if (buffer.flags.highlight) {
	                        highlight = true;
	                    }
	                });
	            });
	            return { count: count, highlight: highlight };
	        }
	    },
	    methods: {
	        toggleStateBrowser: function toggleStateBrowser() {
	            _state2.default.$emit('statebrowser.toggle');
	        },
	        toggleSidebar: function toggleSidebar() {
	            if (this.buffer.isChannel()) {
	                _state2.default.$emit('sidebar.toggle');
	            }
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        this.listen(_state2.default, 'sidebar.toggle', function () {
	            _state2.default.$emit('sidebar.' + (_this.sidebarOpen ? 'hide' : 'show'));
	        });
	        this.listen(_state2.default, 'sidebar.show', function () {
	            _this.sidebarOpen = true;
	        });
	        this.listen(_state2.default, 'sidebar.hide', function () {
	            _this.sidebarOpen = false;
	        });
	    }
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _GlobalApi = __webpack_require__(36);
	
	var _GlobalApi2 = _interopRequireDefault(_GlobalApi);
	
	var _BufferSettings = __webpack_require__(72);
	
	var _BufferSettings2 = _interopRequireDefault(_BufferSettings);
	
	var _ChannelInfo = __webpack_require__(153);
	
	var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);
	
	var _ChannelBanlist = __webpack_require__(152);
	
	var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            buffer_settings_open: false,
	            pluginUiChannelElements: _GlobalApi2.default.singleton().channelHeaderPlugins,
	            pluginUiQueryElements: _GlobalApi2.default.singleton().queryHeaderPlugins
	        };
	    },
	    props: ['buffer'],
	    computed: {
	        isJoined: function isJoined() {
	            var buffer = this.buffer;
	            return buffer.getNetwork().state === 'connected' && buffer.joined;
	        },
	        isConnected: function isConnected() {
	            return this.buffer.getNetwork().state === 'connected';
	        }
	    },
	    components: {
	        BufferSettings: _BufferSettings2.default,
	        ChannelInfo: _ChannelInfo2.default,
	        ChannelBanlist: _ChannelBanlist2.default
	    },
	    methods: {
	        isChannel: function isChannel() {
	            return this.buffer.isChannel();
	        },
	        isServer: function isServer() {
	            return this.buffer.isServer();
	        },
	        isQuery: function isQuery() {
	            return this.buffer.isQuery();
	        },
	        isSpecial: function isSpecial() {
	            return this.buffer.isSpecial();
	        },
	        showNetworkSettings: function showNetworkSettings(network) {
	            _state2.default.$emit('network.settings', network);
	        },
	        joinCurrentBuffer: function joinCurrentBuffer() {
	            var network = this.buffer.getNetwork();
	            this.buffer.enabled = true;
	            network.ircClient.join(this.buffer.name);
	        },
	        closeCurrentBuffer: function closeCurrentBuffer() {
	            _state2.default.removeBuffer(this.buffer);
	        },
	        onHeaderClick: function onHeaderClick(event) {
	            var channelName = event.target.getAttribute('data-channel-name');
	            if (channelName) {
	                var network = this.buffer.getNetwork();
	                _state2.default.addBuffer(this.buffer.networkid, channelName);
	                network.ircClient.join(channelName);
	            }
	        }
	    },
	    watch: {
	        buffer: function watchBuffer() {
	            this.buffer_settings_open = false;
	        }
	    }
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _autocompleteCommands = __webpack_require__(174);
	
	var _autocompleteCommands2 = _interopRequireDefault(_autocompleteCommands);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _GlobalApi = __webpack_require__(36);
	
	var _GlobalApi2 = _interopRequireDefault(_GlobalApi);
	
	var _AutoComplete = __webpack_require__(442);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _TextStyle = __webpack_require__(462);
	
	var _TextStyle2 = _interopRequireDefault(_TextStyle);
	
	var _Emoji = __webpack_require__(461);
	
	var _Emoji2 = _interopRequireDefault(_Emoji);
	
	var _SelfUser = __webpack_require__(453);
	
	var _SelfUser2 = _interopRequireDefault(_SelfUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        AutoComplete: _AutoComplete2.default,
	        SelfUser: _SelfUser2.default
	    },
	    data: function data() {
	        return {
	            selfuser_open: false,
	            value: '',
	            history: [],
	            history_pos: 0,
	            autocomplete_open: false,
	            autocomplete_items: [],
	            autocomplete_filter: '',
	
	            autocomplete_filtering: true,
	            active_tool: null,
	            active_tool_props: {},
	            pluginUiElements: _GlobalApi2.default.singleton().controlInputPlugins
	        };
	    },
	    props: ['container', 'buffer'],
	    computed: {
	        currentNick: function currentNick() {
	            var activeNetwork = _state2.default.getActiveNetwork();
	            return activeNetwork ? activeNetwork.nick : '';
	        },
	        networkState: function networkState() {
	            var activeNetwork = _state2.default.getActiveNetwork();
	            return activeNetwork ? activeNetwork.state : '';
	        }
	    },
	    watch: {
	        history_pos: function watchhistoryPos(newVal) {
	            var val = this.history[this.history_pos];
	            this.$refs.input.setValue(val || '');
	        }
	    },
	    methods: {
	        toggleSelfUser: function toggleSelfUser() {
	            if (this.networkState === 'connected') {
	                this.selfuser_open = !this.selfuser_open;
	            }
	        },
	
	        onToolClickTextStyle: function onToolClickTextStyle() {
	            this.toggleInputTool(_TextStyle2.default);
	        },
	        onToolClickEmoji: function onToolClickEmoji() {
	            this.toggleInputTool(_Emoji2.default);
	        },
	
	        closeInputTool: function closeInputTool() {
	            this.active_tool = null;
	        },
	        toggleInputTool: function toggleInputTool(tool) {
	            if (!tool || this.active_tool === tool) {
	                this.active_tool = null;
	            } else {
	                this.active_tool_props = {
	                    buffer: this.buffer,
	                    ircinput: this.$refs.input
	                };
	                this.active_tool = tool;
	            }
	        },
	        onAutocompleteCancel: function onAutocompleteCancel() {
	            this.autocomplete_open = false;
	        },
	        onAutocompleteTemp: function onAutocompleteTemp(selectedValue, selectedItem) {
	            if (!this.autocomplete_filtering) {
	                this.$refs.input.setCurrentWord(selectedValue);
	            }
	        },
	        onAutocompleteSelected: function onAutocompleteSelected(selectedValue, selectedItem) {
	            var word = selectedValue;
	            this.$refs.input.setCurrentWord(word);
	            this.autocomplete_open = false;
	        },
	        inputKeyDown: function inputKeyDown(event) {
	            var _this = this;
	
	            var meta = false;
	
	            if (navigator.appVersion.indexOf('Mac') !== -1) {
	                meta = event.metaKey;
	            } else {
	                meta = event.altKey;
	            }
	
	            if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
	                return;
	            }
	
	            if (this.autocomplete_open && !this.autocomplete_filtering) {
	                this.$refs.autocomplete.selectCurrentItem();
	            }
	
	            if (event.keyCode === 13) {
	                event.preventDefault();
	                this.submitForm();
	            } else if (event.keyCode === 32) {
	                if (_state2.default.setting('buffers.show_emoticons')) {
	                    var currentWord = this.$refs.input.getCurrentWord();
	                    var emojiList = _state2.default.setting('emojis');
	                    if (emojiList.hasOwnProperty(currentWord.word)) {
	                        var emoji = emojiList[currentWord.word];
	                        var url = _state2.default.setting('emojiLocation') + emoji + '.png';
	                        this.$refs.input.setCurrentWord('');
	                        this.$refs.input.addImg(currentWord.word + ' ', url);
	                    }
	                }
	            } else if (event.keyCode === 38) {
	                event.preventDefault();
	                this.historyBack();
	                this.$nextTick(function () {
	                    _this.$refs.input.selectionToEnd();
	                });
	            } else if (event.keyCode === 40) {
	                event.preventDefault();
	                this.historyForward();
	                this.$nextTick(function () {
	                    _this.$refs.input.selectionToEnd();
	                });
	            } else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
	                event.preventDefault();
	            } else if (meta && event.keyCode === 221) {} else if (meta && event.keyCode === 219) {} else if (meta && event.keyCode === 75) {
	                this.toggleInputTool(_TextStyle2.default);
	                event.preventDefault();
	            }
	        },
	        inputKeyUp: function inputKeyUp(event) {
	            var inputVal = this.$refs.input.getRawText();
	            var currentWord = this.$refs.input.getCurrentWord();
	            var currentToken = currentWord.word.substr(0, currentWord.position);
	
	            if (event.keyCode === 27 && this.autocomplete_open) {
	                this.autocomplete_open = false;
	            } else if (this.autocomplete_open && currentToken === '') {
	                this.autocomplete_open = false;
	            } else if (this.autocomplete_open) {
	                if (currentToken[0] === '@') {
	                    currentToken = currentToken.substr(1);
	                }
	            } else if (currentToken === '@') {
	                this.openAutoComplete(this.buildAutoCompleteItems({ users: true }));
	                this.autocomplete_filtering = true;
	            } else if (inputVal === '/') {
	                this.openAutoComplete(this.buildAutoCompleteItems({ commands: true }));
	                this.autocomplete_filtering = true;
	            } else if (currentToken === '#') {
	                this.openAutoComplete(this.buildAutoCompleteItems({ buffers: true }));
	                this.autocomplete_filtering = true;
	            } else if (event.keyCode === 9) {
	                var items = this.buildAutoCompleteItems({
	                    users: true,
	                    buffers: true
	                });
	                this.openAutoComplete(items);
	                this.autocomplete_filter = currentToken;
	
	                this.autocomplete_filtering = false;
	                event.preventDefault();
	            }
	
	            if (this.autocomplete_open && this.autocomplete_filtering) {
	                this.autocomplete_filter = currentToken;
	            }
	        },
	        submitForm: function submitForm() {
	            var rawInput = this.$refs.input.getValue();
	            if (!rawInput) {
	                return;
	            }
	
	            var ircText = this.$refs.input.buildIrcText();
	            _state2.default.$emit('input.raw', ircText);
	
	            this.history.push(rawInput);
	            this.history.splice(0, this.history.length - 50);
	            this.history_pos = this.history.length;
	
	            this.value = '';
	            this.$refs.input.reset();
	        },
	        historyBack: function historyBack() {
	            if (this.history_pos > 0) {
	                this.history_pos--;
	            }
	        },
	        historyForward: function historyForward() {
	            if (this.history_pos < this.history.length) {
	                this.history_pos++;
	            }
	        },
	        openAutoComplete: function openAutoComplete(items) {
	            if (_state2.default.setting('showAutocomplete')) {
	                this.autocomplete_items = items;
	                this.autocomplete_open = true;
	            }
	        },
	        buildAutoCompleteItems: function buildAutoCompleteItems(_opts) {
	            var opts = _opts || {};
	            var list = [];
	
	            if (opts.users) {
	                var userList = _lodash2.default.values(this.buffer.users).map(function (user) {
	                    var item = {
	                        text: user.nick,
	                        type: 'user'
	                    };
	                    return item;
	                });
	
	                if (this.buffer.isQuery()) {
	                    userList.push({
	                        text: this.buffer.name,
	                        type: 'user'
	                    });
	                }
	
	                list = list.concat(userList);
	            }
	
	            if (opts.buffers) {
	                var bufferList = [];
	                this.buffer.getNetwork().buffers.forEach(function (buffer) {
	                    if (buffer.isChannel()) {
	                        bufferList.push({
	                            text: buffer.name,
	                            type: 'buffer'
	                        });
	                    }
	                });
	
	                list = list.concat(bufferList);
	            }
	
	            if (opts.commands) {
	                var commandList = [];
	                _autocompleteCommands2.default.forEach(function (command) {
	                    commandList.push({
	                        text: '/' + command.command,
	                        description: command.description,
	                        type: 'command'
	                    });
	                });
	
	                list = list.concat(commandList);
	            }
	
	            return list;
	        }
	    },
	    created: function created() {
	        var _this2 = this;
	
	        this.listen(_state2.default, 'document.keydown', function (ev) {
	            if (!_this2.$refs.input) {
	                return;
	            }
	
	            if (ev.ctrlKey || ev.altKey || ev.metaKey) {
	                return;
	            }
	
	            var elements = ['input', 'select', 'textarea', 'button', 'datalist', 'keygen'];
	            var doNotRefocus = elements.indexOf(ev.target.tagName.toLowerCase()) > -1 || ev.target.getAttribute('contenteditable');
	
	            if (doNotRefocus) {
	                return;
	            }
	
	            _this2.$refs.input.focus();
	        });
	    }
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var embedlyTagIncluded = false;
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['url'],
	    computed: {
	        embedlyKey: function embedlyKey() {
	            return _state2.default.settings.embedly.key;
	        }
	    },
	    methods: {
	        updateEmbed: function updateEmbed() {
	            var checkEmbedlyAndShowCard = function checkEmbedlyAndShowCard() {
	                if (typeof window.embedly !== 'function') {
	                    setTimeout(checkEmbedlyAndShowCard, 100);
	                    return;
	                }
	
	                window.embedly('card', { selector: '.embedly-card' });
	            };
	
	            if (!embedlyTagIncluded) {
	                var head = document.getElementsByTagName('head')[0];
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.src = '//cdn.embedly.com/widgets/platform.js';
	                head.appendChild(script);
	                embedlyTagIncluded = true;
	            }
	
	            checkEmbedlyAndShowCard();
	        },
	        closeViewer: function closeViewer() {
	            _state2.default.$emit('mediaviewer.hide');
	        }
	    },
	    created: function created() {
	        this.updateEmbed();
	    },
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            _state2.default.$emit('mediaviewer.opened');
	        });
	    },
	    watch: {
	        url: function watchUrl() {
	            this.updateEmbed();
	        }
	    }
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {},
	    data: function data() {
	        return {};
	    },
	    props: ['buffer', 'message'],
	    computed: {},
	    methods: {
	        urlPreview: function urlPreview(url) {
	            _state2.default.$emit('mediaviewer.show', url);
	        },
	        areWeAnOp: function areWeAnOp() {
	            var ourNick = this.buffer.getNetwork().nick;
	            return this.buffer.isUserAnOp(ourNick);
	        },
	        onBan: function onBan(reason) {
	            var network = this.buffer.getNetwork();
	            network.ircClient.mode(this.buffer.name, '+b', this.message.nick);
	        },
	        onKick: function onKick(promptedReason) {
	            var network = this.buffer.getNetwork();
	            var defaultReason = _state2.default.setting('buffers.default_kick_reason');
	            var reason = promptedReason || defaultReason;
	            network.ircClient.raw('KICK', this.buffer.name, this.message.nick, reason);
	        },
	        openQuery: function openQuery() {
	            var network = this.buffer.getNetwork();
	            var buffer = _state2.default.addBuffer(network.id, this.message.nick);
	            _state2.default.setActiveBuffer(network.id, buffer.name);
	        }
	    }
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _strftime = __webpack_require__(71);
	
	var _strftime2 = _interopRequireDefault(_strftime);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _TextFormatting = __webpack_require__(35);
	
	var TextFormatting = _interopRequireWildcard(_TextFormatting);
	
	var _NotConnected = __webpack_require__(452);
	
	var _NotConnected2 = _interopRequireDefault(_NotConnected);
	
	var _MessageListMessageCompact = __webpack_require__(448);
	
	var _MessageListMessageCompact2 = _interopRequireDefault(_MessageListMessageCompact);
	
	var _MessageListMessageModern = __webpack_require__(449);
	
	var _MessageListMessageModern2 = _interopRequireDefault(_MessageListMessageModern);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOTTOM_SCROLL_MARGIN = 30;
	
	exports.default = {
	    components: {
	        NotConnected: _NotConnected2.default,
	        MessageListMessageModern: _MessageListMessageModern2.default,
	        MessageListMessageCompact: _MessageListMessageCompact2.default
	    },
	    data: function data() {
	        return {
	            auto_scroll: true,
	            chathistoryAvailable: true,
	            hover_nick: '',
	            message_info_open: null
	        };
	    },
	    props: ['buffer', 'users'],
	    computed: {
	        thisMl: function thisMl() {
	            return this;
	        },
	        listType: function listType() {
	            return _state2.default.setting('messageLayout');
	        },
	        useExtraFormatting: function useExtraFormatting() {
	            return this.buffer.setting('extra_formatting');
	        },
	        shouldShowChathistoryTools: function shouldShowChathistoryTools() {
	            if (this.buffer.getNetwork().state !== 'connected') {
	                return false;
	            }
	
	            var isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
	            var isSupported = !!this.buffer.getNetwork().ircClient.network.supports('chathistory');
	            return isCorrectBufferType && isSupported && this.buffer.flags.chathistory_available;
	        },
	        ourNick: function ourNick() {
	            return this.buffer ? this.buffer.getNetwork().nick : '';
	        },
	        filteredMessages: function filteredMessages() {
	            var network = this.buffer.getNetwork();
	            var currentNick = network.nick;
	            var bufferMessages = this.buffer.getMessages();
	
	            var ignoredVar = this.buffer.message_count;
	
	            var messages = bufferMessages.slice(0, bufferMessages.length);
	            messages.sort(function (a, b) {
	                if (a.time > b.time) {
	                    return 1;
	                } else if (b.time > a.time) {
	                    return -1;
	                }
	
	                return 0;
	            });
	
	            var list = [];
	            var maxSize = this.buffer.setting('scrollback_size');
	            var showJoinParts = this.buffer.setting('show_joinparts');
	            var showTopics = this.buffer.setting('show_topics');
	            var showNickChanges = this.buffer.setting('show_nick_changes');
	            var showModeChanges = this.buffer.setting('show_mode_changes');
	            for (var i = messages.length - 1; i >= 0 && list.length < maxSize; i--) {
	                if (!showJoinParts && messages[i].type === 'traffic') {
	                    continue;
	                }
	                if (!showTopics && messages[i].type === 'topic') {
	                    continue;
	                }
	                if (!showNickChanges && messages[i].type === 'nick') {
	                    continue;
	                }
	                if (!showModeChanges && messages[i].type === 'mode') {
	                    continue;
	                }
	
	                if (messages[i].ignore) {
	                    continue;
	                }
	
	                if (messages[i].type === 'topic' && messages[i - 1] && messages[i - 1].type === 'traffic' && messages[i - 1].nick === currentNick) {
	                    list.push(messages[i - 1]);
	                    list.push(messages[i]);
	                    i--;
	                } else {
	                    list.push(messages[i]);
	                }
	            }
	
	            return list.reverse();
	        }
	    },
	    methods: {
	        isHoveringOverMessage: function isHoveringOverMessage(message) {
	            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
	        },
	        toggleMessageInfo: function toggleMessageInfo(message) {
	            if (!message) {
	                this.message_info_open = null;
	            } else if (this.message_info_open === message) {
	                return;
	            } else if (this.canShowInfoForMessage(message)) {
	                var sel = window.getSelection();
	                if (sel.rangeCount > 0) {
	                    var range = sel.getRangeAt(0);
	                    if (range && !range.collapsed) {
	                        return;
	                    }
	                }
	
	                this.message_info_open = message;
	                this.$nextTick(this.maybeScrollToBottom.bind(this));
	            }
	        },
	        shouldShowUnreadMarker: function shouldShowUnreadMarker(idx) {
	            var previous = this.filteredMessages[idx - 1];
	            var current = this.filteredMessages[idx];
	            var lastRead = this.buffer.last_read;
	
	            if (!lastRead) {
	                return false;
	            }
	
	            if (previous && previous.time < lastRead && current.time > lastRead) {
	                return true;
	            }
	
	            return false;
	        },
	        shouldShowDateChangeMarker: function shouldShowDateChangeMarker(idx) {
	            var previous = this.filteredMessages[idx - 1];
	            var current = this.filteredMessages[idx];
	
	            if (!previous) {
	                return false;
	            }
	
	            if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
	                return true;
	            }
	
	            return false;
	        },
	
	        canShowInfoForMessage: function canShowInfoForMessage(message) {
	            var showInfoForTypes = ['privmsg', 'notice', 'action'];
	            return showInfoForTypes.indexOf(message.type) > -1;
	        },
	        bufferSetting: function bufferSetting(key) {
	            return this.buffer.setting(key);
	        },
	        formatTime: function formatTime(time) {
	            return (0, _strftime2.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
	        },
	        formatMessage: function formatMessage(message) {
	            return message.toHtml(this);
	        },
	        isMessageHighlight: function isMessageHighlight(message) {
	            if (message.type === 'traffic') {
	                return false;
	            }
	
	            var network = this.buffer.getNetwork();
	            if (message.message.toLowerCase().indexOf(network.nick.toLowerCase()) > -1) {
	                return true;
	            }
	
	            var highlightFound = false;
	            (_state2.default.setting('highlights') || '').toLowerCase().split(' ').forEach(function (word) {
	                if (!word) {
	                    return;
	                }
	
	                if (message.message.indexOf(word) > -1) {
	                    highlightFound = true;
	                }
	            });
	
	            return highlightFound;
	        },
	        nickStyle: function nickColour(nick) {
	            if (this.bufferSetting('colour_nicknames_in_messages')) {
	                return 'color:' + TextFormatting.createNickColour(nick) + ';';
	            }
	            return '';
	        },
	        onListClick: function onListClick(event) {
	            this.toggleMessageInfo();
	        },
	        onMessageClick: function onThreadClick(event, message) {
	            var channelName = event.target.getAttribute('data-channel-name');
	            if (channelName) {
	                var network = this.buffer.getNetwork();
	                _state2.default.addBuffer(this.buffer.networkid, channelName);
	                network.ircClient.join(channelName);
	                return;
	            }
	
	            var userNick = event.target.getAttribute('data-nick');
	            if (userNick) {
	                var user = _state2.default.getUser(this.buffer.networkid, userNick);
	                if (user) {
	                    _state2.default.$emit('userbox.show', user, {
	                        top: event.clientY,
	                        left: event.clientX,
	                        buffer: this.buffer
	                    });
	                }
	
	                return;
	            }
	
	            var url = event.target.getAttribute('data-url');
	            if (url) {
	                _state2.default.$emit('mediaviewer.show', url);
	            }
	
	            if (this.message_info_open && this.message_info_open !== message) {
	                this.toggleMessageInfo();
	                event.preventDefault();
	                return;
	            }
	
	            if (_state2.default.ui.is_touch) {
	                if (this.canShowInfoForMessage(message) && event.target.nodeName === 'A') {
	                    event.preventDefault();
	                }
	
	                this.toggleMessageInfo(message);
	            }
	        },
	        onThreadScroll: function onThreadScroll() {
	            var el = this.$el;
	            var scrolledUpByPx = el.scrollHeight - (el.offsetHeight + el.scrollTop);
	
	            if (scrolledUpByPx > BOTTOM_SCROLL_MARGIN) {
	                this.auto_scroll = false;
	            } else {
	                this.auto_scroll = true;
	            }
	        },
	        scrollToBottom: function scrollToBottom() {
	            this.$el.scrollTop = this.$el.scrollHeight;
	        },
	        maybeScrollToBottom: function maybeScrollToBottom() {
	            if (this.auto_scroll) {
	                this.$el.scrollTop = this.$el.scrollHeight;
	            }
	        }
	    },
	    watch: {
	        buffer: function watchBuffer(newBuffer) {
	            if (!newBuffer) {
	                return;
	            }
	
	            this.message_info_open = null;
	
	            if (this.buffer.getNetwork().state === 'connected') {
	                newBuffer.flags.has_opened = true;
	            }
	
	            this.scrollToBottom();
	        },
	        'buffer.message_count': function watchBufferMessageCount() {
	            var _this = this;
	
	            this.$nextTick(function () {
	                _this.maybeScrollToBottom();
	            });
	        }
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        this.$nextTick(function () {
	            _this2.scrollToBottom();
	        });
	
	        this.listen(_state2.default, 'mediaviewer.opened', function () {
	            _this2.$nextTick(_this2.maybeScrollToBottom.apply(_this2));
	        });
	    }
	};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _MessageInfo = __webpack_require__(154);
	
	var _MessageInfo2 = _interopRequireDefault(_MessageInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        MessageInfo: _MessageInfo2.default
	    },
	    data: function data() {
	        return {};
	    },
	    props: ['ml', 'message', 'idx'],
	    computed: {},
	    methods: {
	        isHoveringOverMessage: function isHoveringOverMessage(message) {
	            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
	        }
	    }
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _TextFormatting = __webpack_require__(35);
	
	var TextFormatting = _interopRequireWildcard(_TextFormatting);
	
	var _MessageInfo = __webpack_require__(154);
	
	var _MessageInfo2 = _interopRequireDefault(_MessageInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	    components: {
	        MessageInfo: _MessageInfo2.default
	    },
	    data: function data() {
	        return {};
	    },
	    props: ['ml', 'message', 'idx'],
	    computed: {},
	    methods: {
	        isHoveringOverMessage: function isHoveringOverMessage(message) {
	            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
	        },
	        nickColour: function nickColour(nick) {
	            if (this.ml.bufferSetting('colour_nicknames_in_messages')) {
	                return TextFormatting.createNickColour(nick);
	            }
	            return '';
	        },
	        isMessage: function isMessage(message) {
	            var types = ['privmsg', 'action', 'notice'];
	            return types.indexOf(message.type) > -1;
	        }
	    }
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            server_type: 'network',
	            znc_username: '',
	            znc_network: '',
	            znc_password: '',
	            show_advanced: false
	        };
	    },
	    props: ['network'],
	    computed: {
	        settingShowRaw: {
	            get: function getSettingAlertOn() {
	                return this.network.setting('show_raw');
	            },
	            set: function setSettingAlertOn(val) {
	                return this.network.setting('show_raw', val);
	            }
	        }
	    },
	    components: {},
	    methods: {
	        readableStateError: function readableStateError(err) {
	            return Misc.networkErrorMessage(err);
	        },
	
	        reconnect: function reconnect() {
	            this.network.ircClient.connect();
	        },
	        removeNetwork: function removeNetwork() {
	            var confirmed = confirm('Really remove this network? This cannot be undone!');
	            if (!confirmed) {
	                return;
	            }
	
	            _state2.default.removeNetwork(this.network.id);
	            _state2.default.$emit('active.component');
	        },
	        setZncPass: function setZncPass() {
	            var newPass = this.znc_username + '/' + this.znc_network + ':' + this.znc_password;
	            this.network.connection.password = newPass;
	        },
	        toggleTls: function toggleTls() {
	            var connection = this.network.connection;
	            connection.tls = !connection.tls;
	
	            if (connection.tls && connection.port === 6667) {
	                connection.port = 6697;
	            } else if (!connection.tls && connection.port === 6697) {
	                connection.port = 6667;
	            }
	        }
	    },
	    watch: {
	        znc_username: function watchZncUsername() {
	            this.setZncPass();
	        },
	        znc_network: function watchZncNetwork() {
	            this.setZncPass();
	        },
	        znc_password: function watchZncPassword() {
	            this.setZncPass();
	        }
	    },
	    created: function created() {
	        var isZnc = !!(this.network.connection.password || '').match(/^(.*)\/(.*):(.*)$/);
	        this.server_type = isZnc ? 'znc' : 'network';
	        if (isZnc) {
	            var match = (this.network.connection.password || '').match(/^(.*)\/(.*):(.*)$/);
	            this.znc_username = match[1] || '';
	            this.znc_network = match[2] || '';
	            this.znc_password = match[3] || '';
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        this.$nextTick(function () {
	            _this.$el.querySelector('.kiwi-networksettings-connection-address input').focus();
	        });
	    }
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _TextFormatting = __webpack_require__(35);
	
	var TextFormatting = _interopRequireWildcard(_TextFormatting);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = _Logger2.default.namespace('Nicklist');
	
	function strCompare(a, b) {
	    if (a === b) {
	        return 0;
	    }
	    return a > b ? 1 : -1;
	}
	
	exports.default = {
	    data: function data() {
	        return {
	            userbox_user: null
	        };
	    },
	    props: ['network', 'buffer', 'users'],
	    computed: {
	        sortedUsers: function sortedUsers() {
	            var netPrefixes = this.network.ircClient.network.options.PREFIX;
	            var prefixOrders = (0, _create2.default)(null);
	            netPrefixes.forEach(function (prefix, idx) {
	                prefixOrders[prefix.mode] = idx;
	            });
	
	            var nickMap = (0, _create2.default)(null);
	            var users = [];
	            var bufferUsers = this.buffer.users;
	
	            for (var lowercaseNick in bufferUsers) {
	                var user = bufferUsers[lowercaseNick];
	                nickMap[user.nick] = lowercaseNick;
	                users.push(user);
	            }
	
	            var bufferId = this.buffer.id;
	            return users.sort(function (a, b) {
	                var bufferA = a.buffers[bufferId];
	                var bufferB = b.buffers[bufferId];
	
	                if (!bufferA) {
	                    var msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
	                    log.error(msg, a.nick, a.buffers);
	                    return -1;
	                }
	                if (!bufferB) {
	                    var _msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
	                    log.error(_msg, b.nick, b.buffers);
	                    return 1;
	                }
	
	                var modesA = bufferA.modes;
	                var modesB = bufferB.modes;
	
	                if (modesA.length === 0 && modesB.length === 0) {
	                    return strCompare(nickMap[a.nick], nickMap[b.nick]);
	                }
	
	                if (modesA.length > 0 && modesB.length === 0) {
	                    return -1;
	                }
	
	                if (modesA.length === 0 && modesB.length > 0) {
	                    return 1;
	                }
	
	                var aP = prefixOrders[modesA[0]];
	                var bP = prefixOrders[modesB[0]];
	                if (aP > bP) {
	                    return 1;
	                } else if (aP < bP) {
	                    return -1;
	                }
	
	                return strCompare(nickMap[a.nick], nickMap[b.nick]);
	            });
	        },
	        useColouredNicks: function useColouredNicks() {
	            return this.buffer.setting('coloured_nicklist');
	        }
	    },
	    methods: {
	        nickStyle: function nickStyle(nick) {
	            var styles = {};
	            if (this.useColouredNicks) {
	                styles.color = TextFormatting.createNickColour(nick);
	            }
	            return styles;
	        },
	        userModePrefix: function userModePrefix(user) {
	            var modes = user.buffers[this.buffer.id].modes;
	            if (modes.length === 0) {
	                return '';
	            }
	
	            var netPrefixes = this.network.ircClient.network.options.PREFIX;
	            var prefix = _lodash2.default.find(netPrefixes, { mode: modes[0] });
	            return prefix ? prefix.symbol : '';
	        },
	        userMode: function userMode(user) {
	            var modes = user.buffers[this.buffer.id].modes;
	            return modes.length === 0 ? '' : modes[0];
	        },
	        openQuery: function openQuery(user) {
	            var buffer = _state2.default.addBuffer(this.buffer.networkid, user.nick);
	            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
	        },
	        openUserbox: function openUserbox(user, mouseEvent) {
	            _state2.default.$emit('userbox.show', user, {
	                top: mouseEvent.clientY,
	                left: mouseEvent.clientX,
	                buffer: this.buffer
	            });
	        }
	    }
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            forceLoader: false
	        };
	    },
	    props: ['buffer', 'network'],
	    computed: {
	        netStatus: function netStatus() {
	            return this.buffer.getNetwork().state;
	        },
	        shouldShowLoading: function showShowLoading() {
	            var _this = this;
	
	            var minimumLoaderViewtime = 2000;
	            var networkState = this.network.state;
	
	            if (networkState !== 'disconnected' || this.forceLoader) {
	                this.forceLoader = true;
	                setTimeout(function () {
	                    _this.forceLoader = false;
	                }, minimumLoaderViewtime);
	
	                return true;
	            }
	
	            return false;
	        }
	    },
	    methods: {
	        isChannel: function isChannel() {
	            return this.buffer.isChannel();
	        },
	        isServer: function isServer() {
	            return this.buffer.isServer();
	        },
	        isQuery: function isQuery() {
	            return this.buffer.isQuery();
	        },
	        reconnect: function reconnect() {
	            if (this.buffer.isChannel()) {
	                this.buffer.enabled = true;
	            }
	            this.buffer.getNetwork().ircClient.connect();
	        },
	        showNetworkSettings: function showNetworkSettings() {
	            var network = this.buffer.getNetwork();
	            _state2.default.$emit('network.settings', network);
	        }
	    }
	};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['network'],
	    computed: {
	        modeString: function modeString() {
	            var str = '';
	            this.network.ircClient.user.modes.forEach(function (mode) {
	                str += mode;
	            });
	
	            if (str) {
	                str = '+' + str;
	            }
	
	            return str;
	        },
	        netUser: function netUser() {
	            return this.network.ircClient.user;
	        }
	    },
	    methods: {
	        changeNick: function changeNick(newNick) {
	            var nick = newNick.trim();
	            if (!nick.match(/(^[0-9])|(\s)/)) {
	                this.network.ircClient.changeNick(newNick);
	            }
	        }
	    }
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _MessageList = __webpack_require__(155);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _NetworkSettings = __webpack_require__(450);
	
	var _NetworkSettings2 = _interopRequireDefault(_NetworkSettings);
	
	var _ChannelList = __webpack_require__(443);
	
	var _ChannelList2 = _interopRequireDefault(_ChannelList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['network'],
	    components: {
	        MessageList: _MessageList2.default,
	        NetworkSettings: _NetworkSettings2.default,
	        ChannelList: _ChannelList2.default
	    },
	    computed: {
	        hasMessages: function hasMessages() {
	            return this.network.serverBuffer().getMessages().length > 0;
	        },
	        serverBuffer: function serverBuffer() {
	            return this.network.serverBuffer();
	        }
	    }
	};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            show_help: false
	        };
	    },
	    computed: {
	        aliasText: {
	            get: function getAliasText() {
	                return _state2.default.setting('aliases').trim();
	            },
	            set: function setAliasText(newVal) {
	                _state2.default.setting('aliases', newVal.trim());
	            }
	        }
	    }
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _BufferSettings = __webpack_require__(72);
	
	var _BufferSettings2 = _interopRequireDefault(_BufferSettings);
	
	var _ChannelInfo = __webpack_require__(153);
	
	var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);
	
	var _ChannelBanlist = __webpack_require__(152);
	
	var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);
	
	var _UserBox = __webpack_require__(460);
	
	var _UserBox2 = _interopRequireDefault(_UserBox);
	
	var _Nicklist = __webpack_require__(451);
	
	var _Nicklist2 = _interopRequireDefault(_Nicklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        BufferSettings: _BufferSettings2.default,
	        ChannelInfo: _ChannelInfo2.default,
	        ChannelBanlist: _ChannelBanlist2.default,
	        Nicklist: _Nicklist2.default,
	        UserBox: _UserBox2.default
	    },
	    data: function data() {
	        return {
	            settings_open: false,
	            userbox_user: null
	        };
	    },
	    props: ['network', 'buffer', 'users'],
	    computed: {
	        sidebarIsWide: {
	            get: function getSidebarIsWide() {
	                return this.settings_open || this.userbox_user;
	            },
	            set: function setSidebarIsWide(newVal) {
	                if (!newVal) {
	                    this.settings_open = false;
	                    this.userbox_user = null;
	                }
	            }
	        },
	        settingShowJoinParts: {
	            get: function getSettingShowJoinParts() {
	                return this.buffer.setting('show_joinparts');
	            },
	            set: function setSettingShowJoinParts(newVal) {
	                return this.buffer.setting('show_joinparts', newVal);
	            }
	        },
	        settingShowTopics: {
	            get: function getSettingShowTopics() {
	                return this.buffer.setting('show_topics');
	            },
	            set: function setSettingShowTopics(newVal) {
	                return this.buffer.setting('show_topics', newVal);
	            }
	        },
	        settingShowNickChanges: {
	            get: function getSettingShowNickChanges() {
	                return this.buffer.setting('show_nick_changes');
	            },
	            set: function setSettingShowNickChanges(newVal) {
	                return this.buffer.setting('show_nick_changes', newVal);
	            }
	        },
	        settingShowModeChanges: {
	            get: function getSettingShowModeChanges() {
	                return this.buffer.setting('show_mode_changes');
	            },
	            set: function setSettingShowModeChanges(newVal) {
	                return this.buffer.setting('show_mode_changes', newVal);
	            }
	        },
	        settingColouredNicklist: {
	            get: function getSettingShowJoinParts() {
	                return this.buffer.setting('coloured_nicklist');
	            },
	            set: function setSettingShowJoinParts(newVal) {
	                return this.buffer.setting('coloured_nicklist', newVal);
	            }
	        },
	        settingExtraFormatting: {
	            get: function settingExtraFormatting() {
	                return this.buffer.setting('extra_formatting');
	            },
	            set: function settingExtraFormatting(newVal) {
	                return this.buffer.setting('extra_formatting', newVal);
	            }
	        },
	        bufferType: function bufferType() {
	            var type = '';
	
	            if (!this.buffer) {
	                type = 'none';
	            } else if (this.buffer.isServer()) {
	                type = 'server';
	            } else if (this.buffer.isChannel()) {
	                type = 'channel';
	            } else if (this.buffer.isQuery()) {
	                type = 'query';
	            }
	
	            return type;
	        }
	    },
	    methods: {},
	    created: function created() {
	        var _this = this;
	
	        this.listen(_state2.default, 'sidebar.hide', function () {
	            _this.settings_open = false;
	        });
	
	        this.listen(_state2.default, 'userbox.show', function (user, opts) {
	            _this.userbox_user = user;
	        });
	        this.listen(_state2.default, 'userbox.hide', function () {
	            _this.userbox_user = null;
	        });
	    }
	};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _StateBrowserNetwork = __webpack_require__(459);
	
	var _StateBrowserNetwork2 = _interopRequireDefault(_StateBrowserNetwork);
	
	var _AppSettings = __webpack_require__(441);
	
	var _AppSettings2 = _interopRequireDefault(_AppSettings);
	
	var _BufferSettings = __webpack_require__(72);
	
	var _BufferSettings2 = _interopRequireDefault(_BufferSettings);
	
	var _NetworkProvider = __webpack_require__(167);
	
	var _NetworkProvider2 = _interopRequireDefault(_NetworkProvider);
	
	var _NetworkProviderZnc = __webpack_require__(172);
	
	var _NetworkProviderZnc2 = _interopRequireDefault(_NetworkProviderZnc);
	
	var _GlobalApi = __webpack_require__(36);
	
	var _GlobalApi2 = _interopRequireDefault(_GlobalApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var netProv = new _NetworkProvider2.default();
	
	var znc = new _NetworkProviderZnc2.default(_state2.default);
	netProv.addProvider(znc);
	znc.autoDetectZncNetworks();
	
	exports.default = {
	    data: function data() {
	        return {
	            popup_buffername: null,
	            popup_networkid: null,
	            popup_top: 0,
	            new_channel_input: '',
	            is_usermenu_open: false,
	            show_provided_networks: false,
	            provided_networks: (0, _create2.default)(null),
	            pluginUiElements: _GlobalApi2.default.singleton().stateBrowserPlugins
	        };
	    },
	    props: ['networks'],
	    components: {
	        BufferSettings: _BufferSettings2.default,
	        StateBrowserNetwork: _StateBrowserNetwork2.default
	    },
	    methods: {
	        showBufferPopup: function showBufferPopup(buffer, domY) {
	            if (!buffer) {
	                this.popup_buffername = null;
	                this.popup_networkid = null;
	                this.popup_top = 0;
	            } else {
	                var stateBrowserTopPosition = this.$el.getBoundingClientRect();
	                this.popup_buffername = buffer.name;
	                this.popup_networkid = buffer.networkid;
	                this.popup_top = domY - stateBrowserTopPosition.top;
	            }
	        },
	        closeBuffer: function closeBuffer() {
	            _state2.default.removeBuffer(this.bufferForPopup);
	        },
	        onNewChannelInputFocus: function onNewChannelInputFocus() {
	            if (!this.new_channel_input) {
	                this.new_channel_input = '#';
	            }
	        },
	        onNewChannelInputBlur: function onNewChannelInputBlur() {
	            if (this.new_channel_input === '#') {
	                this.new_channel_input = '';
	            }
	        },
	        clickAddNetwork: function clickAddNetwork() {
	            var nick = 'Guest' + Math.floor(Math.random() * 100);
	            var network = _state2.default.addNetwork('Network', nick, {});
	            _state2.default.$emit('network.settings', network);
	        },
	        clickAppSettings: function clickAppSettings() {
	            _state2.default.$emit('active.component', _AppSettings2.default);
	        },
	        clickForget: function clickForget() {
	            var msg = 'This will delete all stored networks and start fresh. Are you sure?';
	            var confirmed = confirm(msg);
	            if (!confirmed) {
	                return;
	            }
	
	            _state2.default.persistence.forgetState();
	            window.location.reload();
	        },
	        connectProvidedNetwork: function connectProvidedNetwork(pNet) {
	            var net = _state2.default.addNetwork(pNet.name, pNet.nick, {
	                server: pNet.server,
	                port: pNet.port,
	                tls: pNet.tls,
	                password: pNet.password
	            });
	
	            net.ircClient.connect();
	        }
	    },
	    computed: {
	        bufferForPopup: function bufferForPopup() {
	            if (!this.popup_buffername || !this.popup_networkid) {
	                return false;
	            }
	
	            return _state2.default.getBufferByName(this.popup_networkid, this.popup_buffername);
	        },
	        isPersistingState: function isPersistingState() {
	            return !!_state2.default.persistence;
	        },
	        isRestrictedServer: function isRestrictedServer() {
	            return !!_state2.default.settings.restricted;
	        },
	        networksToShow: function networksToShow() {
	            var bncNet = _state2.default.setting('bnc').network;
	            return this.networks.filter(function (network) {
	                return network !== bncNet;
	            });
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        this.listen(_state2.default, 'document.clicked', function () {
	            _this.showBufferPopup(null);
	        });
	
	        netProv.on('networks', function (networks) {
	            _this.provided_networks = networks;
	        });
	    }
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	var _BufferSettings = __webpack_require__(72);
	
	var _BufferSettings2 = _interopRequireDefault(_BufferSettings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            new_channel_input_has_focus: false,
	            new_channel_input: '',
	            collapsed: false
	        };
	    },
	    props: ['network'],
	    components: {
	        BufferSettings: _BufferSettings2.default
	    },
	    methods: {
	        setActiveBuffer: function switchContainer(buffer) {
	            _state2.default.$emit('active.component', null);
	            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
	        },
	        isActiveBuffer: function isActiveBuffer(buffer) {
	            return buffer.networkid === _state2.default.ui.active_network && buffer.name === _state2.default.ui.active_buffer;
	        },
	        orderedBuffers: function orderedBuffers(buffers) {
	            var list = buffers.map(function (b) {
	                return b;
	            });
	
	            list = _lodash2.default.filter(list, function (buffer) {
	                return !buffer.isServer();
	            });
	            list = list.sort(function (a, b) {
	                var order = 0;
	                if (a.isChannel() && b.isQuery()) {
	                    order = -1;
	                } else if (a.isQuery() && b.isChannel()) {
	                    order = 1;
	                } else {
	                    order = a.name.localeCompare(b.name);
	                }
	
	                return order;
	            });
	
	            return list;
	        },
	        showNetworkSettings: function showNetworkSettings(network) {
	            _state2.default.$emit('network.settings', network);
	        },
	        showBufferPopup: function showBufferPopup(buffer, domY) {
	            if (!buffer) {
	                this.popup_buffername = null;
	                this.popup_networkid = null;
	                this.popup_top = 0;
	            } else {
	                this.popup_buffername = buffer.name;
	                this.popup_networkid = buffer.networkid;
	                this.popup_top = domY;
	            }
	        },
	        onNewChannelInputFocus: function onNewChannelInputFocus() {
	            if (!this.new_channel_input) {
	                this.new_channel_input = '#';
	            }
	
	            this.new_channel_input_has_focus = true;
	        },
	        onNewChannelInputBlur: function onNewChannelInputBlur() {
	            if (this.new_channel_input === '#') {
	                this.new_channel_input = '';
	            }
	
	            this.new_channel_input_has_focus = false;
	        },
	        submitNewChannelForm: function submitNewChannelForm() {
	            var newChannelVal = this.new_channel_input;
	            this.new_channel_input = '#';
	
	            var network = this.network;
	            var bufferObjs = Misc.extractBuffers(newChannelVal);
	
	            var hasSwitchedActiveBuffer = false;
	            bufferObjs.forEach(function (bufferObj) {
	                var chanName = bufferObj.name;
	                var ignoreNames = ['#0', '0', '&0'];
	                if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
	                    return;
	                }
	
	                var newBuffer = _state2.default.addBuffer(network.id, chanName);
	                if (newBuffer && !hasSwitchedActiveBuffer) {
	                    _state2.default.setActiveBuffer(network.id, newBuffer.name);
	                    hasSwitchedActiveBuffer = true;
	                }
	
	                if (bufferObj.key) {
	                    newBuffer.key = bufferObj.key;
	                }
	
	                if (network.isChannelName(chanName)) {
	                    network.ircClient.join(chanName, bufferObj.key);
	                }
	            });
	        }
	    },
	    computed: {
	        isActiveNetwork: function isActiveNetwork() {
	            return _state2.default.getActiveNetwork() === this.network;
	        }
	    }
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            whoisRequested: false,
	            whoisLoading: false
	        };
	    },
	    props: ['buffer', 'network', 'user'],
	    computed: {
	        availableChannelModes: function availableChannelModes() {
	            var availableModes = [];
	            var prefixes = this.network.ircClient.network.options.PREFIX;
	
	            var knownPrefix = {
	                q: 'Owner',
	                a: 'Admin',
	                o: 'Operator',
	                h: 'Half-Operator',
	                v: 'Voice'
	            };
	            prefixes.forEach(function (prefix) {
	                var mode = prefix.mode;
	                if (knownPrefix[mode]) {
	                    availableModes.push({
	                        mode: mode,
	                        description: knownPrefix[mode]
	                    });
	                }
	            });
	
	            return availableModes;
	        },
	        areWeAnOp: function areWeAnOp() {
	            if (!this.buffer) {
	                return false;
	            }
	
	            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
	        },
	        isUserOnBuffer: function isUserOnBuffer() {
	            if (!this.buffer) {
	                return false;
	            }
	
	            if (!this.user.buffers[this.buffer.id]) {
	                return false;
	            }
	
	            return true;
	        },
	        userMode: {
	            get: function getUserMode() {
	                if (!this.buffer) {
	                    return '';
	                }
	
	                var userBufferInfo = this.user.buffers[this.buffer.id];
	                if (!userBufferInfo) {
	                    return '';
	                }
	
	                var modes = userBufferInfo.modes;
	                return modes.length > 0 ? modes[0] : '';
	            },
	
	            set: function setUserMode(newVal) {
	                var client = this.network.ircClient;
	                var oldVal = this.userMode;
	
	                var changes = [];
	                var targets = [];
	
	                if (oldVal) {
	                    changes.push('-' + oldVal);
	                    targets.push(this.user.nick);
	                }
	                if (newVal) {
	                    changes.push('+' + newVal);
	                    targets.push(this.user.nick);
	                }
	
	                var params = ['MODE', this.buffer.name, changes.join('')].concat(targets);
	                client.raw(params);
	            }
	        }
	    },
	    methods: {
	        userModeOnThisBuffer: function userModeOnBuffer(user) {
	            if (!this.buffer) {
	                return '';
	            }
	
	            var userBufferInfo = user.buffers[this.buffer.id];
	            var modes = userBufferInfo.modes;
	            return modes.length > 0 ? modes[0] : '';
	        },
	        openQuery: function openQuery() {
	            var buffer = _state2.default.addBuffer(this.network.id, this.user.nick);
	            _state2.default.setActiveBuffer(this.network.id, buffer.name);
	        },
	        updateWhoisData: function updateWhoisData() {
	            var _this = this;
	
	            this.whoisRequested = true;
	            this.whoisLoading = true;
	            this.network.ircClient.whois(this.user.nick, function () {
	                _this.whoisLoading = false;
	            });
	        },
	        kickUser: function kickUser() {
	            var reason = _state2.default.setting('buffers.default_kick_reason');
	            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
	        },
	        createBanMask: function banMask() {
	            var mask = _state2.default.setting('buffers.default_ban_mask');
	            mask = mask.replace('%n', this.user.nick);
	            mask = mask.replace('%i', this.user.username);
	            mask = mask.replace('%h', this.user.host);
	
	            return mask;
	        },
	        banUser: function banUser() {
	            if (!this.user.username || !this.user.host) {
	                return;
	            }
	
	            var banMask = this.createBanMask();
	            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
	        },
	        kickbanUser: function kickbanuser() {
	            if (!this.user.username || !this.user.host) {
	                return;
	            }
	
	            var banMask = this.createBanMask();
	            var reason = _state2.default.setting('buffers.default_kick_reason');
	            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
	            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
	        },
	        maybeRepositionTop: function maybeRepositionTop() {
	            var rect = this.$el.getBoundingClientRect();
	
	            var targetTop = parseInt((this.$el.style.top || '').replace('px', ''), 10);
	
	            if (targetTop + rect.height > window.innerHeight) {
	                this.$el.style.top = window.innerHeight - rect.height + 'px';
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.maybeRepositionTop();
	    },
	    updated: function updated() {
	        this.maybeRepositionTop();
	    },
	    watch: {
	        user: function watchUser() {
	            this.whoisRequested = false;
	            this.whoisLoading = false;
	        }
	    }
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            location: _state2.default.setting('emojiLocation')
	        };
	    },
	    computed: {
	        emojis: function emojis() {
	            var list = {};
	            var available = _state2.default.setting('emojis');
	            _lodash2.default.each(available, function (code, ascii) {
	                list[code] = ascii;
	            });
	            return list;
	        }
	    },
	    props: ['ircinput'],
	    methods: {
	        onImgClick: function onImgClick(event) {
	            var url = window.getComputedStyle(event.target, null).getPropertyValue('background-image');
	
	            url = url.replace('url(', '').replace(')', '');
	            url = url.replace(' ', '').replace(/"/g, '');
	            var code = event.target.dataset.code;
	            this.ircinput.addImg(code, url);
	        }
	    }
	};

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    props: ['ircinput'],
	
	    methods: {
	        onColourClick: function onColourClick(event) {
	            var colour = window.getComputedStyle(event.target, null).getPropertyValue('background-color');
	            var code = event.target.dataset.code;
	            this.ircinput.setColour(code, colour);
	        },
	        onImgClick: function onImgClick(event) {
	            var url = window.getComputedStyle(event.target, null).getPropertyValue('background-image');
	
	            url = url.replace('url(', '').replace(')', '');
	            url = url.replace(' ', '').replace(/"/g, '');
	            var code = event.target.dataset.code;
	            this.ircinput.addImg(code, url);
	        },
	        onResetClick: function onResetClick() {
	            this.ircinput.resetStyles();
	        }
	    }
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            title: 'Where are you connecting today?',
	            buttonText: '',
	            server_type: 'default',
	            server: '',
	            tls: false,
	            nick: '',
	            password: '',
	            encoding: 'utf8',
	            channel: '',
	            znc_network: '',
	            znc_network_support: true,
	            direct: false,
	            show_type_switcher: true,
	            show_password_box: false,
	            is_connecting: false,
	            connecting_net: null
	        };
	    },
	    methods: {
	        readableStateError: function readableStateError(err) {
	            return Misc.networkErrorMessage(err);
	        },
	
	        startUp: function startUp() {
	            var _this = this;
	
	            var net = void 0;
	
	            if (!this.nick) {
	                this.$el.querySelector('.kiwi-customserver-nick input').focus();
	                return;
	            }
	
	            var nick = this.nick;
	
	            if (this.server_type === 'znc') {
	                var password = nick;
	                if (this.znc_network) {
	                    password += '/' + this.znc_network;
	                }
	                password += ':' + this.password;
	
	                net = _state2.default.addNetwork('ZNC', nick, {
	                    server: this.server.split(':')[0],
	                    port: parseInt(this.server.split(':')[1] || 6667, 10),
	                    tls: this.tls,
	                    password: password
	                });
	            } else {
	                net = _state2.default.addNetwork('Network', nick, {
	                    server: this.server.split(':')[0],
	                    port: parseInt(this.server.split(':')[1] || 6667, 10),
	                    tls: this.tls,
	                    password: this.password,
	                    direct: this.direct,
	                    encoding: this.encoding
	                });
	            }
	
	            if (net) {
	                var hasSetActiveBuffer = false;
	
	                var bufferObjs = Misc.extractBuffers(this.channel);
	                bufferObjs.forEach(function (bufferObj, idx) {
	                    var buffer = _state2.default.addBuffer(net.id, bufferObj.name);
	                    buffer.enabled = true;
	
	                    if (bufferObj.key) {
	                        buffer.key = bufferObj.key;
	                    }
	
	                    if (idx === 0) {
	                        _state2.default.setActiveBuffer(net.id, buffer.name);
	                        hasSetActiveBuffer = true;
	                    }
	                });
	
	                if (!hasSetActiveBuffer) {
	                    _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
	                }
	
	                this.is_connecting = true;
	                this.connecting_net = net;
	                net.ircClient.connect();
	
	                var onRegistered = function onRegistered() {
	                    setTimeout(function () {
	                        _this.is_connecting = false;
	                    }, 1000);
	                    _this.$emit('start');
	                    net.ircClient.off('registered', onRegistered);
	                    net.ircClient.off('close', onClosed);
	                };
	                var onClosed = function onClosed() {
	                    setTimeout(function () {
	                        _this.is_connecting = false;
	                    }, 1000);
	                    net.ircClient.off('registered', onRegistered);
	                    net.ircClient.off('close', onClosed);
	                };
	                net.ircClient.once('registered', onRegistered);
	                net.ircClient.once('close', onClosed);
	            }
	        },
	        processNickRandomNumber: function processNickRandomNumber(nick) {
	            var tmp = (nick || '').replace(/\?/g, function () {
	                return Math.floor(Math.random() * 100).toString();
	            });
	            return _lodash2.default.trim(tmp);
	        },
	        infoClick: function infoClick() {
	            if (this.connecting_net) {
	                var net = this.connecting_net;
	                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
	            }
	            this.$emit('start');
	        },
	        parseConnectionString: function parseConnectionString(str) {
	            var reg = /(?:(ircs?):\/\/)?([a-z.0-9]+)(?::(?:(\+)?([0-9]+)))?(?:\/([^?]*))?(?:\?(.*))?/;
	            var connections = [];
	            str.split(';').forEach(function (connectionString) {
	                if (!connectionString) {
	                    return;
	                }
	
	                var m = connectionString.match(reg);
	
	                if (!m) {
	                    return;
	                }
	
	                var tls = m[1] === 'ircs' || !!m[3];
	                var params = (0, _create2.default)(null);
	                (m[6] || '').split('&').forEach(function (p) {
	                    var parts = p.split('=');
	                    if (parts.length === 2) {
	                        params[parts[0].toLowerCase()] = parts[1];
	                    }
	                });
	
	                var channels = m[5] || params.channel || '';
	                channels = (0, _lodash2.default)(channels.split(',')).compact().map(function (_channelName) {
	                    var hasPrefix = _channelName[0] === '#' || _channelName[0] === '&';
	
	                    var channelName = hasPrefix ? _channelName : '#' + _channelName;
	
	                    return channelName;
	                });
	
	                connections.push({
	                    tls: tls,
	                    server: m[2],
	                    port: parseInt(m[4] || (tls ? 6697 : 6667), 10),
	                    channels: channels,
	                    nick: params.nick || '',
	                    encoding: params.encoding || 'utf8',
	                    params: params
	                });
	            });
	
	            return connections;
	        },
	        applyDefaults: function applyDefaults() {
	            this.server = _state2.default.settings.startupOptions.server;
	            this.tls = _state2.default.settings.startupOptions.tls;
	            this.nick = this.processNickRandomNumber(_state2.default.settings.startupOptions.nick);
	            this.channel = _state2.default.settings.startupOptions.channel;
	            this.direct = _state2.default.settings.startupOptions.direct;
	            this.encoding = _state2.default.settings.startupOptions.encoding;
	
	            if (_state2.default.settings.startupOptions.port.toString() !== '6667') {
	                this.server += ':' + _state2.default.settings.startupOptions.port.toString();
	            }
	
	            this.title = 'Where are you connecting today?';
	        }
	    },
	    created: function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	            var saveThisSessionsState, network, fragment, uriCheck, connections, con;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            saveThisSessionsState = false;
	
	                            if (_state2.default.networks.length > 0) {
	                                network = _state2.default.networks[0];
	
	                                _state2.default.setActiveBuffer(network.id, network.serverBuffer().name);
	                                saveThisSessionsState = true;
	                                this.$emit('start');
	                            } else if (window.location.hash.substr(1)) {
	                                fragment = window.location.hash.substr(1);
	                                uriCheck = fragment.substr(0, 7).toLowerCase();
	
	                                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
	                                    fragment = decodeURIComponent(fragment);
	                                }
	
	                                connections = this.parseConnectionString(fragment);
	
	                                if (connections.length === 0) {
	                                    saveThisSessionsState = true;
	                                    this.applyDefaults();
	                                } else if (connections.length === 1) {
	                                    saveThisSessionsState = false;
	                                    this.server_type = 'default_simple';
	                                    this.show_type_switcher = false;
	
	                                    con = connections[0];
	
	                                    this.server = con.server + ':' + con.port;
	                                    this.tls = con.tls;
	                                    this.nick = this.processNickRandomNumber(con.nick);
	                                    this.channel = con.channels.join(',');
	                                    this.direct = con.direct;
	                                    this.encoding = con.encoding;
	
	                                    if (con.params.type === 'znc') {
	                                        if (con.params.network === '_') {
	                                            this.znc_network_support = false;
	                                        } else {
	                                            this.znc_network = con.params.network || '';
	                                        }
	                                        this.server_type = 'znc';
	                                        this.title = 'Enter your password to connect to ZNC';
	                                    } else {
	                                        this.title = 'Enter a nickname to join';
	                                    }
	                                } else if (connections.length > 1) {
	                                    saveThisSessionsState = false;
	
	                                    connections.forEach(function (con, idx) {
	                                        var net = _state2.default.addNetwork(con.server, con.nick, {
	                                            server: con.server,
	                                            port: con.port,
	                                            tls: con.tls,
	                                            password: con.password || ''
	                                        });
	
	                                        con.channels.forEach(function (channelName) {
	                                            var buffer = _state2.default.addBuffer(net.id, channelName);
	                                            buffer.enabled = true;
	                                        });
	
	                                        if (idx === 0) {
	                                            _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
	                                        }
	                                    });
	
	                                    this.$emit('start');
	                                }
	                            } else {
	                                saveThisSessionsState = true;
	                                this.applyDefaults();
	                            }
	
	                            if (_state2.default.settings.startupOptions.greetingText) {
	                                this.title = _state2.default.settings.startupOptions.greetingText;
	                            }
	                            if (_state2.default.settings.startupOptions.buttonText) {
	                                this.buttonText = _state2.default.settings.startupOptions.buttonText;
	                            } else {
	                                this.buttonText = this.$t('connect');
	                            }
	
	                            if (saveThisSessionsState) {
	                                _state2.default.persistence.watchStateForChanges();
	                            }
	
	                        case 5:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        function created() {
	            return _ref.apply(this, arguments);
	        }
	
	        return created;
	    }()
	};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(231);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _Logger = __webpack_require__(29);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = _Logger2.default.namespace('Startup/kiwiBnc');
	
	exports.default = {
	    created: function created() {
	        window.t = this;
	    },
	    data: function data() {
	        return {
	            closing: false,
	            loading: false,
	            username: '',
	            password: '',
	            statusMessage: ''
	        };
	    },
	    computed: {
	        greetingText: function greetingText() {
	            var greeting = _state2.default.settings.startupOptions.greetingText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
	        },
	        buttonText: function buttonText() {
	            if (this.loading) {
	                return '';
	            }
	
	            var greeting = _state2.default.settings.startupOptions.buttonText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_button');
	        },
	        infoStyle: function infoStyle() {
	            var style = {};
	            var options = _state2.default.settings.startupOptions;
	
	            if (options.infoBackground) {
	                style['background-image'] = 'url(' + options.infoBackground + ')';
	            } else {
	                style['background-color'] = '#333333';
	            }
	
	            return style;
	        },
	        infoContent: function infoContent() {
	            return _state2.default.settings.startupOptions.infoContent || '';
	        }
	    },
	    methods: {
	        close: function close() {
	            var _this = this;
	
	            this.closing = true;
	            this.$el.addEventListener('transitionend', function (event) {
	                _state2.default.persistence.watchStateForChanges();
	                _this.$emit('start');
	            }, false);
	        },
	        startUp: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	                var _this2 = this;
	
	                var bncnet, cleanUpEvents, onRegistered, onError, onClose;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.statusMessage = this.$t('logging_in');
	                                this.loading = true;
	
	                                bncnet = this.getBncNetwork();
	
	                                cleanUpEvents = function cleanUpEvents() {
	                                    bncnet.ircClient.off('registered', onRegistered);
	                                    bncnet.ircClient.off('irc error', onError);
	                                    bncnet.ircClient.off('close', onClose);
	                                };
	
	                                onRegistered = function () {
	                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                                        var bncNetworks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, network, buffers;
	
	                                        return _regenerator2.default.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        cleanUpEvents();
	
	                                                        _context.next = 3;
	                                                        return bncnet.ircClient.bnc.getNetworks();
	
	                                                    case 3:
	                                                        bncNetworks = _context.sent;
	                                                        _iteratorNormalCompletion = true;
	                                                        _didIteratorError = false;
	                                                        _iteratorError = undefined;
	                                                        _context.prev = 7;
	                                                        _iterator = (0, _getIterator3.default)(bncNetworks);
	
	                                                    case 9:
	                                                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                                            _context.next = 26;
	                                                            break;
	                                                        }
	
	                                                        network = _step.value;
	
	                                                        network.buffers = [];
	                                                        _context.prev = 12;
	                                                        _context.next = 15;
	                                                        return bncnet.ircClient.bnc.getBuffers(network.name);
	
	                                                    case 15:
	                                                        buffers = _context.sent;
	
	                                                        network.buffers = buffers;
	                                                        _context.next = 22;
	                                                        break;
	
	                                                    case 19:
	                                                        _context.prev = 19;
	                                                        _context.t0 = _context['catch'](12);
	
	                                                        log.error(_context.t0);
	
	                                                    case 22:
	
	                                                        _this2.addNetworkToState(network);
	
	                                                    case 23:
	                                                        _iteratorNormalCompletion = true;
	                                                        _context.next = 9;
	                                                        break;
	
	                                                    case 26:
	                                                        _context.next = 32;
	                                                        break;
	
	                                                    case 28:
	                                                        _context.prev = 28;
	                                                        _context.t1 = _context['catch'](7);
	                                                        _didIteratorError = true;
	                                                        _iteratorError = _context.t1;
	
	                                                    case 32:
	                                                        _context.prev = 32;
	                                                        _context.prev = 33;
	
	                                                        if (!_iteratorNormalCompletion && _iterator.return) {
	                                                            _iterator.return();
	                                                        }
	
	                                                    case 35:
	                                                        _context.prev = 35;
	
	                                                        if (!_didIteratorError) {
	                                                            _context.next = 38;
	                                                            break;
	                                                        }
	
	                                                        throw _iteratorError;
	
	                                                    case 38:
	                                                        return _context.finish(35);
	
	                                                    case 39:
	                                                        return _context.finish(32);
	
	                                                    case 40:
	
	                                                        _this2.monitorNetworkChanges(bncnet, bncNetworks);
	                                                        _this2.close();
	
	                                                    case 42:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, _this2, [[7, 28, 32, 40], [12, 19], [33,, 35, 39]]);
	                                    }));
	
	                                    return function onRegistered() {
	                                        return _ref2.apply(this, arguments);
	                                    };
	                                }();
	
	                                onError = function onError(event) {
	                                    cleanUpEvents();
	                                    _this2.statusMessage = _this2.$t('invalid_login');
	                                    _this2.loading = false;
	                                };
	
	                                onClose = function onClose(event) {
	                                    cleanUpEvents();
	                                    _this2.statusMessage = _this2.$t('invalid_login');
	                                    _this2.loading = false;
	                                };
	
	                                bncnet.ircClient.once('registered', onRegistered);
	                                bncnet.ircClient.once('irc error', onError);
	                                bncnet.ircClient.once('close', onClose);
	                                bncnet.ircClient.connect();
	
	                            case 11:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function startUp() {
	                return _ref.apply(this, arguments);
	            }
	
	            return startUp;
	        }(),
	
	        getBncNetwork: function getBncNetwork() {
	            var bnc = _state2.default.setting('bnc');
	
	            if (bnc.network) {
	                bnc.username = this.username;
	                bnc.password = this.password;
	                return bnc.network;
	            }
	
	            var options = _state2.default.settings.startupOptions;
	
	            bnc.active = true;
	            bnc.server = options.server || '';
	            bnc.port = options.port || 6667;
	            bnc.tls = !!options.tls;
	            bnc.username = this.username;
	            bnc.password = this.password;
	
	            var bncnet = _state2.default.addNetwork('bnccontrol', this.username, {
	                server: bnc.server,
	                port: bnc.port,
	                tls: bnc.tls
	            });
	
	            bnc.network = bncnet;
	
	            return bncnet;
	        },
	
	        addNetworkToState: function addNetworkToState(network) {
	            var net = _state2.default.addNetwork(network.name, network.nick, {
	                server: network.host,
	                port: network.port,
	                tls: network.tls,
	                password: network.password,
	                bncname: network.name,
	                username: network.user
	            });
	
	            network.buffers.forEach(function (buffer) {
	                var newBuffer = _state2.default.addBuffer(net.id, buffer.name);
	                if (buffer.joined) {
	                    newBuffer.enabled = true;
	                }
	                if (buffer.seen) {
	                    newBuffer.last_read = new Date(buffer.seen).getTime();
	                }
	            });
	        },
	
	        monitorNetworkChanges: function monitorNetworkChanges(bncNet, bncNetworks) {
	            var existingNets = (0, _create2.default)(null);
	            function rememberNetworks() {
	                _state2.default.networks.forEach(function (network) {
	                    if (!network.connection.bncname) {
	                        return;
	                    }
	
	                    existingNets[network.connection.bncname] = {
	                        name: network.connection.bncname,
	                        host: network.connection.server,
	                        port: network.connection.port,
	                        tls: network.connection.tls,
	                        password: network.connection.password,
	                        nick: network.nick,
	                        username: network.username
	                    };
	                });
	            }
	
	            rememberNetworks();
	
	            var saveState = function saveState(newVal) {
	                _state2.default.networks.forEach(function (network) {
	                    if (network.name === 'bnccontrol') {
	                        return;
	                    }
	
	                    var bncName = network.connection.bncname;
	                    var current = existingNets[bncName] || {};
	                    var tags = {};
	
	                    if (network.connection.server !== current.host) {
	                        tags.host = network.connection.server;
	                    }
	                    if (network.connection.port !== current.port) {
	                        tags.port = network.connection.port;
	                    }
	                    if (network.connection.tls !== current.tls) {
	                        tags.tls = network.connection.tls;
	                    }
	                    if (network.connection.password !== current.password) {
	                        tags.password = network.connection.password;
	                    }
	                    if (network.nick !== current.nick) {
	                        tags.nick = network.nick;
	                    }
	                    if (network.username !== current.username) {
	                        tags.user = network.username;
	                    }
	
	                    if (!current.name && tags.host) {
	                        network.connection.bncname = network.name;
	                        bncNet.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
	                    } else if (current.name) {
	                        bncNet.ircClient.bnc.saveNetwork(bncName, tags);
	                    }
	                });
	
	                rememberNetworks();
	            };
	
	            var debouncedSaveState = _lodash2.default.debounce(saveState, 2000);
	
	            _state2.default.$watch('networks', debouncedSaveState, { deep: true });
	
	            _state2.default.$on('network.connecting', function (event) {
	                saveState();
	
	                var netName = event.network.connection.bncname;
	                var networkFromBnc = _lodash2.default.find(bncNetworks, { name: netName });
	                if (networkFromBnc && !networkFromBnc.connected) {
	                    bncNet.ircClient.raw('BOUNCER connect ' + netName);
	                }
	            });
	
	            _state2.default.$on('network.new', function (event) {
	                var currentNum = 1;
	                var existingNet = true;
	                while (existingNet) {
	                    existingNet = _lodash2.default.find(_state2.default.networks, { name: 'Network' + currentNum });
	                    if (!existingNet) {
	                        event.network.name = 'Network' + currentNum;
	                    }
	
	                    currentNum++;
	                }
	            });
	
	            _state2.default.$on('network.removed', function (event) {
	                bncNet.ircClient.bnc.removeNetwork(event.network.connection.bncname);
	            });
	
	            _state2.default.$on('buffer.close', function (event) {
	                var buffer = event.buffer;
	                var network = event.buffer.getNetwork();
	                var bncName = network.connection.bncname;
	
	                if (bncName) {
	                    bncNet.ircClient.bnc.closeBuffer(bncName, buffer.name);
	                }
	            });
	        }
	    }
	};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firstRun = true;
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    computed: {
	        networks: function networks() {
	            return _state2.default.networks;
	        }
	    },
	    methods: {
	        addNetwork: function addNetwork() {
	            var nick = 'Guest' + Math.floor(Math.random() * 100);
	            var network = _state2.default.addNetwork('New Network', nick, {});
	            _state2.default.$emit('network.settings', network);
	        },
	        toggleStateBrowser: function toggleStateBrowser() {
	            _state2.default.$emit('statebrowser.show');
	        },
	        init: function init() {
	            var _this = this;
	
	            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _state2.default.persistence.watchStateForChanges();
	                                _this.$emit('start', {
	                                    fallbackComponent: _this.constructor
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this);
	            }))();
	        }
	    },
	    created: function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (firstRun) {
	                                this.init();
	                                firstRun = false;
	                            }
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function created() {
	            return _ref.apply(this, arguments);
	        }
	
	        return created;
	    }()
	};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            network: null,
	            channel: '',
	            nick: '',
	            password: '',
	            showChannel: true,
	            showPass: true,
	            showNick: true,
	            show_password_box: false,
	            closing: false
	        };
	    },
	    computed: {
	        greetingText: function greetingText() {
	            var greeting = _state2.default.settings.startupOptions.greetingText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
	        },
	        buttonText: function buttonText() {
	            var greeting = _state2.default.settings.startupOptions.buttonText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_button');
	        },
	        readyToStart: function readyToStart() {
	            var ready = this.channel && this.nick;
	
	            if (!this.nick.match(/^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i)) {
	                ready = false;
	            }
	
	            return ready;
	        },
	        infoStyle: function infoStyle() {
	            var style = {};
	            var options = _state2.default.settings.startupOptions;
	
	            if (options.infoBackground) {
	                style['background-image'] = 'url(' + options.infoBackground + ')';
	            } else {
	                style['background-color'] = '#333333';
	            }
	
	            return style;
	        },
	        infoContent: function infoContent() {
	            return _state2.default.settings.startupOptions.infoContent || '';
	        }
	    },
	    methods: {
	        readableStateError: function readableStateError(err) {
	            return Misc.networkErrorMessage(err);
	        },
	
	        close: function close() {
	            var _this = this;
	
	            this.closing = true;
	            this.$el.addEventListener('transitionend', function (event) {
	                _state2.default.persistence.watchStateForChanges();
	                _this.$emit('start');
	            }, false);
	        },
	        formSubmit: function formSubmit() {
	            if (this.readyToStart) {
	                this.startUp();
	            }
	        },
	        startUp: function startUp() {
	            var _this2 = this;
	
	            var options = _state2.default.settings.startupOptions;
	
	            var net = void 0;
	            if (!this.network) {
	                net = this.network = _state2.default.addNetwork('Network', this.nick, {
	                    server: _lodash2.default.trim(options.server),
	                    port: options.port,
	                    tls: options.tls,
	                    password: this.password,
	                    encoding: _lodash2.default.trim(options.encoding),
	                    direct: !!options.direct,
	                    gecos: options.gecos
	                });
	            } else {
	                net = this.network;
	            }
	
	            var hasSwitchedActiveBuffer = false;
	            var bufferObjs = Misc.extractBuffers(this.channel);
	            bufferObjs.forEach(function (bufferObj) {
	                var newBuffer = _state2.default.addBuffer(net.id, bufferObj.name);
	                newBuffer.enabled = true;
	
	                if (newBuffer && !hasSwitchedActiveBuffer) {
	                    _state2.default.setActiveBuffer(net.id, newBuffer.name);
	                    hasSwitchedActiveBuffer = true;
	                }
	
	                if (bufferObj.key) {
	                    newBuffer.key = bufferObj.key;
	                }
	            });
	
	            net.ircClient.connect();
	            var onRegistered = function onRegistered() {
	                _this2.close();
	                net.ircClient.off('registered', onRegistered);
	                net.ircClient.off('close', onClosed);
	            };
	            var onClosed = function onClosed() {
	                net.ircClient.off('registered', onRegistered);
	                net.ircClient.off('close', onClosed);
	            };
	            net.ircClient.once('registered', onRegistered);
	            net.ircClient.once('close', onClosed);
	        },
	        processNickRandomNumber: function processNickRandomNumber(nick) {
	            var tmp = (nick || '').replace(/\?/g, function () {
	                return Math.floor(Math.random() * 100).toString();
	            });
	            return _lodash2.default.trim(tmp);
	        }
	    },
	    created: function created() {
	        var options = _state2.default.settings.startupOptions;
	
	        this.nick = this.processNickRandomNumber(Misc.queryStringVal('nick') || options.nick || '');
	        this.password = options.password || '';
	        this.channel = window.location.hash || options.channel || '';
	        this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
	        this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
	        this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
	
	        if (options.autoConnect && this.nick && this.channel) {
	            this.startUp();
	        }
	    }
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Misc = __webpack_require__(20);
	
	var Misc = _interopRequireWildcard(_Misc);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            network: null,
	            network_extras: null,
	            username: '',
	            password: '',
	            znc_network: '',
	            showNetwork: true,
	            showPass: true,
	            showUser: true,
	            show_password_box: false,
	            closing: false
	        };
	    },
	    computed: {
	        greetingText: function greetingText() {
	            var greeting = _state2.default.settings.startupOptions.greetingText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
	        },
	        buttonText: function buttonText() {
	            var greeting = _state2.default.settings.startupOptions.buttonText;
	            return typeof greeting === 'string' ? greeting : this.$t('start_button');
	        },
	        readyToStart: function readyToStart() {
	            return this.username && (this.password || this.showPass === false);
	        },
	        infoStyle: function infoStyle() {
	            var style = {};
	            var options = _state2.default.settings.startupOptions;
	
	            if (options.infoBackground) {
	                style['background-image'] = 'url(' + options.infoBackground + ')';
	            } else {
	                style['background-color'] = '#333333';
	            }
	
	            return style;
	        },
	        infoContent: function infoContent() {
	            return _state2.default.settings.startupOptions.infoContent || '';
	        }
	    },
	    methods: {
	        readableStateError: function readableStateError(err) {
	            return Misc.networkErrorMessage(err);
	        },
	
	        close: function close() {
	            var _this = this;
	
	            this.closing = true;
	            this.$el.addEventListener('transitionend', function (event) {
	                _this.$emit('start');
	            }, false);
	        },
	        formSubmit: function formSubmit() {
	            if (this.readyToStart) {
	                this.startUp();
	            }
	        },
	        addNetwork: function addNetwork(netName) {
	            var options = _state2.default.settings.startupOptions;
	            var password = this.username;
	            if (netName) {
	                password += '/' + netName;
	            }
	            password += ':' + this.password;
	
	            var net = _state2.default.addNetwork(netName, this.username, {
	                server: _lodash2.default.trim(options.server),
	                port: options.port,
	                tls: options.tls,
	                password: password
	            });
	            return net;
	        },
	        startUp: function startUp() {
	            var _this2 = this;
	
	            if (this.network) {
	                _state2.default.removeNetwork(this.network.id);
	            }
	
	            var netList = _lodash2.default.compact(this.znc_network.split(','));
	            if (netList.length === 0) {
	                netList.push('');
	            }
	
	            var net = this.network = this.addNetwork(netList.shift());
	            this.network_extras = netList;
	
	            var onRegistered = function onRegistered() {
	                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
	                net.ircClient.off('registered', onRegistered);
	                net.ircClient.off('close', onClosed);
	                _this2.network_extras.forEach(function (netName, idx) {
	                    var extraNet = _this2.addNetwork(_lodash2.default.trim(netName));
	                    extraNet.ircClient.connect();
	                });
	                _this2.close();
	            };
	            var onClosed = function onClosed() {
	                net.ircClient.off('registered', onRegistered);
	                net.ircClient.off('close', onClosed);
	            };
	            net.ircClient.once('registered', onRegistered);
	            net.ircClient.once('close', onClosed);
	            net.ircClient.connect();
	        }
	    },
	    created: function created() {
	        var options = _state2.default.settings.startupOptions;
	
	        this.username = options.username || '';
	        this.password = options.password || '';
	        this.znc_network = window.location.hash.substr(1) || options.network || '';
	        this.showNetwork = typeof options.showNetwork === 'boolean' ? options.showNetwork : true;
	        this.showUser = typeof options.showUser === 'boolean' ? options.showUser : true;
	        this.showPass = typeof options.showPass === 'boolean' ? options.showPass : true;
	
	        if (options.autoConnect && this.username && this.password) {
	            this.startUp();
	        }
	    }
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Vue = __webpack_require__(28);
	
	exports.default = Vue.component('input-prompt', {
	    data: function data() {
	        return {
	            value: '',
	            state: 'pre'
	        };
	    },
	    props: ['label'],
	    methods: {
	        prompt: function prompt() {
	            var _this = this;
	
	            this.state = 'prompt';
	            this.$nextTick(function () {
	                _this.$el.querySelector('input').focus();
	            });
	        },
	        complete: function complete() {
	            this.$emit('submit', this.value);
	            this.state = 'pre';
	        },
	        cancel: function cancel() {
	            this.$emit('cancel');
	            this.state = 'pre';
	        }
	    }
	});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Vue = __webpack_require__(28);
	
	exports.default = Vue.component('input-text', {
	    data: function data() {
	        return {
	            hasFocus: false
	        };
	    },
	    props: ['value', 'label', 'type'],
	    computed: {
	        currentValue: {
	            get: function getCurrentValue() {
	                return this.value;
	            },
	            set: function setCurrentValue(newVal) {
	                this.$emit('input', newVal);
	            }
	        }
	    },
	    methods: {
	        updateValue: function updateValue(newValue) {
	            this.$emit('input', newValue);
	        }
	    }
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _create = __webpack_require__(5);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _htmlparser = __webpack_require__(49);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vue = __webpack_require__(28);
	
	exports.default = Vue.component('irc-input', {
	    data: function data() {
	        return {
	            last_known_value: '',
	            text_value: '',
	            current_el: null,
	            current_el_pos: 0,
	            current_range: null,
	            default_colour: null,
	            code_map: (0, _create2.default)(null)
	        };
	    },
	    props: ['placeholder'],
	    computed: {
	        editor: function editor() {
	            return this.$refs.editor;
	        }
	    },
	    methods: {
	        onTextInput: function onTextInput(event) {
	            if (event.data[event.data.length - 1] === '\n') {
	                event.preventDefault();
	                this.setCurrentWord(event.data.trim());
	            }
	        },
	        onPaste: function onPaste(event) {
	            event.stopPropagation();
	            event.preventDefault();
	
	            var clipboardData = event.clipboardData || window.clipboardData;
	            var pastedData = clipboardData.getData('Text');
	
	            var selection = window.getSelection();
	            var range = selection.getRangeAt(0);
	            if (range) {
	                range.deleteContents();
	                range.insertNode(document.createTextNode(pastedData));
	
	                var selPos = this.current_range[0] + pastedData.length;
	                this.current_range = [selPos, selPos];
	            }
	            this.focus();
	        },
	        updateValueProps: function updateValueProps() {
	            var selection = window.getSelection();
	            this.current_el_pos = selection.anchorOffset;
	            this.current_el = selection.anchorNode;
	
	            var range = null;
	            var currentRange = selection.getRangeAt(0);
	            if (currentRange) {
	                range = currentRange.cloneRange();
	                range.selectNodeContents(this.$refs.editor);
	                range.setEnd(currentRange.startContainer, currentRange.startOffset);
	            }
	
	            var start = range.toString().length;
	            this.current_range = [start, start + currentRange.toString().length];
	
	            this.maybeEmitInput();
	        },
	        selectionToEnd: function selectionToEnd() {
	            var len = this.$refs.editor.innerHTML.length;
	            this.current_range = [len, len];
	            this.focus();
	        },
	        setValue: function setValue(newVal) {
	            this.value = newVal;
	            this.$refs.editor.innerHTML = newVal;
	        },
	        getValue: function getValue() {
	            return this.$refs.editor.innerHTML;
	        },
	        maybeEmitInput: function maybeEmitInput() {
	            var currentHtml = this.$refs.editor.innerHTML;
	            if (this.last_known_value !== currentHtml) {
	                this.$emit('input', currentHtml);
	                this.last_known_value = currentHtml;
	            }
	        },
	        buildIrcText: function buildIrcText() {
	            var _this = this;
	
	            var source = this.$refs.editor.innerHTML;
	            var textValue = '';
	
	            var parser = new _htmlparser2.default.Parser({
	                onopentag: function onopentag(name, attribs) {
	                    var codeLookup = '';
	                    if (attribs.style) {
	                        var match = attribs.style.match(/color: ([^;]+)/);
	                        if (match) {
	                            codeLookup = match[1];
	                            if (_this.code_map[codeLookup]) {
	                                textValue += '\x03' + _this.code_map[codeLookup];
	                            }
	                        }
	                    }
	                    if (attribs.src && _this.code_map[attribs.src]) {
	                        textValue += _this.code_map[attribs.src];
	                    }
	                },
	                ontext: function ontext(text) {
	                    textValue += text;
	                },
	                onclosetag: function onclosetag(tagName) {
	                    if (tagName === 'span') {
	                        textValue += '\x03';
	                    }
	                }
	            }, {
	                decodeEntities: true
	            });
	
	            parser.write(source);
	            parser.end();
	
	            return textValue;
	        },
	        reset: function reset(rawHtml) {
	            this.$refs.editor.innerHTML = rawHtml || '';
	
	            var br = this.$refs.editor.querySelector('br');
	            if (br) {
	                br.remove();
	            }
	
	            if (this.default_colour) {
	                this.focus();
	                this.setColour(this.default_colour.code, this.default_colour.colour);
	            }
	
	            this.updateValueProps();
	        },
	        resetStyles: function resetStyles() {
	            this.focus();
	            document.execCommand('styleWithCSS', false, true);
	            document.execCommand('selectAll', false, null);
	            document.execCommand('removeFormat', false, null);
	            this.default_colour = null;
	        },
	        setColour: function setColour(code, colour) {
	            var range = window.getSelection().getRangeAt(0);
	            if (range && range.collapsed) {
	                this.default_colour = {
	                    code: code,
	                    colour: colour
	                };
	            }
	
	            this.focus();
	            document.execCommand('styleWithCSS', false, true);
	            document.execCommand('foreColor', false, colour);
	
	            this.code_map[colour] = code;
	            this.updateValueProps();
	        },
	        addImg: function addImg(code, url) {
	            this.focus();
	            document.execCommand('styleWithCSS', false, true);
	            document.execCommand('insertImage', false, url);
	
	            this.code_map[url] = code;
	            this.updateValueProps();
	        },
	
	        insertText: function insertText(text) {
	            var el = this.current_el;
	            var pos = this.current_el_pos;
	            var val = el.textContent;
	            el.textContent = val.substr(0, pos) + text + val.substr(pos);
	
	            var newPos = pos + text.length;
	            this.current_range = [newPos, newPos];
	        },
	
	        setCurrentWord: function setCurrentWord(text, keepPosition) {
	            var el = this.current_el;
	            var pos = this.current_el_pos;
	            var val = el.textContent || '';
	
	            var startVal = val.substr(0, pos);
	            var space = startVal.lastIndexOf(' ');
	            if (space === -1) {
	                space = 0;
	            } else {
	                space++;
	            }
	            var startPos = space;
	
	            var endVal = val.substr(pos);
	            space = endVal.indexOf(' ');
	            if (space === -1) space = endVal.length;
	            var endPos = space;
	
	            el.textContent = startVal.substr(0, startPos) + text + endVal.substr(endPos);
	
	            var range = document.createRange();
	            if (keepPosition) {
	                range.setStart(el, pos);
	                range.setEnd(el, pos);
	            } else {
	                if (el.nodeType === 3) {
	                    range.setStart(el, startPos + text.length);
	                    range.setEnd(el, startPos + text.length);
	                } else {
	                    range.setStart(el, 1);
	                    range.setEnd(el, 1);
	                }
	            }
	
	            var sel = window.getSelection();
	            sel.removeAllRanges();
	            sel.addRange(range);
	            this.updateValueProps();
	        },
	
	        getCurrentWord: function getCurrentWord() {
	            var el = this.current_el;
	            var pos = this.current_el_pos;
	            var val = el.textContent;
	
	            var startVal = val.substr(0, pos);
	            var space = startVal.lastIndexOf(' ');
	            if (space === -1) {
	                space = 0;
	            } else {
	                space++;
	            }
	            var startPos = space;
	
	            space = val.indexOf(' ', startPos);
	            if (space === -1) space = val.length;
	            var endPos = space;
	
	            return {
	                word: val.substr(startPos, endPos),
	                position: pos - startPos
	            };
	        },
	
	        getRawText: function getRawText() {
	            return this.$refs.editor.innerText;
	        },
	
	        focus: function focus() {
	            if (this.current_range) {
	                var selection = window.getSelection();
	                var savedSel = this.current_range;
	
	                var charIndex = 0;
	                var range = document.createRange();
	                range.setStart(this.$refs.editor, 0);
	                range.collapse(true);
	                var nodeStack = [this.$refs.editor];
	                var node = null;
	                var foundStart = false;
	                var stop = false;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType === 3) {
	                        var nextCharIndex = charIndex + node.length;
	                        if (!foundStart && savedSel[0] >= charIndex && savedSel[0] <= nextCharIndex) {
	                            range.setStart(node, savedSel[0] - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && savedSel[1] >= charIndex && savedSel[1] <= nextCharIndex) {
	                            range.setEnd(node, savedSel[1] - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        var i = node.childNodes.length;
	                        while (i--) {
	                            nodeStack.push(node.childNodes[i]);
	                        }
	                    }
	                }
	
	                this.$refs.editor.focus();
	                selection.removeAllRanges();
	                selection.addRange(range);
	            } else {
	                this.$refs.editor.focus();
	            }
	        }
	    }
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Vue = __webpack_require__(28);
	
	Vue.component('tabbed-tab', {
	    template: '<div v-if="active" class="u-tabbed-content"><slot></slot></div>',
	    data: function data() {
	        return { active: false };
	    },
	    props: ['header', 'focus']
	});
	
	exports.default = Vue.component('tabbed-view', {
	    data: function data() {
	        return {
	            a: 1
	        };
	    },
	    computed: {
	        tabs: function computedtabs() {
	            return this.$children;
	        }
	    },
	    methods: {
	        setActive: function setActive(c) {
	            this.$children.forEach(function (child) {
	                if (child !== c) {
	                    child.active = false;
	                }
	            });
	            c.active = true;
	
	            this.a++;
	        }
	    },
	    mounted: function created() {
	        var _this = this;
	
	        this.$children.forEach(function (t) {
	            if (t.focus) {
	                _this.setActive(t);
	            }
	        });
	    }
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(31);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(30);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _state = __webpack_require__(3);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _about = __webpack_require__(365);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firstRun = true;
	
	var ctor = {
	    data: function data() {
	        return {
	            about_open: false
	        };
	    },
	    computed: {
	        networks: function networks() {
	            return _state2.default.networks;
	        },
	        aboutContent: function aboutContent() {
	            return _about2.default;
	        }
	    },
	    methods: {
	        addNetwork: function addNetwork() {
	            var nick = 'Guest' + Math.floor(Math.random() * 100);
	            var network = _state2.default.addNetwork('New Network', nick, {});
	            _state2.default.$emit('network.settings', network);
	        },
	        toggleStateBrowser: function toggleStateBrowser() {
	            _state2.default.$emit('statebrowser.show');
	        },
	        init: function init() {
	            var _this = this;
	
	            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _state2.default.persistence.watchStateForChanges();
	                                _this.$emit('start', {
	                                    fallbackComponent: _this.constructor
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this);
	            }))();
	        }
	    },
	    created: function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (firstRun) {
	                                this.init();
	                                firstRun = false;
	                            }
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function created() {
	            return _ref.apply(this, arguments);
	        }
	
	        return created;
	    }()
	};
	
	exports.default = ctor;
	
	_state2.default.getStartups().kiwiirccom = ctor;

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

	module.exports = "<h3>Linking to your network /channel</h3> <p>Some quick examples on how you can link directly to your network or channels. Even better, embed them into an iframe directly on your website.</p> <ul> <li><a target=_blank href=https://kiwiirc.com/nextclient/irc.server.com/#channel>https://kiwiirc.com/nextclient/irc.server.com/#channel</a></li> <li><a target=_blank href=https://kiwiirc.com/nextclient/irc.server.com/#channel,#channel2>https://kiwiirc.com/nextclient/irc.server.com/#channel,#channel2</a></li> <li><a target=_blank href=https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel,#channel2>https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel,#channel2</a></li> </ul> <p>As a bonus, you can link to multiple IRC networks at the same time:</p> <ul> <li><a target=_blank href=https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel;irc://irc.exmaple.net/#channel>https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel;irc://irc.exmaple.net/#channel</a></li> </ul> <p>Or maybe you host a ZNC server and want to link to it:</p> <ul> <li><a target=_blank href=\"https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel?type=znc&nick=username\">https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel?type=znc&nick=username</a></li> </ul> <hr style=\"margin:4em 0\"/> <h3>What's new in Kiwi Next?</h3> <h4>Networks and settings remembered</h4> <p>All your settings and networks will be remembered for when you come back. You won't need to be re-entering your favourite networks every time you open Kiwi anymore.</p> <h4>Mobile and tablet support</h4> <p>Now that over 50% of internet usage is now on mobile, Kiwi has complete mobile support with new layouts and messages. Everything is accessible with just your fingers.</p> <h4>Embedded images and videos</h4> <p>Opening photos and videos within Kiwi now gets pinned at the bottom of the screen. This lets you switch channels, keep talking without it going off-screen, and have that permenant youtube video playing while you're talking.</p> <h4>ZNC integration</h4> <p>When connecting to a ZNC server, Kiwi will now automatically detect it and look for any other networks in your ZNC account. If any are found then they are shown in a list - just one click away from connecting to it.</p> <h4>Aliases editor</h4> <p>A full alias editor to create command aliases to handle users in your channel, administrate your network or project, or even join multiple commands into a single helpful command. Created by a simple text editor that lets you copy/paste/share your aliases wherever you please.</p> <h4>Raw IRC power</h4> <p>If you're a power IRC user or like to get indepth, Kiwi now uses the raw IRC protocol directly in the browser. Look at the raw IRC messages going back and forth, send raw commands, or use it's scripting to test out new protocol ideas and experiments.</p> <h4>The most IRCv3 compliant open source web IRC client</h4> <p>IRC is being pushed forward by the <a href=http://ircv3.net target=_blank>IRCv3 working group</a> which brings us new features that any IRC client can be using. Not only taking part, but Kiwi is one of the most IRCv3 complete web clients that exists.</p> ";

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports) {

	module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	module.exports = {"locales":["af-za","ar-sa","bg-bg","bs-ba","ca-es","cs-cz","da-dk","de-de","dev","el-gr","en-us","es-ar","es-em","es-es","es-us","eu-es","fi-fi","fr-fr","gl-es","he-il","hu-hu","id-id","it-it","ja-jp","ko-kr","nl-nl","no-no","pl-pl","pt-br","pt-pt","ro-ro","ru-ru","sl-si","sq-al","sr-sp","sv-se","tr-tr","uk-ua","vi-vn","zh-cn","zh-tw"]}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = {"start_button":"Start","start_greeting":"Welcome to Kiwi IRC!","close":"Close","connect":"Connect","connecting":"Connecting...","connected":"Connected","settings":"Settings","channels":"Channels","banned":"Banned Users","notifications":"Notifications","username":"Username","password":"Password","password_have":"I have a password","server":"Server","nick":"Nick","channel":"Channel","network":"Network","znc":"ZNC","logging_in":"Logging in...","invalid_login":"Invalid login","do_search":"Search...","ok":"OK","cancel":"Cancel","window_unload":"This will close all KiwiIRC conversations. Are you sure you want to close this window?","whois_realname":"Real name","whois_status":"Status","whois_status_available":"Is available","send_a_message":"Send a message","more_information":"More information","ignore_user":"Ignore user","connection_channel":"Channel","settings_general":"General","settings_theme":"Theme","settings_themeurl":"Theme URL","settings_use_monospace":"Use monospace","settings_layout_compact":"Traditional IRC layout","settings_show_autocomplete":"Show autocomplete list","settings_messages_title":"Chat Messages","settings_timestamps":"Show timestamps","settings_24hour_timestamps":"Use 24-hour timestamps","settings_emoticons":"Show emoticons","settings_block_private":"Block new private messages","settings_scrollback":"Messages in scrollback","settings_formatting":"Extra formatting","settings_nick_colouring":"Colour nicknames in messages","settings_show_joinpart":"Include join/part messages as activity","settings_mute_sound":"Mute sound notifications","settings_highlight":"Highlight on words (space separated)","settings_aliases":"Aliases","send_message":"Send Message","settings_notify":"Notify me when","settings_notify_all":"All messages","settings_notify_mentioned":"I am mentioned","settings_notify_never":"Never","settings_notify_mute":"Mute sounds","operator_tools":"Operator Tools","settings_default_ban_mask":"Default ban mask","settings_default_kick_reason":"Default kick reason","bans_refresh":"Refresh banlist","bans_user":"Banned user","bans_by":"Banned by","bans_refreshing":"Refreshing banlist...","bans_nobody":"Nobody is banned!","channel_topic":"Topic","channel_moderated":"Moderated chat","channel_invite":"Invite only","channel_moderated_topic":"Only moderators can change the topic","channel_external":"Block messages from outside this channel","container_welcome":"Welcome to Kiwi IRC! Select a channel on the left.","container_statebrowser":"Show statebrowser","container_join":"Join Channel","container_notconnected":"Not Connected","container_privmsg":"Private conversation with {{user}}","input_placeholder":"Send a message...","media_loading":"Loading {{url}}...","messages_load":"Load previous messages","unread_messages":"Unread Messages","settings_server_details":"Server details","settings_port":"Port","settings_znc_other":"Other networks on this ZNC account will be listed in the network list","settings_your_details":"Your details","settings_nickname":"Nickname","settings_advanced":"Advanced","settings_encoding":"Encoding","settings_show_raw":"Show Raw","settings_autorun":"Run commands when connected","settings_danger":"Danger Zone","settings_remove":"Remove network","person":"{{count}} person here","person_plural":"{{count}} people here","reconnect_channel":"Reconnect to join {{channel}}","reconnect_network":"Reconnect to {{network}} to start talking","reconnect_query":"Reconnect to continue talking with {{user}}","reconnect_settings":"Connection settings","side_close":"Close options","side_options":"Channel options","side_settings":"Your settings","side_joins":"Show when people join","side_topics":"Show when channel topic changes","side_nick_changes":"Show when users change their nicks","side_mode_changes":"Show when users change channel modes","side_formatting":"Extra message formatting","side_colours":"Nick colours in the list","side_buffer":"No buffer set","error_starting":"There was an error starting Kiwi IRC :(","error_installed":"Make sure you have installed Kiwi IRC correctly and the configurartion can be loaded","state_leave":"Leave {{name}}","state_account":"Your account","state_remembered":"Your settings and networks will be remembered on this computer.","state_forget":"Forget me","state_network":"No networks here yet.","state_add":"Add one?","state_available":"Available networks","state_configure":"Configure network","state_disconnected":"Not connected.","state_join":"Join new #channel","change_nick":"Change nick","user_account":"Account name: {{user}}","user_realname":"Real name: {{realname}}","user_bot":"Is a bot","user_help":"Is available for help","user_op":"Is an operator","user_server":"Connected to {{server}} {{info}}","user_secure":"Securely connected via SSL/TLS","user_channels":"Also in channels {{channels}}","user_access":"Access level","user_normal":"Normal","user_kick":"Kick from the channel","user_ban":"Ban from the channel","user_kickban":"Ban and kick from the channel","personal_client":"Your IRC Client.","personal_addjoin":"Add your networks. Join your channels.","personal_return":"They will be here when you come back.","personal_add":"Add a Network","personal_saved":"Saved networks","rizon_title":"Kiwi IRC (next gen) - Rizon preview","rizon_websockets":"Direct websockets. No Kiwi server or webirc involved.","rizon_thanks":"(Thanks to Adam @Rizon for the development websocket server support!)","rizon_dev":"Give the developer version of Kiwi IRC a try!"}

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI5MTJlYzY2ZDc1NzJmZjgyMTc0OTMxOTM5NjQ3MGJkZS5zdmciOw=="

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(327)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(193),
	  /* template */
	  __webpack_require__(482),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(354)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(194),
	  /* template */
	  __webpack_require__(509),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(323)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(195),
	  /* template */
	  __webpack_require__(478),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(353)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(199),
	  /* template */
	  __webpack_require__(508),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(319)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(200),
	  /* template */
	  __webpack_require__(474),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(320)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(201),
	  /* template */
	  __webpack_require__(475),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(322)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(202),
	  /* template */
	  __webpack_require__(477),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(340)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(203),
	  /* template */
	  __webpack_require__(495),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(336)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(206),
	  /* template */
	  __webpack_require__(491),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(346)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(207),
	  /* template */
	  __webpack_require__(501),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(347)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(208),
	  /* template */
	  __webpack_require__(502),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(350)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(209),
	  /* template */
	  __webpack_require__(505),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(324)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(210),
	  /* template */
	  __webpack_require__(479),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(335)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(211),
	  /* template */
	  __webpack_require__(490),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(355)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(212),
	  /* template */
	  __webpack_require__(510),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(344)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(213),
	  /* template */
	  __webpack_require__(499),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(341)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(214),
	  /* template */
	  __webpack_require__(496),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(351)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(215),
	  /* template */
	  __webpack_require__(506),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(339)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(216),
	  /* template */
	  __webpack_require__(494),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(326)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(217),
	  /* template */
	  __webpack_require__(481),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(337)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(218),
	  /* template */
	  __webpack_require__(492),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(332)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(219),
	  /* template */
	  __webpack_require__(487),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(329)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(220),
	  /* template */
	  __webpack_require__(484),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(318)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(221),
	  /* template */
	  __webpack_require__(473),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(321)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(222),
	  /* template */
	  __webpack_require__(476),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(331)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(223),
	  /* template */
	  __webpack_require__(486),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(352)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(224),
	  /* template */
	  __webpack_require__(507),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(342)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(225),
	  /* template */
	  __webpack_require__(497),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(333)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(226),
	  /* template */
	  __webpack_require__(488),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(330)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(227),
	  /* template */
	  __webpack_require__(485),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(328)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(228),
	  /* template */
	  __webpack_require__(483),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(343)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(229),
	  /* template */
	  __webpack_require__(498),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(325)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(230),
	  /* template */
	  __webpack_require__(480),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-customserver",
	    class: [_vm.is_connecting ? 'kiwi-customserver--connecting' : '']
	  }, [(!_vm.is_connecting) ? _c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }) : _c('h2', [_vm._v(_vm._s(_vm.$t('connecting')) + " "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.infoClick
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "connectingloader"
	    }
	  }, [(!_vm.is_connecting) ? _c('form', {
	    staticClass: "u-form kiwi-customserver-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.startUp($event)
	      }
	    }
	  }, [(_vm.network && _vm.network.state_error) ? _c('div', {
	    staticClass: "kiwi-customserver-error"
	  }, [_vm._v("We couldn't connect to the server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), (_vm.server_type === 'default') ? [_c('input-text', {
	    attrs: {
	      "label": _vm.$t('server')
	    },
	    model: {
	      value: (_vm.server),
	      callback: function($$v) {
	        _vm.server = $$v
	      },
	      expression: "server"
	    }
	  }, [_c('span', {
	    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
	    class: [_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],
	    on: {
	      "click": function($event) {
	        _vm.tls = !_vm.tls
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
	  }), _vm._v(" "), (!_vm.tls) ? _c('i', {
	    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
	  }) : _vm._e()])]), _vm._v(" "), _c('input-text', {
	    staticClass: "kiwi-customserver-nick",
	    attrs: {
	      "label": _vm.$t('nick')
	    },
	    model: {
	      value: (_vm.nick),
	      callback: function($$v) {
	        _vm.nick = $$v
	      },
	      expression: "nick"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "kiwi-customserver-have-password"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show_password_box),
	      expression: "show_password_box"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.show_password_box,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.show_password_box = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n            ")]), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('input-text', {
	    attrs: {
	      "label": _vm.$t('channel')
	    },
	    model: {
	      value: (_vm.channel),
	      callback: function($$v) {
	        _vm.channel = $$v
	      },
	      expression: "channel"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.server_type === 'default_simple') ? [_c('input-text', {
	    staticClass: "kiwi-customserver-nick",
	    attrs: {
	      "label": _vm.$t('nick')
	    },
	    model: {
	      value: (_vm.nick),
	      callback: function($$v) {
	        _vm.nick = $$v
	      },
	      expression: "nick"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "kiwi-customserver-have-password"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show_password_box),
	      expression: "show_password_box"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.show_password_box,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.show_password_box = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n            ")]), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('input-text', {
	    staticClass: "kiwi-customserver-channel",
	    attrs: {
	      "label": _vm.$t('channel')
	    },
	    model: {
	      value: (_vm.channel),
	      callback: function($$v) {
	        _vm.channel = $$v
	      },
	      expression: "channel"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.server_type === 'znc') ? [_c('input-text', {
	    attrs: {
	      "label": _vm.$t('server')
	    },
	    model: {
	      value: (_vm.server),
	      callback: function($$v) {
	        _vm.server = $$v
	      },
	      expression: "server"
	    }
	  }, [_c('span', {
	    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
	    class: [_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],
	    on: {
	      "click": function($event) {
	        _vm.tls = !_vm.tls
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
	  }), _vm._v(" "), (!_vm.tls) ? _c('i', {
	    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
	  }) : _vm._e()])]), _vm._v(" "), _c('input-text', {
	    staticClass: "kiwi-customserver-nick",
	    attrs: {
	      "label": _vm.$t('username')
	    },
	    model: {
	      value: (_vm.nick),
	      callback: function($$v) {
	        _vm.nick = $$v
	      },
	      expression: "nick"
	    }
	  }), _vm._v(" "), (_vm.znc_network_support) ? _c('input-text', {
	    attrs: {
	      "label": _vm.$t('network')
	    },
	    model: {
	      value: (_vm.znc_network),
	      callback: function($$v) {
	        _vm.znc_network = $$v
	      },
	      expression: "znc_network"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('input-text', {
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })] : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary u-submit",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), (_vm.show_type_switcher) ? _c('div', {
	    staticClass: "kiwi-customserver-server-types"
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.server_type = 'default'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('network')))]), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.server_type = 'znc'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('znc')))])]) : _vm._e()], 2) : _c('div', {
	    staticClass: "kiwi-customserver-loader"
	  }, [_c('i', {
	    staticClass: "fa fa-spin fa-spinner",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-container",
	    class: {
	      /* 'kiwi-container-' + bufferType: true, */
	      'kiwi-container--sidebar-open': _vm.sidebarOpen,
	      'kiwi-container--no-sidebar': _vm.buffer && !_vm.buffer.isChannel(),
	        'kiwi-container--mini': _vm.isHalfSize,
	    }
	  }, [(_vm.buffer) ? [_c('div', {
	    staticClass: "kiwi-container-toggledraw-statebrowser",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleStateBrowser($event)
	      }
	    }
	  }, [(!_vm.unreadMessages.count) ? _c('i', {
	    staticClass: "fa fa-bars",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _c('div', {
	    staticClass: "kiwi-container-toggledraw-statebrowser-messagecount",
	    class: {
	      'kiwi-container-toggledraw-statebrowser-messagecount--highlight': _vm.unreadMessages.highlight
	    }
	  }, [_vm._v(_vm._s(_vm.unreadMessages.count > 999 ? '999+' : _vm.unreadMessages.count))])]), _vm._v(" "), _c('container-header', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  }), _vm._v(" "), _c('div', {
	    class: {
	      'kiwi-container-toggledraw-sidebar': true,
	      'kiwi-container-toggledraw-sidebar--disabled': !_vm.buffer.isChannel()
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleSidebar($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ellipsis-v",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), (_vm.buffer.isServer()) ? [_c('server-view', {
	    attrs: {
	      "network": _vm.network,
	      "buffer": _vm.buffer
	    }
	  })] : [(_vm.buffer.isChannel()) ? _c('sidebar', {
	    attrs: {
	      "network": _vm.network,
	      "buffer": _vm.buffer,
	      "users": _vm.users
	    }
	  }) : _vm._e(), _vm._v(" "), _c('message-list', {
	    attrs: {
	      "buffer": _vm.buffer,
	      "users": _vm.users
	    }
	  })]] : [_vm._v("\n        " + _vm._s(_vm.$t('container_welcome')) + "\n        "), _c('a', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleStateBrowser($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('container_statebrowser')))])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-header",
	    class: {
	      'kiwi-header--showall': _vm.buffer_settings_open,
	    },
	    on: {
	      "click": _vm.onHeaderClick
	    }
	  }, [(_vm.isChannel()) ? [_c('div', {
	    staticClass: "kiwi-header-options"
	  }, [_c('a', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.closeCurrentBuffer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-name"
	  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" "), (_vm.isJoined) ? _c('div', {
	    staticClass: "kiwi-header-topic"
	  }) : _vm._e(), _vm._v(" "), (!_vm.isJoined && _vm.isConnected) ? _c('div', {
	    staticClass: "kiwi-header-notjoined"
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.joinCurrentBuffer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('container_join')))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-tools"
	  }, _vm._l((_vm.pluginUiChannelElements), function(el) {
	    return _c('div', {
	      directives: [{
	        name: "rawElement",
	        rawName: "v-rawElement",
	        value: (el),
	        expression: "el"
	      }],
	      staticClass: "kiwi-header-tool"
	    })
	  }))] : (_vm.isServer()) ? [(_vm.buffer.getNetwork().state === 'disconnected') ? _c('div', {
	    staticClass: "kiwi-header-server-connection"
	  }, [_c('a', {
	    staticClass: "u-button u-button-primary",
	    on: {
	      "click": function($event) {
	        _vm.buffer.getNetwork().ircClient.connect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('connect')))])]) : (_vm.buffer.getNetwork().state === 'connecting') ? _c('div', {
	    staticClass: "kiwi-header-server-connection"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('connecting')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-name"
	  }, [_vm._v(_vm._s(_vm.buffer.getNetwork().name))])] : (_vm.isQuery()) ? [_c('div', {
	    staticClass: "kiwi-header-options"
	  }, [_c('a', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.closeCurrentBuffer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-name"
	  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-tools"
	  }, _vm._l((_vm.pluginUiQueryElements), function(el) {
	    return _c('div', {
	      directives: [{
	        name: "rawElement",
	        rawName: "v-rawElement",
	        value: (el),
	        expression: "el"
	      }],
	      staticClass: "kiwi-header-tool"
	    })
	  }))] : (_vm.isSpecial()) ? [_c('div', {
	    staticClass: "kiwi-header-options"
	  }, [_c('a', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.closeCurrentBuffer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-header-name"
	  }, [_vm._v(_vm._s(_vm.buffer.name))])] : _vm._e(), _vm._v(" "), (_vm.buffer_settings_open) ? _c('div', {
	    staticClass: "kiwi-header-buffersettings",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('tabbed-view', [_c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('settings'),
	      "focus": true
	    }
	  }, [_c('channel-info', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  })], 1), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('banned')
	    }
	  }, [_c('channel-banlist', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  })], 1), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('notifications')
	    }
	  }, [_c('buffer-settings', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  })], 1)], 1), _vm._v(" "), _c('a', {
	    staticClass: "u-button u-button-secondary kiwi-header-close-buffersettings",
	    on: {
	      "click": function($event) {
	        _vm.buffer_settings_open = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-startbnc",
	    class: [_vm.closing ? 'kiwi-startbnc--closing' : '']
	  }, [_c('div', {
	    staticClass: "kiwi-startbnc-section kiwi-startbnc-section-connection"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.greetingText)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-startbnc-status"
	  }, [_vm._v(_vm._s(_vm.statusMessage))]), _vm._v(" "), _c('form', {
	    staticClass: "kiwi-startbnc-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.startUp($event)
	      }
	    }
	  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('username')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.loading
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('password')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    attrs: {
	      "type": "password",
	      "disabled": _vm.loading
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary u-submit",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.loading || !_vm.username || !_vm.password
	    }
	  }, [(!_vm.loading) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.buttonText)
	    }
	  }) : _c('i', {
	    staticClass: "fa fa-spinner fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-startbnc-section kiwi-startbnc-section-info",
	    style: (_vm.infoStyle)
	  }, [(_vm.infoContent) ? _c('div', {
	    staticClass: "kiwi-startbnc-section-info-content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.infoContent)
	    }
	  }, [_c('h3', [_vm._v("Take your conversations anywhere.")]), _vm._v(" "), _c('h4', [_vm._v("IRC? No problem.")]), _vm._v(" "), _c('p', [_vm._v("IRC has a history of being difficult, lets makes it usable.")]), _vm._v(" "), _c('p', [_vm._v("Just log in and get going.")])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-controlinput"
	  }, [_c('div', {
	    staticClass: "kiwi-controlinput-selfuser",
	    class: {
	      'kiwi-controlinput-selfuser--open': _vm.selfuser_open
	    }
	  }, [(_vm.selfuser_open && _vm.networkState === 'connected') ? _c('self-user', {
	    attrs: {
	      "network": _vm.buffer.getNetwork()
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-controlinput-inner"
	  }, [(_vm.currentNick) ? _c('div', {
	    staticClass: "kiwi-controlinput-user",
	    on: {
	      "click": _vm.toggleSelfUser
	    }
	  }, [_c('span', {
	    staticClass: "kiwi-controlinput-user-nick"
	  }, [_vm._v(_vm._s(_vm.currentNick))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-caret-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "kiwi-controlinput-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submitForm($event)
	      }
	    }
	  }, [(_vm.autocomplete_open) ? _c('auto-complete', {
	    ref: "autocomplete",
	    attrs: {
	      "items": _vm.autocomplete_items,
	      "filter": _vm.autocomplete_filter,
	      "buffer": _vm.buffer
	    },
	    on: {
	      "temp": _vm.onAutocompleteTemp,
	      "selected": _vm.onAutocompleteSelected,
	      "cancel": _vm.onAutocompleteCancel
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-controlinput-input-wrap"
	  }, [_c('irc-input', {
	    ref: "input",
	    staticClass: "kiwi-controlinput-input",
	    attrs: {
	      "wrap": "off",
	      "placeholder": _vm.$t('input_placeholder')
	    },
	    on: {
	      "keydown": function($event) {
	        _vm.inputKeyDown($event)
	      },
	      "keyup": function($event) {
	        _vm.inputKeyUp($event)
	      },
	      "click": _vm.closeInputTool
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    ref: "plugins",
	    staticClass: "kiwi-controlinput-tools"
	  }, [_c('a', {
	    staticClass: "kiwi-controlinput-tool",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.onToolClickTextStyle($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-adjust",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "kiwi-controlinput-tool",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.onToolClickEmoji($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-smile-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _vm._l((_vm.pluginUiElements), function(el) {
	    return _c('div', {
	      directives: [{
	        name: "rawElement",
	        rawName: "v-rawElement",
	        value: (el),
	        expression: "el"
	      }],
	      staticClass: "kiwi-controlinput-tool"
	    })
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-controlinput-active-tool"
	  }, [_c(_vm.active_tool, _vm._b({
	    tag: "component"
	  }, 'component', _vm.active_tool_props, false))], 1)])
	},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-autocomplete"
	  }, _vm._l((_vm.filteredAndLimitedItems), function(item, item_idx) {
	    return _c('div', {
	      class: {
	        'kiwi-autocomplete-item': true,
	        'kiwi-autocomplete-item--selected': item.idx === _vm.selected_idx
	      },
	      on: {
	        "click": function($event) {
	          _vm.selected_idx = item.idx;
	          _vm.selectCurrentItem()
	        }
	      }
	    }, [(item.type === 'user') ? [_c('span', {
	      staticClass: "kiwi-autocomplete-item-value"
	    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
	      staticClass: "u-link kiwi-autocomplete-item-action",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.openQuery(item.text)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('send_message')))])] : (item.type === 'command') ? [_c('span', {
	      staticClass: "kiwi-autocomplete-item-value"
	    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
	      staticClass: "u-link kiwi-autocomplete-item-description"
	    }, [_vm._v(_vm._s(item.description))])] : [_c('span', {
	      staticClass: "kiwi-autocomplete-item-value"
	    }, [_vm._v(_vm._s(item.text))])]], 2)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-notconnected"
	  }, [_c('div', {
	    staticClass: "kiwi-notconnected-bigicon"
	  }, [(!_vm.shouldShowLoading) ? _c('i', {
	    staticClass: "fa fa-plug",
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": _vm.reconnect
	    }
	  }) : _c('i', {
	    staticClass: "fa fa-refresh fa-spin kiwi-notconnected-bigicon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), (!_vm.shouldShowLoading) ? _c('div', {
	    staticClass: "kiwi-notconnected-caption"
	  }, [(_vm.isChannel()) ? [_c('span', {
	    on: {
	      "click": _vm.reconnect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('reconnect_channel', {
	    channel: _vm.buffer.name
	  })))])] : (_vm.isServer()) ? [_c('span', {
	    on: {
	      "click": _vm.reconnect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('reconnect_network', {
	    network: _vm.buffer.getNetwork().name
	  })))])] : (_vm.isQuery()) ? [_c('span', {
	    on: {
	      "click": _vm.reconnect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('reconnect_query', {
	    user: _vm.buffer.name
	  })))])] : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "kiwi-notconnected-networksettings u-link",
	    on: {
	      "click": _vm.showNetworkSettings
	    }
	  }, [_vm._v(_vm._s(_vm.$t('reconnect_settings')))])], 2) : _c('div', {
	    staticClass: "kiwi-notconnected-caption"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('connecting')) + "\n    ")])])
	},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-personal"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('personal_client')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_addjoin')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_return')))]), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary",
	    on: {
	      "click": _vm.addNetwork
	    }
	  }, [_vm._v(_vm._s(_vm.$t('personal_add')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networks.length > 0) ? _c('a', {
	    staticClass: "u-link kiwi-personal-existing-networks",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleStateBrowser($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('personal_saved')))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-aboutnew-content",
	    class: {
	      'kiwi-aboutnew-content--open': _vm.about_open
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.aboutContent)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-aboutnew"
	  }, [_c('div', {
	    staticClass: "kiwi-aboutnew-sep"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.about_open = !_vm.about_open
	      }
	    }
	  }, [_vm._v("Link to your network / channel")]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-aboutnew-help"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.about_open = !_vm.about_open
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-question-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-sponsor"
	  }, [_vm._v("\n        Sponsored by "), _c('a', {
	    attrs: {
	      "href": "//www.privateinternetaccess.com/"
	    }
	  }, [_vm._v("PrivateInternetAccess")]), _vm._v(" "), _c('span', [_vm._v("Protect your internet with a VPN")])])
	}]}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-statebrowser-network",
	    class: [
	      _vm.isActiveNetwork ? 'kiwi-statebrowser-network--active' : '' ]
	  }, [_c('div', {
	    staticClass: "kiwi-statebrowser-network-header"
	  }, [_c('a', {
	    staticClass: "kiwi-statebrowser-network-name u-link",
	    on: {
	      "click": function($event) {
	        _vm.setActiveBuffer(_vm.network.serverBuffer())
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.network.name))]), _vm._v(" "), (_vm.network.buffers.length > 1) ? _c('a', {
	    staticClass: "kiwi-statebrowser-network-toggle",
	    on: {
	      "click": function($event) {
	        _vm.collapsed = !_vm.collapsed
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa",
	    class: [_vm.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-network-toggable-area",
	    class: [
	      _vm.collapsed ? 'kiwi-statebrowser-network-toggable-area--collapsed' : '' ]
	  }, [_c('transition', {
	    attrs: {
	      "name": "kiwi-statebrowser-network-status-transition"
	    }
	  }, [(_vm.network.state !== 'connected') ? _c('div', {
	    staticClass: "kiwi-statebrowser-network-status"
	  }, [(_vm.network.state_error) ? [_c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.showNetworkSettings(_vm.network)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_configure')))])] : (!_vm.network.connection.server) ? [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.showNetworkSettings(_vm.network)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_configure')))])] : (_vm.network.state === 'disconnected') ? [_vm._v("\n                " + _vm._s(_vm.$t('state_disconnected')) + "\n                "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.network.ircClient.connect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('connect')))])] : (_vm.network.state === 'connecting') ? [_vm._v("\n                " + _vm._s(_vm.$t('connecting')) + "\n            ")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-channels"
	  }, _vm._l((_vm.orderedBuffers(_vm.network.buffers)), function(buffer) {
	    return _c('div', {
	      staticClass: "kiwi-statebrowser-channel",
	      class: {
	        'kiwi-statebrowser-channel-active': _vm.isActiveBuffer(buffer),
	          'kiwi-statebrowser-channel-notjoined': buffer.isChannel() && !buffer.joined
	      }
	    }, [_c('div', {
	      staticClass: "kiwi-statebrowser-channel-name",
	      on: {
	        "click": function($event) {
	          _vm.setActiveBuffer(buffer)
	        }
	      }
	    }, [_vm._v(_vm._s(buffer.name))]), _vm._v(" "), _c('div', {
	      staticClass: "kiwi-statebrowser-channel-labels"
	    }, [_c('transition', {
	      attrs: {
	        "name": "kiwi-statebrowser-channel-label-transition"
	      }
	    }, [(buffer.flags.unread) ? _c('div', {
	      staticClass: "kiwi-statebrowser-channel-label",
	      class: {
	        'kiwi-statebrowser-channel-label--highlight': buffer.flags.highlight
	      }
	    }, [_vm._v("\n                        " + _vm._s(buffer.flags.unread) + "\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	      staticClass: "kiwi-statebrowser-channel-settings",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.$emit('showBufferSettings', buffer, $event.clientY)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-bell-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])
	  })), _vm._v(" "), (_vm.network.state === 'connected') ? _c('form', {
	    staticClass: "kiwi-statebrowser-newchannel",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submitNewChannelForm($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-statebrowser-newchannel-inputwrap",
	    class: [
	      _vm.new_channel_input_has_focus ?
	      'kiwi-statebrowser-newchannel-inputwrap--focus' :
	      ''
	    ]
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.new_channel_input),
	      expression: "new_channel_input"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('state_join')
	    },
	    domProps: {
	      "value": (_vm.new_channel_input)
	    },
	    on: {
	      "focus": _vm.onNewChannelInputFocus,
	      "blur": _vm.onNewChannelInputBlur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.new_channel_input = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": _vm.submitNewChannelForm
	    }
	  })])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-wrap",
	    class: {
	      'kiwi-wrap--statebrowser-drawopen': _vm.stateBrowserDrawOpen,
	      'kiwi-wrap--monospace': _vm.setting('useMonospace'),
	        'kiwi-wrap--touch': _vm.state.ui.is_touch,
	    },
	    on: {
	      "click": _vm.emitDocumentClick
	    }
	  }, [_c('link', {
	    attrs: {
	      "href": _vm.themeUrl,
	      "rel": "stylesheet",
	      "type": "text/css"
	    }
	  }), _vm._v(" "), (!_vm.hasStarted || (!_vm.fallbackComponent && _vm.networks.length === 0)) ? [_c(_vm.startupComponent, {
	    tag: "component",
	    on: {
	      "start": _vm.startUp
	    }
	  })] : [_c('state-browser', {
	    attrs: {
	      "networks": _vm.networks
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-workspace",
	    on: {
	      "click": function($event) {
	        _vm.stateBrowserDrawOpen = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-workspace-background"
	  }), _vm._v(" "), (!_vm.activeComponent && _vm.network) ? [_c('container', {
	    attrs: {
	      "network": _vm.network,
	      "buffer": _vm.buffer,
	      "users": _vm.users,
	      "isHalfSize": _vm.mediaviewerOpen
	    }
	  }), _vm._v(" "), (_vm.mediaviewerOpen) ? _c('media-viewer', {
	    attrs: {
	      "url": _vm.mediaviewerUrl
	    }
	  }) : _vm._e(), _vm._v(" "), _c('control-input', {
	    attrs: {
	      "container": _vm.networks,
	      "buffer": _vm.buffer
	    }
	  })] : (!_vm.activeComponent) ? _c(_vm.fallbackComponent, _vm._b({
	    tag: "component"
	  }, 'component', _vm.fallbackComponentProps, false)) : _c(_vm.activeComponent, _vm._b({
	    tag: "component"
	  }, 'component', _vm.activeComponentProps, false))], 2)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-ircinput"
	  }, [_c('div', {
	    ref: "editor",
	    staticClass: "kiwi-ircinput-editor",
	    attrs: {
	      "contenteditable": "true",
	      "role": "textbox",
	      "placeholder": _vm.placeholder
	    },
	    on: {
	      "keypress": function($event) {
	        _vm.updateValueProps();
	        _vm.$emit('keypress', $event)
	      },
	      "keydown": function($event) {
	        _vm.updateValueProps();
	        _vm.$emit('keydown', $event)
	      },
	      "keyup": function($event) {
	        _vm.updateValueProps();
	        _vm.$emit('keyup', $event)
	      },
	      "textInput": function($event) {
	        _vm.updateValueProps();
	        _vm.onTextInput($event);
	        _vm.$emit('textInput', $event)
	      },
	      "mouseup": function($event) {
	        _vm.updateValueProps();
	      },
	      "click": function($event) {
	        _vm.$emit('click', $event)
	      },
	      "paste": _vm.onPaste
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-inputtool-colours"
	  }, [_c('div', {
	    staticClass: "kiwi-inputtool-colours-palette",
	    on: {
	      "mousedown": function($event) {
	        $event.preventDefault();
	      },
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-white",
	    attrs: {
	      "data-code": "00"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-black",
	    attrs: {
	      "data-code": "01"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-blue",
	    attrs: {
	      "data-code": "02"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-green",
	    attrs: {
	      "data-code": "03"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-red",
	    attrs: {
	      "data-code": "04"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-brown",
	    attrs: {
	      "data-code": "05"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-purple",
	    attrs: {
	      "data-code": "06"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-orange",
	    attrs: {
	      "data-code": "07"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-yellow",
	    attrs: {
	      "data-code": "08"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-green",
	    attrs: {
	      "data-code": "09"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-cyan",
	    attrs: {
	      "data-code": "10"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-cyan",
	    attrs: {
	      "data-code": "11"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-blue",
	    attrs: {
	      "data-code": "12"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-pink",
	    attrs: {
	      "data-code": "13"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-grey",
	    attrs: {
	      "data-code": "14"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-grey",
	    attrs: {
	      "data-code": "15"
	    },
	    on: {
	      "click": _vm.onColourClick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour kiwi-inputtools-colours-reset",
	    on: {
	      "click": _vm.onResetClick
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ban",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-inputtools-colours-colour kiwi-inputtools-colours-img",
	    staticStyle: {
	      "background-image": "url(/static/emoticons/smile.png)"
	    },
	    attrs: {
	      "data-code": ":D"
	    },
	    on: {
	      "click": _vm.onImgClick
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: [
	      'input-text',
	      _vm.hasFocus ? 'input-text--focus' : '',
	      _vm.hasFocus || _vm.currentValue ? 'input-text--reveal-value' : ''
	    ]
	  }, [(_vm.type === 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    attrs: {
	      "type": "password",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.hasFocus = true
	      },
	      "blur": function($event) {
	        _vm.hasFocus = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : (_vm.type === 'number') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.hasFocus = true
	      },
	      "blur": function($event) {
	        _vm.hasFocus = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    attrs: {
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.hasFocus = true
	      },
	      "blur": function($event) {
	        _vm.hasFocus = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
	    staticClass: "input-text-c"
	  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "input-text-label"
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-text-underline"
	  }, [_c('div', {
	    staticClass: "input-text-underline-active"
	  })])
	}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-personal"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('personal_client')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_addjoin')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_return')))]), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary",
	    on: {
	      "click": _vm.addNetwork
	    }
	  }, [_vm._v(_vm._s(_vm.$t('personal_add')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networks.length > 0) ? _c('a', {
	    staticClass: "u-link kiwi-personal-existing-networks",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleStateBrowser($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('personal_saved')))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-inputtool-emoji"
	  }, [_c('div', {
	    staticClass: "kiwi-inputtool-emoji-palette",
	    on: {
	      "mousedown": function($event) {
	        $event.preventDefault();
	      },
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, _vm._l((_vm.emojis), function(text, eCode) {
	    return _c('div', {
	      staticClass: "kiwi-inputtool-emoji-emoji",
	      style: ({
	        'background-image': ("url(" + _vm.location + eCode + ".png)")
	      }),
	      attrs: {
	        "data-code": text + ' '
	      },
	      on: {
	        "click": _vm.onImgClick
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-prompt"
	  }, [(_vm.state === 'pre') ? _c('div', {
	    on: {
	      "click": _vm.prompt
	    }
	  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.state === 'prompt') ? _c('form', {
	    staticClass: "u-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.complete($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "input-prompt-label"
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "u-input",
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
	        _vm.cancel($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "u-button u-button-primary",
	    on: {
	      "click": _vm.complete
	    }
	  }, [_vm._v(_vm._s(_vm.$t('ok')))]), _vm._v(" "), _c('a', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('cancel')))])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-channelinfo"
	  }, [_c('form', {
	    staticClass: "u-form kiwi-channelinfo-basicmodes",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('label', {
	    staticClass: "kiwi-channelinfo-topic"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('channel_topic'))), _c('br'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.topic),
	      expression: "topic",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    attrs: {
	      "rows": "2"
	    },
	    domProps: {
	      "value": (_vm.topic)
	    },
	    on: {
	      "change": function($event) {
	        _vm.topic = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.modeM),
	      expression: "modeM"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.modeM) ? _vm._i(_vm.modeM, null) > -1 : (_vm.modeM)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.modeM,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.modeM = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.modeM = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.modeM = $$c
	        }
	      }
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_moderated')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.modeI),
	      expression: "modeI"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.modeI) ? _vm._i(_vm.modeI, null) > -1 : (_vm.modeI)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.modeI,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.modeI = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.modeI = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.modeI = $$c
	        }
	      }
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_invite')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.modeT),
	      expression: "modeT"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.modeT) ? _vm._i(_vm.modeT, null) > -1 : (_vm.modeT)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.modeT,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.modeT = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.modeT = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.modeT = $$c
	        }
	      }
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_moderated_topic')) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.modeN),
	      expression: "modeN"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.modeN) ? _vm._i(_vm.modeN, null) > -1 : (_vm.modeN)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.modeN,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.modeN = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.modeN = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.modeN = $$c
	        }
	      }
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('channel_external')) + "\n        ")]), _vm._v(" "), _c('label', [_vm._v("\n            " + _vm._s(_vm.$t('password'))), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.modeK),
	      expression: "modeK",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.modeK)
	    },
	    on: {
	      "change": function($event) {
	        _vm.modeK = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-selfuser"
	  }, [_c('div', {
	    staticClass: "kiwi-selfuser-mask"
	  }, [_c('span', {
	    staticClass: "kiwi-selfuser-nick"
	  }, [_vm._v(_vm._s(_vm.network.nick))]), _vm._v(" "), _c('span', {
	    staticClass: "kiwi-selfuser-host"
	  }, [_vm._v(_vm._s(_vm.netUser.username) + "@" + _vm._s(_vm.netUser.host))])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-selfuser-modes"
	  }, [_vm._v(_vm._s(_vm.modeString))]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-selfuser-actions"
	  }, [_c('input-prompt', {
	    attrs: {
	      "label": _vm.$t('change_nick') + ':'
	    },
	    on: {
	      "submit": _vm.changeNick
	    }
	  }, [_c('a', {
	    staticClass: "u-link"
	  }, [_vm._v(_vm._s(_vm.$t('change_nick')))])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-messagelist-message kiwi-messagelist-message--compact",
	    class: [
	      _vm.ml.filteredMessages[_vm.idx - 1] &&
	      _vm.ml.filteredMessages[_vm.idx - 1].nick === _vm.message.nick &&
	      _vm.message.time - _vm.ml.filteredMessages[_vm.idx - 1].time < 60000 &&
	      _vm.ml.filteredMessages[_vm.idx - 1].type !== 'traffic' &&
	      _vm.message.type !== 'traffic' ?
	      'kiwi-messagelist-message-repeat' :
	      '',
	      'kiwi-messagelist-message-' + _vm.message.type,
	      _vm.message.type_extra ?
	      'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
	      '',
	      _vm.ml.isMessageHighlight(_vm.message) ?
	      'kiwi-messagelist-message--highlight' :
	      '',
	      _vm.ml.isHoveringOverMessage(_vm.message) ?
	      'kiwi-messagelist-message--hover' :
	      '',
	      _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
	      'kiwi-messagelist-message--unread' :
	      '',
	      _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
	      'kiwi-messagelist-message--own' :
	      '',
	      _vm.ml.message_info_open === _vm.message ?
	      'kiwi-messagelist-message--info-open' :
	      '',
	      _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
	      'kiwi-messagelist-message--blur' :
	      '' ],
	    attrs: {
	      "data-message": _vm.message
	    },
	    on: {
	      "click": function($event) {
	        _vm.ml.onMessageClick($event, _vm.message)
	      }
	    }
	  }, [(_vm.ml.bufferSetting('show_timestamps')) ? _c('div', {
	    staticClass: "kiwi-messagelist-time"
	  }, [_vm._v("\n        " + _vm._s(_vm.ml.formatTime(_vm.message.time)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-messagelist-nick",
	    style: (_vm.ml.nickStyle(_vm.message.nick)),
	    attrs: {
	      "data-nick": _vm.message.nick
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.ml.hover_nick = _vm.message.nick.toLowerCase();
	      },
	      "mouseout": function($event) {
	        _vm.ml.hover_nick = '';
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.message.nick))]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-messagelist-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.ml.formatMessage(_vm.message))
	    }
	  }), _vm._v(" "), (_vm.ml.message_info_open === _vm.message) ? _c('message-info', {
	    attrs: {
	      "message": _vm.message,
	      "buffer": _vm.ml.buffer
	    },
	    on: {
	      "close": function($event) {
	        _vm.ml.toggleMessageInfo()
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-userbox"
	  }, [_c('div', {
	    staticClass: "kiwi-userbox-header"
	  }, [_c('i', {
	    staticClass: "fa fa-user kiwi-userbox-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.user.nick))]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-userbox-usermask"
	  }, [_vm._v(_vm._s(_vm.user.username) + "@" + _vm._s(_vm.user.host))])]), _vm._v(" "), _c('p', {
	    staticClass: "kiwi-userbox-basicinfo"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('whois_realname')) + ":")]), _vm._v(" " + _vm._s(_vm.user.realname) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('whois_status')) + ":")]), _vm._v(" " + _vm._s(_vm.user.away ? _vm.user.away : _vm.$t('whois_status_available')) + " "), _c('br')]), _vm._v(" "), _c('p', {
	    staticClass: "kiwi-userbox-actions"
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.openQuery
	    }
	  }, [_vm._v(_vm._s(_vm.$t('send_a_message')))]), _vm._v(" "), (!_vm.whoisRequested) ? _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.updateWhoisData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('more_information')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.ignore),
	      expression: "user.ignore"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.user.ignore) ? _vm._i(_vm.user.ignore, null) > -1 : (_vm.user.ignore)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.user.ignore,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.user.ignore = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.user.ignore = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.user.ignore = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('ignore_user')) + "\n        ")])]), _vm._v(" "), (_vm.whoisRequested) ? _c('div', {
	    staticClass: "kiwi-userbox-whois",
	    class: [_vm.whoisLoading ? 'kiwi-userbox-whois--loading' : '']
	  }, [(_vm.whoisLoading) ? [_c('i', {
	    staticClass: "fa fa-spinner",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })] : [_c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.user.away ? _vm.$t('whois_status') + ': ' + _vm.user.away : _vm.$t('whois_status_available')))]), _vm._v(" "), (_vm.user.account) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_account', {
	    user: _vm.user.account
	  })))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_realname', {
	    realname: _vm.user.realname
	  })))]), _vm._v(" "), (_vm.user.bot) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_bot')))]) : _vm._e(), _vm._v(" "), (_vm.user.helpop) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_help')))]) : _vm._e(), _vm._v(" "), (_vm.user.operator) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_op')))]) : _vm._e(), _vm._v(" "), (_vm.user.server) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_server', {
	    server: _vm.user.server,
	    info: (_vm.user.server_info ? ("(" + (_vm.user.server_info) + ")") : '')
	  })) + "\u000f")]) : _vm._e(), _vm._v(" "), (_vm.user.secure) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_secure')))]) : _vm._e(), _vm._v(" "), (_vm.user.channels) ? _c('span', {
	    staticClass: "kiwi-userbox-whois-line"
	  }, [_vm._v(_vm._s(_vm.$t('user_channels', {
	    channels: _vm.user.channels
	  })))]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (_vm.buffer.isChannel() && _vm.areWeAnOp) ? _c('div', {
	    staticClass: "kiwi-userbox-actions-op"
	  }, [_c('form', {
	    staticClass: "u-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isUserOnBuffer) ? _c('label', [_vm._v("\n                " + _vm._s(_vm.$t('user_access')) + " "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userMode),
	      expression: "userMode"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.userMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_vm._l((_vm.availableChannelModes), function(mode) {
	    return _c('option', {
	      domProps: {
	        "value": mode.mode
	      }
	    }, [_vm._v("\n                        " + _vm._s(mode.description) + "\n                    ")])
	  }), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v(_vm._s(_vm.$t('user_normal')))])], 2)]) : _vm._e(), _vm._v(" "), (_vm.isUserOnBuffer) ? _c('label', [_c('button', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.kickUser
	    }
	  }, [_vm._v(_vm._s(_vm.$t('user_kick')))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('button', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.banUser
	    }
	  }, [_vm._v(_vm._s(_vm.$t('user_ban')))])]), _vm._v(" "), (_vm.isUserOnBuffer) ? _c('label', [_c('button', {
	    staticClass: "u-button u-button-secondary",
	    on: {
	      "click": _vm.kickbanUser
	    }
	  }, [_vm._v(_vm._s(_vm.$t('user_kickban')))])]) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-messageinfo",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-messageinfo-author"
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.openQuery
	    }
	  }, [_vm._v("Reply in private")])]), _vm._v(" "), (_vm.areWeAnOp()) ? _c('div', {
	    staticClass: "kiwi-messageinfo-opactions"
	  }, [_c('input-prompt', {
	    attrs: {
	      "label": "Kick reason:"
	    },
	    on: {
	      "submit": _vm.onKick
	    }
	  }, [_c('a', {
	    staticClass: "u-link"
	  }, [_vm._v("Kick " + _vm._s(_vm.message.nick))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-prompt', {
	    attrs: {
	      "label": "Ban reason:"
	    },
	    on: {
	      "submit": _vm.onBan
	    }
	  }, [_c('a', {
	    staticClass: "u-link"
	  }, [_vm._v("Ban " + _vm._s(_vm.message.nick))])])], 1) : _vm._e(), _vm._v(" "), (_vm.message.mentioned_urls.length > 0) ? _c('div', {
	    staticClass: "kiwi-messageinfo-urls"
	  }, _vm._l((_vm.message.mentioned_urls), function(url) {
	    return _c('div', {
	      staticClass: "kiwi-messageinfo-url"
	    }, [_c('a', {
	      staticClass: "u-button u-button-secondary",
	      on: {
	        "click": function($event) {
	          _vm.urlPreview(url)
	        }
	      }
	    }, [_vm._v("Preview")]), _vm._v(" "), _c('a', {
	      staticClass: "u-link",
	      attrs: {
	        "href": url,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(url))])])
	  })) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-caret-up kiwi-messageinfo-close",
	    on: {
	      "click": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-statebrowser"
	  }, [_c('div', {
	    staticClass: "kiwi-statebrowser-tools"
	  }, _vm._l((_vm.pluginUiElements), function(el) {
	    return _c('div', {
	      directives: [{
	        name: "rawElement",
	        rawName: "v-rawElement",
	        value: (el),
	        expression: "el"
	      }],
	      staticClass: "kiwi-statebrowser-tool"
	    })
	  })), _vm._v(" "), (_vm.bufferForPopup) ? _c('div', {
	    staticClass: "kiwi-statebrowser-channel-popup",
	    style: ({
	      top: _vm.popup_top + 'px'
	    }),
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('buffer-settings', {
	    attrs: {
	      "buffer": _vm.bufferForPopup
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.closeBuffer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_leave', {
	    name: _vm.bufferForPopup.name
	  })))])], 1) : _vm._e(), _vm._v(" "), (_vm.isPersistingState) ? _c('div', {
	    staticClass: "kiwi-statebrowser-usermenu",
	    class: [_vm.is_usermenu_open ? 'kiwi-statebrowser-usermenu--open' : '']
	  }, [_c('a', {
	    staticClass: "kiwi-statebrowser-usermenu-header",
	    on: {
	      "click": function($event) {
	        _vm.is_usermenu_open = !_vm.is_usermenu_open
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_account')) + " "), _c('i', {
	    staticClass: "fa fa-caret-down"
	  })]), _vm._v(" "), (_vm.is_usermenu_open) ? _c('div', {
	    staticClass: "kiwi-statebrowser-usermenu-body"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('state_remembered'))), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.clickForget
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_forget')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary",
	    on: {
	      "click": function($event) {
	        _vm.is_usermenu_open = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('close')))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-divider"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-switcher"
	  }, [(!_vm.isRestrictedServer) ? _c('a', {
	    on: {
	      "click": _vm.clickAddNetwork
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _c('a', {
	    on: {
	      "click": _vm.clickAppSettings
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), (_vm.networks.length === 0) ? _c('div', {
	    staticClass: "kiwi-statebrowser-nonetworks"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('state_network'))), _c('br'), _c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.clickAddNetwork
	    }
	  }, [_vm._v(_vm._s(_vm.$t('state_add')))])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.provided_networks).length > 0) ? _c('div', {
	    staticClass: "kiwi-statebrowser-availablenetworks"
	  }, [_c('div', {
	    staticClass: "kiwi-statebrowser-availablenetworks-toggle",
	    on: {
	      "click": function($event) {
	        _vm.show_provided_networks = !_vm.show_provided_networks
	      }
	    }
	  }, [_vm._v("↪ " + _vm._s(_vm.$t('state_available')))]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-availablenetworks-networks",
	    class: {
	      'kiwi-statebrowser-availablenetworks-networks--open': _vm.show_provided_networks
	    }
	  }, _vm._l((_vm.provided_networks), function(pNets, pNetTypeName) {
	    return _c('div', {
	      staticClass: "kiwi-statebrowser-availablenetworks-type"
	    }, [_c('div', {
	      staticClass: "kiwi-statebrowser-availablenetworks-name"
	    }, [_vm._v(_vm._s(pNetTypeName))]), _vm._v(" "), _vm._l((pNets), function(pNet) {
	      return _c('div', {
	        staticClass: "kiwi-statebrowser-availablenetworks-link",
	        class: [pNet.connected ? 'kiwi-statebrowser-availablenetworks-link--connected' : '']
	      }, [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.connectProvidedNetwork(pNet)
	          }
	        }
	      }, [_vm._v(_vm._s(pNet.name))]), _c('br')])
	    })], 2)
	  }))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-statebrowser-scrollarea"
	  }, [_c('div', {
	    staticClass: "kiwi-statebrowser-networks"
	  }, _vm._l((_vm.networksToShow), function(network) {
	    return _c('state-browser-network', {
	      attrs: {
	        "network": network
	      },
	      on: {
	        "showBufferSettings": _vm.showBufferPopup
	      }
	    })
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-mediaviewer"
	  }, [_c('div', {
	    staticClass: "kiwi-mediaviewer-controls"
	  }, [_c('a', {
	    staticClass: "u-button u-button-warning kiwi-mediaviewer-controls-close",
	    on: {
	      "click": _vm.closeViewer
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    key: _vm.url
	  }, [_c('a', {
	    staticClass: "embedly-card",
	    attrs: {
	      "href": _vm.url,
	      "data-card-key": _vm.embedlyKey,
	      "data-card-chrome": "0",
	      "data-card-controls": "0",
	      "data-card-recommend": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('media_loading', {
	    url: _vm.url
	  })))])])])
	},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-sidebar",
	    class: {
	      'kiwi-sidebar--wide': _vm.sidebarIsWide
	    }
	  }, [(_vm.buffer) ? [(_vm.buffer.isChannel()) ? [(_vm.sidebarIsWide) ? _c('span', {
	    staticClass: "kiwi-sidebar-options",
	    on: {
	      "click": function($event) {
	        _vm.sidebarIsWide = false
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('close')) + " "), _c('i', {
	    staticClass: "fa fa-caret-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _c('span', {
	    staticClass: "kiwi-sidebar-options",
	    on: {
	      "click": function($event) {
	        _vm.settings_open = !_vm.settings_open
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_options')) + "\n            ")]), _vm._v(" "), (_vm.settings_open) ? _c('div', {
	    staticClass: "kiwi-sidebar-buffersettings",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('tabbed-view', [_c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('settings'),
	      "focus": true
	    }
	  }, [_c('channel-info', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-sidebar-settings"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('side_settings')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowJoinParts),
	      expression: "settingShowJoinParts"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowJoinParts) ? _vm._i(_vm.settingShowJoinParts, null) > -1 : (_vm.settingShowJoinParts)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowJoinParts,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowJoinParts = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowJoinParts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowJoinParts = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_joins')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowTopics),
	      expression: "settingShowTopics"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowTopics) ? _vm._i(_vm.settingShowTopics, null) > -1 : (_vm.settingShowTopics)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowTopics,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowTopics = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowTopics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowTopics = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_topics')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowNickChanges),
	      expression: "settingShowNickChanges"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowNickChanges) ? _vm._i(_vm.settingShowNickChanges, null) > -1 : (_vm.settingShowNickChanges)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowNickChanges,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowNickChanges = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowNickChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowNickChanges = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_nick_changes')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowModeChanges),
	      expression: "settingShowModeChanges"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowModeChanges) ? _vm._i(_vm.settingShowModeChanges, null) > -1 : (_vm.settingShowModeChanges)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowModeChanges,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowModeChanges = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowModeChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowModeChanges = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_mode_changes')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingExtraFormatting),
	      expression: "settingExtraFormatting"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingExtraFormatting) ? _vm._i(_vm.settingExtraFormatting, null) > -1 : (_vm.settingExtraFormatting)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingExtraFormatting,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingExtraFormatting = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingExtraFormatting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingExtraFormatting = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_formatting')))]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingColouredNicklist),
	      expression: "settingColouredNicklist"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingColouredNicklist) ? _vm._i(_vm.settingColouredNicklist, null) > -1 : (_vm.settingColouredNicklist)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingColouredNicklist,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingColouredNicklist = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingColouredNicklist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingColouredNicklist = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('side_colours')))])])], 1), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('banned')
	    }
	  }, [_c('channel-banlist', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  })], 1), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('notifications')
	    }
	  }, [_c('buffer-settings', {
	    attrs: {
	      "buffer": _vm.buffer
	    }
	  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userbox_user) ? _c('div', {
	    staticClass: "kiwi-sidebar-userbox",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('user-box', {
	    attrs: {
	      "user": _vm.userbox_user,
	      "buffer": _vm.buffer,
	      "network": _vm.network
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.buffer.isChannel()) ? _c('nicklist', {
	    attrs: {
	      "network": _vm.network,
	      "buffer": _vm.buffer,
	      "users": _vm.users
	    }
	  }) : _vm._e()] : (_vm.buffer.isQuery()) ? void 0 : _vm._e()] : [_vm._v("\n        " + _vm._s(_vm.$t('side_buffer')) + "\n    ")]], 2)
	},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-welcome-znc",
	    class: [_vm.closing ? 'kiwi-welcome-znc--closing' : '']
	  }, [_c('div', {
	    staticClass: "kiwi-welcome-znc-section kiwi-welcome-znc-section-connection"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.greetingText)
	    }
	  }), _vm._v(" "), (!_vm.network || _vm.network.state === 'disconnected') ? [_c('form', {
	    staticClass: "u-form kiwi-welcome-znc-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.formSubmit($event)
	      }
	    }
	  }, [(_vm.network && _vm.network.state === 'disconnected') ? _c('div', {
	    staticClass: "kiwi-welcome-znc-error"
	  }, [_vm._v("We couldn't connect to the server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), (_vm.showUser) ? _c('input-text', {
	    staticClass: "kiwi-welcome-znc-nick",
	    attrs: {
	      "label": _vm.$t('username')
	    },
	    model: {
	      value: (_vm.username),
	      callback: function($$v) {
	        _vm.username = $$v
	      },
	      expression: "username"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPass) ? _c('input-text', {
	    staticClass: "kiwi-welcome-znc-password",
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showNetwork) ? _c('input-text', {
	    staticClass: "kiwi-welcome-znc-channel",
	    attrs: {
	      "label": _vm.$t('network')
	    },
	    model: {
	      value: (_vm.znc_network),
	      callback: function($$v) {
	        _vm.znc_network = $$v
	      },
	      expression: "znc_network"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary u-submit kiwi-welcome-znc-start",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.readyToStart
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.buttonText)
	    }
	  })], 1)] : (_vm.network.state !== 'connected') ? [_c('i', {
	    staticClass: "fa fa-spin fa-spinner",
	    staticStyle: {
	      "font-size": "2em",
	      "margin-top": "1em"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-welcome-znc-section kiwi-welcome-znc-section-info",
	    style: (_vm.infoStyle)
	  }, [(_vm.infoContent) ? _c('div', {
	    staticClass: "kiwi-welcome-znc-section-info-content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.infoContent)
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "u-tabbed-view"
	  }, [_c('div', {
	    key: _vm.a,
	    staticClass: "u-tabbed-view-tabs"
	  }, _vm._l((_vm.tabs), function(c) {
	    return _c('a', {
	      class: {
	        'u-tabbed-view-tab': true,
	        'u-tabbed-view-tab--active': c.active
	      },
	      on: {
	        "click": function($event) {
	          _vm.setActive(c)
	        }
	      }
	    }, [_vm._v(_vm._s(c.header))])
	  })), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-settings-aliases"
	  }, [_c('form', {
	    staticClass: "u-form"
	  }, [_c('a', {
	    staticClass: "u-link kiwi-settings-aliases-showhelp",
	    on: {
	      "click": function($event) {
	        _vm.show_help = !_vm.show_help
	      }
	    }
	  }, [_vm._v("What are aliases?")]), _vm._v(" "), (_vm.show_help) ? _c('div', {
	    staticClass: "kiwi-settings-aliases-help"
	  }, [_c('p', [_vm._v("Aliases let you rename existing IRC commands or even build entirely new ones.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Variables")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h4', [_vm._v("Helper commands")]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aliasText),
	      expression: "aliasText"
	    }],
	    staticClass: "kiwi-settings-aliases-input",
	    domProps: {
	      "value": (_vm.aliasText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.aliasText = $event.target.value
	      }
	    }
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("They must be one per line and in the form of "), _c('em', [_vm._v("/name /what it should do")]), _vm._v(".")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                There are several variables that may be used to refer to the current environment, such\n                as the active channel or active nick.\n                "), _c('ul', [_c('li', [_c('em', [_vm._v("$server")]), _vm._v(" The current network name")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("$channel / $destination")]), _vm._v(" The current channel / buffer name")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("$nick")]), _vm._v(" The current nick")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                You can also use variables to read input from the typed command. "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('em', [_vm._v("$0")]), _vm._v(" The command name")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("$1")]), _vm._v(" The first argument from the typed input")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("$2")]), _vm._v(" The second argument from the typed input")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("$1+")]), _vm._v(" From the first argument to the last argument")])]), _vm._v(" "), _c('b', [_vm._v("Example 1:")]), _vm._v(" "), _c('em', [_vm._v("/greet /msg $1 Hello, $1!")]), _c('br'), _vm._v("\n                This creates an IRC command /greet that accepts one argument. Typing \"/greet username\"\n                will execute \"/msg username Hello, username!\". "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Example 2:")]), _vm._v(" "), _c('em', [_vm._v("/ban /quote mode $channel +b $1+")]), _c('br'), _vm._v("\n                This creates an IRC command /ban that does a few things. Typing \"/ban nick1 nick2\"\n                will execute \"/quote mode #activechannel +b nick1 nick2\". $channel is replaced with the\n                active channel name, $1+ is replaced with all the typed input from the first word to the end.\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('ul', [_c('li', [_c('em', [_vm._v("/echo")]), _c('br'), _vm._v("Sends a message to the active buffer without sending it to the IRC network. Eg, /echo Something happened")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("/lines")]), _c('br'), _vm._v("\n                        Similar to Mirc script, this lets you execute multiples lines of commands separated by a pipe, \"|\"."), _c('br'), _vm._v("\n                        Example: \"/lines /ban nick1 | /echo Banned user\" would first execute the /ban command, and then the /echo command. This comes in handy with creating short aliases such as the common \"/cycle\" command that parts and re-joins the active channel: \"/cycle /lines /part $channel | /join $channel\".\n                    ")])])])
	}]}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-buffersettings"
	  }, [_c('div', {
	    staticClass: "kiwi-buffersettings-alerts"
	  }, [_c('form', {
	    staticClass: "u-form"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('settings_notify')) + ": ")]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_all')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingAlertOn),
	      expression: "settingAlertOn"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "alert_on",
	      "value": "message"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.settingAlertOn, "message")
	    },
	    on: {
	      "__c": function($event) {
	        _vm.settingAlertOn = "message"
	      }
	    }
	  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_mentioned')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingAlertOn),
	      expression: "settingAlertOn"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "alert_on",
	      "value": "highlight"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.settingAlertOn, "highlight")
	    },
	    on: {
	      "__c": function($event) {
	        _vm.settingAlertOn = "highlight"
	      }
	    }
	  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_never')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingAlertOn),
	      expression: "settingAlertOn"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "alert_on",
	      "value": "never"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.settingAlertOn, "never")
	    },
	    on: {
	      "__c": function($event) {
	        _vm.settingAlertOn = "never"
	      }
	    }
	  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_notify_mute')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingMuteSound),
	      expression: "settingMuteSound"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingMuteSound) ? _vm._i(_vm.settingMuteSound, null) > -1 : (_vm.settingMuteSound)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingMuteSound,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingMuteSound = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingMuteSound = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingMuteSound = $$c
	        }
	      }
	    }
	  })]), _c('br')])])])
	},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-messagelist-message kiwi-messagelist-message--modern",
	    class: [
	      _vm.ml.filteredMessages[_vm.idx - 1] &&
	      _vm.ml.filteredMessages[_vm.idx - 1].nick === _vm.message.nick &&
	      _vm.message.time - _vm.ml.filteredMessages[_vm.idx - 1].time < 60000 &&
	      _vm.ml.filteredMessages[_vm.idx - 1].type !== 'traffic' &&
	      _vm.message.type !== 'traffic' ?
	      'kiwi-messagelist-message-repeat' :
	      '',
	      'kiwi-messagelist-message-' + _vm.message.type,
	      _vm.message.type_extra ?
	      'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
	      '',
	      _vm.ml.isMessageHighlight(_vm.message) ?
	      'kiwi-messagelist-message--highlight' :
	      '',
	      _vm.ml.isHoveringOverMessage(_vm.message) ?
	      'kiwi-messagelist-message--hover' :
	      '',
	      _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
	      'kiwi-messagelist-message--unread' :
	      '',
	      _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
	      'kiwi-messagelist-message--own' :
	      '',
	      _vm.ml.message_info_open === _vm.message ?
	      'kiwi-messagelist-message--info-open' :
	      '',
	      _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
	      'kiwi-messagelist-message--blur' :
	      '' ],
	    attrs: {
	      "data-message": _vm.message
	    },
	    on: {
	      "click": function($event) {
	        _vm.ml.onMessageClick($event, _vm.message)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-messagelist-modern-left"
	  }, [(_vm.isMessage(_vm.message)) ? _c('div', {
	    staticClass: "kiwi-messagelist-modern-avatar",
	    style: ({
	      'background-color': _vm.nickColour(_vm.message.nick)
	    }),
	    attrs: {
	      "data-nick": _vm.message.nick
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.message.nick[0]) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-messagelist-modern-right"
	  }, [_c('div', {
	    staticClass: "kiwi-messagelist-nick",
	    style: (_vm.ml.nickStyle(_vm.message.nick)),
	    attrs: {
	      "data-nick": _vm.message.nick
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.ml.hover_nick = _vm.message.nick.toLowerCase();
	      },
	      "mouseout": function($event) {
	        _vm.ml.hover_nick = '';
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.message.nick))]), _vm._v(" "), (_vm.isMessage(_vm.message) && _vm.ml.bufferSetting('show_timestamps')) ? _c('div', {
	    staticClass: "kiwi-messagelist-time"
	  }, [_vm._v("\n            " + _vm._s(_vm.ml.formatTime(_vm.message.time)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-messagelist-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.ml.formatMessage(_vm.message))
	    }
	  }), _vm._v(" "), (_vm.ml.message_info_open === _vm.message) ? _c('message-info', {
	    attrs: {
	      "message": _vm.message,
	      "buffer": _vm.ml.buffer
	    },
	    on: {
	      "close": function($event) {
	        _vm.ml.toggleMessageInfo()
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-networksettings"
	  }, [_c('form', {
	    staticClass: "u-form"
	  }, [_c('div', {
	    staticClass: "kiwi-networksettings-section kiwi-networksettings-connection"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_server_details')))]), _vm._v(" "), (_vm.network.state_error) ? _c('div', {
	    staticClass: "kiwi-networksettings-error"
	  }, [_vm._v("We couldn't connect to that server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), _c('input-text', {
	    staticClass: "kiwi-networksettings-connection-address",
	    attrs: {
	      "label": _vm.$t('server')
	    },
	    model: {
	      value: (_vm.network.connection.server),
	      callback: function($$v) {
	        _vm.network.connection.server = $$v
	      },
	      expression: "network.connection.server"
	    }
	  }), _vm._v(" "), _c('input-text', {
	    staticClass: "kiwi-networksettings-connection-port",
	    attrs: {
	      "label": _vm.$t('settings_port'),
	      "type": "number"
	    },
	    model: {
	      value: (_vm.network.connection.port),
	      callback: function($$v) {
	        _vm.network.connection.port = $$v
	      },
	      expression: "network.connection.port"
	    }
	  }, [_c('span', {
	    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
	    class: [_vm.network.connection.tls ? 'kiwi-customserver-tls--enabled' : ''],
	    on: {
	      "click": _vm.toggleTls
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
	  }), _vm._v(" "), (!_vm.network.connection.tls) ? _c('i', {
	    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-networksettings-connection-password"
	  }, [(_vm.server_type === 'network') ? [_c('input-text', {
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.network.connection.password),
	      callback: function($$v) {
	        _vm.network.connection.password = $$v
	      },
	      expression: "network.connection.password"
	    }
	  })] : [_c('input-text', {
	    attrs: {
	      "label": _vm.$t('username')
	    },
	    model: {
	      value: (_vm.znc_username),
	      callback: function($$v) {
	        _vm.znc_username = $$v
	      },
	      expression: "znc_username"
	    }
	  }), _vm._v(" "), _c('input-text', {
	    attrs: {
	      "label": _vm.$t('network')
	    },
	    model: {
	      value: (_vm.znc_network),
	      callback: function($$v) {
	        _vm.znc_network = $$v
	      },
	      expression: "znc_network"
	    }
	  }), _vm._v(" "), _c('input-text', {
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.znc_password),
	      callback: function($$v) {
	        _vm.znc_password = $$v
	      },
	      expression: "znc_password"
	    }
	  })]], 2), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-networksettings-server-types"
	  }, [(_vm.server_type === 'znc') ? _c('div', {
	    staticClass: "kiwi-networksettings-server-types-info"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t('settings_znc_other')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    class: {
	      'kiwi-networksettings-server-type-active': _vm.server_type === 'network'
	    },
	    on: {
	      "click": function($event) {
	        _vm.server_type = 'network'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('network')))]), _vm._v(" "), _c('a', {
	    staticClass: "u-link",
	    class: {
	      'kiwi-networksettings-server-type-active': _vm.server_type === 'znc'
	    },
	    on: {
	      "click": function($event) {
	        _vm.server_type = 'znc'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('znc')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-networksettings-section  kiwi-networksettings-user"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_nickname')))]), _vm._v(" "), _c('input-text', {
	    attrs: {
	      "label": _vm.$t('settings_nickname')
	    },
	    model: {
	      value: (_vm.network.nick),
	      callback: function($$v) {
	        _vm.network.nick = $$v
	      },
	      expression: "network.nick"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-networksettings-section kiwi-networksettings-advanced"
	  }, [_c('h3', {
	    on: {
	      "click": function($event) {
	        _vm.show_advanced = !_vm.show_advanced
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('settings_advanced')) + " "), _c('i', {
	    staticClass: "fa",
	    class: ['fa-caret-' + (_vm.show_advanced ? 'up' : 'down')],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), (_vm.show_advanced) ? [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_encoding')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.network.connection.encoding),
	      expression: "network.connection.encoding"
	    }],
	    domProps: {
	      "value": (_vm.network.connection.encoding)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.network.connection.encoding = $event.target.value
	      }
	    }
	  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_raw')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowRaw),
	      expression: "settingShowRaw"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowRaw) ? _vm._i(_vm.settingShowRaw, null) > -1 : (_vm.settingShowRaw)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowRaw,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowRaw = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowRaw = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowRaw = $$c
	        }
	      }
	    }
	  })]), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "u-form-block"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_autorun')))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.network.auto_commands),
	      expression: "network.auto_commands"
	    }],
	    attrs: {
	      "cols": "40",
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.network.auto_commands)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.network.auto_commands = $event.target.value
	      }
	    }
	  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-networksettings-section kiwi-networksettings-danger"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_danger')))]), _vm._v(" "), _c('label', [_c('a', {
	    staticClass: "u-button u-button-warning",
	    on: {
	      "click": _vm.removeNetwork
	    }
	  }, [_vm._v(_vm._s(_vm.$t('settings_remove')))])]), _c('br')])])])
	},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    key: _vm.buffer.name,
	    staticClass: "kiwi-messagelist",
	    on: {
	      "scroll": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.onThreadScroll($event)
	      },
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.onListClick($event)
	      }
	    }
	  }, [(_vm.shouldShowChathistoryTools) ? _c('div', {
	    staticClass: "kiwi-messagelist-scrollback"
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": function($event) {
	        _vm.buffer.requestScrollback()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('messages_load')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredMessages), function(message, idx) {
	    return [(_vm.shouldShowDateChangeMarker(idx)) ? _c('div', {
	      staticClass: "kiwi-messagelist-seperator"
	    }, [_c('span', [_vm._v(_vm._s((new Date(message.time)).toDateString()))])]) : _vm._e(), _vm._v(" "), (_vm.shouldShowUnreadMarker(idx)) ? _c('div', {
	      staticClass: "kiwi-messagelist-seperator"
	    }, [_c('span', [_vm._v(_vm._s(_vm.$t('unread_messages')))])]) : _vm._e(), _vm._v(" "), (_vm.listType === 'modern') ? _c('message-list-message-modern', {
	      key: message.id,
	      attrs: {
	        "message": message,
	        "idx": idx,
	        "ml": _vm.thisMl
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.listType !== 'modern') ? _c('message-list-message-compact', {
	      key: message.id,
	      attrs: {
	        "message": message,
	        "idx": idx,
	        "ml": _vm.thisMl
	      }
	    }) : _vm._e()]
	  }), _vm._v(" "), (_vm.buffer.getNetwork().state !== 'connected') ? _c('not-connected', {
	    attrs: {
	      "buffer": _vm.buffer,
	      "network": _vm.buffer.getNetwork()
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-channelbanlist"
	  }, [_c('form', {
	    staticClass: "u-form kiwi-channelbanlist",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('a', {
	    staticClass: "u-link",
	    on: {
	      "click": _vm.updateBanlist
	    }
	  }, [_vm._v(_vm._s(_vm.$t('bans_refresh')))]), _vm._v(" "), (_vm.banlist.length > 0) ? _c('table', {
	    staticClass: "kiwi-channelbanlist-table"
	  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('bans_user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('bans_by')))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.banlist), function(ban) {
	    return _c('tr', [_c('td', {
	      staticClass: "kiwi-channelbanlist-table-mask"
	    }, [_vm._v(_vm._s(ban.banned))]), _vm._v(" "), _c('td', {
	      staticClass: "kiwi-channelbanlist-table-bannedby"
	    }, [_vm._v(_vm._s(ban.banned_by))]), _vm._v(" "), _c('td', {
	      staticClass: "kiwi-channelbanlist-table-bannedat"
	    }, [_vm._v(_vm._s((new Date(ban.banned_at * 1000)).toDateString()))]), _vm._v(" "), _c('td', {
	      staticClass: "kiwi-channelbanlist-table-actions"
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeBan(ban.banned)
	        }
	      }
	    })])])
	  })], 2) : (_vm.is_refreshing) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$t('bans_refreshing')) + "\n        ")]) : _c('div', {
	    staticClass: "kiwi-channelbanlist-empty"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('bans_nobody')) + "\n        ")])])])
	},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-nicklist"
	  }, [_c('div', {
	    staticClass: "kiwi-nicklist-info"
	  }, [_vm._v(_vm._s(_vm.$t('person', {
	    count: _vm.sortedUsers.length
	  })))]), _vm._v(" "), _c('ul', {
	    staticClass: "kiwi-nicklist-users"
	  }, _vm._l((_vm.sortedUsers), function(user) {
	    return _c('li', {
	      key: user.nick,
	      staticClass: "kiwi-nicklist-user",
	      class: [
	        _vm.userMode(user) ? 'kiwi-nicklist-user--mode-' + _vm.userMode(user) : '',
	        user.away ? 'kiwi-nicklist-user--away' : ''
	      ]
	    }, [_c('span', {
	      staticClass: "kiwi-nicklist-user-prefix"
	    }, [_vm._v(_vm._s(_vm.userModePrefix(user)))]), _c('span', {
	      staticClass: "kiwi-nicklist-user-nick",
	      style: (_vm.nickStyle(user.nick)),
	      on: {
	        "click": function($event) {
	          _vm.openUserbox(user, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(user.nick))])])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-wrap kiwi-wrap-error"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error_starting')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('error_installed')))])])
	},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-welcome-simple",
	    class: [_vm.closing ? 'kiwi-welcome-simple--closing' : '']
	  }, [_c('div', {
	    staticClass: "kiwi-welcome-simple-section kiwi-welcome-simple-section-connection"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.greetingText)
	    }
	  }), _vm._v(" "), (!_vm.network || _vm.network.state === 'disconnected') ? [_c('form', {
	    staticClass: "u-form kiwi-welcome-simple-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.formSubmit($event)
	      }
	    }
	  }, [(_vm.network && _vm.network.state_error) ? _c('div', {
	    staticClass: "kiwi-welcome-simple-error"
	  }, [_vm._v("We couldn't connect to the server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), (_vm.showNick) ? _c('input-text', {
	    staticClass: "kiwi-welcome-simple-nick",
	    attrs: {
	      "label": _vm.$t('nick')
	    },
	    model: {
	      value: (_vm.nick),
	      callback: function($$v) {
	        _vm.nick = $$v
	      },
	      expression: "nick"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPass) ? _c('label', {
	    staticClass: "kiwi-welcome-simple-have-password"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show_password_box),
	      expression: "show_password_box"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.show_password_box,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.show_password_box = $$c
	        }
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
	    staticClass: "kiwi-welcome-simple-password",
	    attrs: {
	      "label": _vm.$t('password'),
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showChannel) ? _c('input-text', {
	    staticClass: "kiwi-welcome-simple-channel",
	    attrs: {
	      "label": _vm.$t('channel')
	    },
	    model: {
	      value: (_vm.channel),
	      callback: function($$v) {
	        _vm.channel = $$v
	      },
	      expression: "channel"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "u-button u-button-primary u-submit kiwi-welcome-simple-start",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.readyToStart
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.buttonText)
	    }
	  })], 1)] : (_vm.network.state !== 'connected') ? [_c('i', {
	    staticClass: "fa fa-spin fa-spinner",
	    staticStyle: {
	      "font-size": "2em",
	      "margin-top": "1em"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-welcome-simple-section kiwi-welcome-simple-section-info",
	    style: (_vm.infoStyle)
	  }, [(_vm.infoContent) ? _c('div', {
	    staticClass: "kiwi-welcome-simple-section-info-content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.infoContent)
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-channellist"
	  }, [_c('div', {
	    staticClass: "kiwi-channellist-nav"
	  }, [_c('a', {
	    staticClass: "u-button kiwi-channellist-refresh",
	    class: {
	      'u-button-primary': _vm.listState === '',
	        'u-button-secondary': _vm.listState === 'updating',
	    },
	    on: {
	      "click": _vm.maybeUpdateList
	    }
	  }, [(_vm.listState === '') ? _c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _c('i', {
	    staticClass: "fa fa-refresh fa-spin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-channellist-pagination"
	  }, [_c('a', {
	    on: {
	      "click": _vm.prevPage
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-step-backward",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" " + _vm._s(_vm.page + 1) + " / " + _vm._s(_vm.maxPages + 1) + " "), _c('a', {
	    on: {
	      "click": _vm.nextPage
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-step-forward",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('form', {
	    staticClass: "u-form kiwi-channellist-search",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "placeholder": _vm.$t('do_search')
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.listState === '') ? _c('table', {
	    key: _vm.last_updated,
	    attrs: {
	      "width": "100%"
	    }
	  }, [_c('tbody', _vm._l((_vm.paginated), function(channel) {
	    return _c('tr', [_c('td', [_c('span', {
	      staticClass: "kiwi-channellist-users"
	    }, [_c('i', {
	      staticClass: "fa fa-user",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(channel.num_users))]), _vm._v(" "), _c('a', {
	      staticClass: "u-link",
	      on: {
	        "click": function($event) {
	          _vm.joinChannel(channel.channel)
	        }
	      }
	    }, [_vm._v(_vm._s(channel.channel))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(channel.topic))])])
	  }))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-appsettings"
	  }, [_c('a', {
	    staticClass: "u-button u-button-secondary kiwi-appsettings-close",
	    on: {
	      "click": _vm.closeSettings
	    }
	  }, [_vm._v(_vm._s(_vm.$t('close')))]), _vm._v(" "), _c('form', {
	    staticClass: "u-form"
	  }, [_c('tabbed-view', [_c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('settings_general'),
	      "focus": true
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-appsettings-section kiwi-appsettings-general"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_general')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_theme')) + ": ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theme),
	      expression: "theme"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.settings.themes), function(t) {
	    return _c('option', {
	      domProps: {
	        "value": t.name
	      }
	    }, [_vm._v(_vm._s(t.name))])
	  })), _vm._v(" "), _c('a', {
	    staticClass: "kiwi-appsettings-theme-reload",
	    attrs: {
	      "title": "Refresh Theme"
	    },
	    on: {
	      "click": _vm.refreshTheme
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), (_vm.theme === 'custom') ? _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_themeurl')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customThemeUrl),
	      expression: "customThemeUrl"
	    }],
	    staticClass: "u-input",
	    domProps: {
	      "value": (_vm.customThemeUrl)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.customThemeUrl = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_autocomplete')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingShowAutoComplete),
	      expression: "settingShowAutoComplete"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingShowAutoComplete) ? _vm._i(_vm.settingShowAutoComplete, null) > -1 : (_vm.settingShowAutoComplete)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingShowAutoComplete,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingShowAutoComplete = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingShowAutoComplete = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingShowAutoComplete = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), (_vm.themeSupportsMonospace) ? _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_use_monospace')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingUseMonospace),
	      expression: "settingUseMonospace"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingUseMonospace) ? _vm._i(_vm.settingUseMonospace, null) > -1 : (_vm.settingUseMonospace)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingUseMonospace,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingUseMonospace = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingUseMonospace = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingUseMonospace = $$c
	        }
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-appsettings-section kiwi-appsettings-messages"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_messages_title')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_layout_compact')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingMessageLayout),
	      expression: "settingMessageLayout"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingMessageLayout) ? _vm._i(_vm.settingMessageLayout, null) > -1 : (_vm.settingMessageLayout)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingMessageLayout,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingMessageLayout = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingMessageLayout = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingMessageLayout = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_timestamps')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferShowTimestamps),
	      expression: "settingBufferShowTimestamps"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferShowTimestamps) ? _vm._i(_vm.settingBufferShowTimestamps, null) > -1 : (_vm.settingBufferShowTimestamps)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferShowTimestamps,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferShowTimestamps = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferShowTimestamps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferShowTimestamps = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_24hour_timestamps')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.timestamps_24h),
	      expression: "timestamps_24h"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.timestamps_24h) ? _vm._i(_vm.timestamps_24h, null) > -1 : (_vm.timestamps_24h)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.timestamps_24h,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.timestamps_24h = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.timestamps_24h = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.timestamps_24h = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_emoticons')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferShowEmoticons),
	      expression: "settingBufferShowEmoticons"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferShowEmoticons) ? _vm._i(_vm.settingBufferShowEmoticons, null) > -1 : (_vm.settingBufferShowEmoticons)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferShowEmoticons,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferShowEmoticons = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferShowEmoticons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferShowEmoticons = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_block_private')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferBlockPms),
	      expression: "settingBufferBlockPms"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferBlockPms) ? _vm._i(_vm.settingBufferBlockPms, null) > -1 : (_vm.settingBufferBlockPms)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferBlockPms,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferBlockPms = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferBlockPms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferBlockPms = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_scrollback')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferScrollbackSize),
	      expression: "settingBufferScrollbackSize"
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.settingBufferScrollbackSize)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.settingBufferScrollbackSize = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_formatting')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferExtraFormatting),
	      expression: "settingBufferExtraFormatting"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferExtraFormatting) ? _vm._i(_vm.settingBufferExtraFormatting, null) > -1 : (_vm.settingBufferExtraFormatting)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferExtraFormatting,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferExtraFormatting = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferExtraFormatting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferExtraFormatting = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_nick_colouring')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferColourNicknames),
	      expression: "settingBufferColourNicknames"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferColourNicknames) ? _vm._i(_vm.settingBufferColourNicknames, null) > -1 : (_vm.settingBufferColourNicknames)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferColourNicknames,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferColourNicknames = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferColourNicknames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferColourNicknames = $$c
	        }
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-appsettings-section kiwi-appsettings-notifications"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('notifications')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_joinpart')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferTrafficAsActivity),
	      expression: "settingBufferTrafficAsActivity"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferTrafficAsActivity) ? _vm._i(_vm.settingBufferTrafficAsActivity, null) > -1 : (_vm.settingBufferTrafficAsActivity)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferTrafficAsActivity,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferTrafficAsActivity = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferTrafficAsActivity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferTrafficAsActivity = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_mute_sound')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingBufferMuteSound),
	      expression: "settingBufferMuteSound"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.settingBufferMuteSound) ? _vm._i(_vm.settingBufferMuteSound, null) > -1 : (_vm.settingBufferMuteSound)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.settingBufferMuteSound,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.settingBufferMuteSound = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.settingBufferMuteSound = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.settingBufferMuteSound = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_highlight')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingHighlights),
	      expression: "settingHighlights"
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.settingHighlights)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.settingHighlights = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "kiwi-appsettings-section kiwi-appsettings-operator-tools"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('operator_tools')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_ban_mask')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingDefaultBanMask),
	      expression: "settingDefaultBanMask"
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.settingDefaultBanMask)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.settingDefaultBanMask = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_kick_reason')) + ": ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settingDefaultKickReason),
	      expression: "settingDefaultKickReason"
	    }],
	    staticClass: "u-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.settingDefaultKickReason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.settingDefaultKickReason = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('settings_aliases')
	    }
	  }, [_c('div', {
	    staticClass: "kiwi-appsettings-section kiwi-appsettings-aliases"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_aliases')))]), _vm._v(" "), _c('settings-aliases')], 1)])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kiwi-serverview"
	  }, [_c('div', {
	    staticClass: "kiwi-serverview-inner"
	  }, [_c('tabbed-view', {
	    key: _vm.network.id
	  }, [_c('tabbed-tab', {
	    attrs: {
	      "header": 'Messages',
	      "focus": _vm.hasMessages
	    }
	  }, [_c('message-list', {
	    attrs: {
	      "buffer": _vm.serverBuffer,
	      "messages": _vm.serverBuffer.getMessages()
	    }
	  })], 1), _vm._v(" "), _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('settings'),
	      "focus": !_vm.hasMessages
	    }
	  }, [_c('network-settings', {
	    attrs: {
	      "network": _vm.network
	    }
	  })], 1), _vm._v(" "), (_vm.network.state === 'connected') ? _c('tabbed-tab', {
	    attrs: {
	      "header": _vm.$t('channels')
	    }
	  }, [_c('channel-list', {
	    attrs: {
	      "network": _vm.network
	    }
	  })], 1) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.70847cbaa5b5fc0d40d9.js